var i18n={
    en:{
        overtime_1:`Error code: `,
        overtime_2:`, plesase retry it`,
        isnetwork:`Internet error. Please check and retry`,
        edit_photo:`Edit Photo`,
        select_photo:`Select Photo`,
        change_photo:`Change Photo`,
        cancel:`Cancel`,
        hide_password:`Hide password`,
        show_password:`Show password`,
        zoom_in:`Zoom in`,
        zoom_out:`Zoom out`,
        rotate:`Rotate`,
        horizontal_flip:`Horizontal flip`,
        vertical_flip:`Vertical flip`,
        Connect:`Connect`,
        unlink_success:`Unlink successfully`,
        connect_success:`Connect successfully`,
        feedback_title:`Thanks for your feedback. Please leave your problem and we will respond to you within 24 hours.`,
        feedback_thank_you:`Thank You!<br />Your Feedback has been submitted successfully.`,
        feedback_email:`Enter your email here!`,
        feedback_content:`Leave any problem or suggestion you encountered here.`,
        feedback_submit:`Submit`,
        form_contents:`You have not entered any description. Please enter it and submit again.`,
        old_password:`Please input old password`,
        new_password:`Please create a new password`,
        old_new_password:`The new password cannot be the same as the old one`,
        incorrect_password:`Incorrect password`,
        delete_no:`Delete Now`,
        Caps:`Caps lock is on`,
        Get:`Get`,
        Done:`Done`,
        error_20001:`Error: 20001. Please log in again.`,
        error_20002:`Error: 20002. Please log in again.`,
        error_20003:`Error: 20003. Please log in again.`,
        error_20004:`Request failed (error code: 20004). Please try it again.`,
        error_20005:`Login session has expired (Error: 20005). Please log in again.`,
        error_20006:`Request failed (error code: 20006). Please try it again.`,
        error_20007:`Login session has expired (Error: 20007). Please log in again.`,
        error_20008:`Login session has expired (Error: 20008). Please log in again.`,
        error_20009:`Login session has expired (Error: 20009). Please log in again.`,
        error_20901:`Request failed (error code: 20901). Please try it again`,
        error_20902:`Request failed (error code: 20902). Please try it again`,
        error_22298:`Request for Google failed (Error: 22298). Please try it again.`,
        error_21601:`Error: 21601. Please contact us`,
        error_21602:`Invalid Verification (Error: 21602). Please try it again.`,
        error_21603:`Error: 21603. Please try it again`,
        error_21604:`Request failed (error code: 21604). Please try it again`,
        error_21606:`Request failed (error code: 21606). Please try it again`,
        error_21611:`Request failed (error code: 21611). Please try it again`,
        error_21613:`Sign up too often, please try again later.`,
        error_21801:`Error: 21801. Please contact us`,
        error_21802:`Request failed (Error: 21802). Please try it again`,
        error_21803:`Error: 21803. Please try it again`,
        error_21804:`Request failed (error code: 21804). Please try it again`,
        error_21806:`Error: 21806. Please try it again`,
        error_21807:`Error: 21807. Please contact us`,
        error_21808:`Error: 21808. Please contact us`,
        error_21809:`Error: 21809. Please contact us`,
        error_21810:`Error: 21810. Please contact us`,
        error_21811:`Error: 21811. Please contact us`,
        error_21812:`Error: 21812. Please contact us`,
        error_21813:`Request failed (error code: 21813). Please try it again`,
        error_21814:`Error: 21814. Please contact us`,
        error_21815:`Request failed (error code: 21815). Please try it again`,
        error_21816:`Error: 21816. Please contact us`,
        error_21817:`Error: 21817. Please contact us`,
        error_21818:`Error: 21818. Please contact us`,
        error_21819:`Request failed (error code: 21819). Please try it again`,
        error_21820:`Error: 21820. Please contact us`,
        error_21821:`Error: 21821. Please contact us`,
        error_21822:`Error: 21822. Please contact us`,
        error_21823:`Request failed (error code: 21823). Please try it again`,
        error_21824:`Request failed (error code: 21824). Please try it again`,
        error_21825:`Request failed (error code: 21825). Please try it again`,
        error_21826:`Request failed (error code: 21826). Please try it again`,
        error_21827:`Request failed (error code: 21827). Please try it again`,
        error_21828:`Deleted Account. Please wait for 3 days or use another email.`,
        error_21829:`Login Failed!`,
        error_26701:`Error code: 26701, please contact us`,
        error_26702:`Reuqest failed (error code: 26702). Please retry it`,
        error_26703:`Error code: 26703, please contact us`,
        error_26704:`Error code: 26704, please contact us`,
        error_26705:`Wait for logging in (error code: 26705). Please retry it`,
        no_code_text:`We've sent a verification code. Please enter your code. <span class='tips'>Didn't receive a code?`,
        no_code_text_1:`1. Please make sure the email address is valid and it can receive emails.`,
        no_code_text_2:`2. For the email is sent by system automatically, it may be flagged as the spam or junk email. Please check whether the email is in the Trash folder.`,
        no_code_text_3:`3. Cannot solve your problem?`,
        no_code_text_3_span:`Then click <a href="https://discord.gg/CB5W97Z9eG" rel="nofollow">here</a> to contact us.`,
        no_code_text_4_span:`<b>Attention:</b> After deleting your account, you will not be able to use the same email to register and login for 3 days.`,
        log_in:`Log In`,
        public_Network_error:`Network error. Please try again later.`,
        public_showToast_Success:`Success`,
        public_showToast_Warning:`Warning`,
        public_showToast_Error:`Error`,
        public_showToast_1:`Payment successful, enjoy the chat!`,
        public_showToast_2:`Confirming your payment, please check back later.`,
        public_showToast_3:`Payment failed, please try again or contact us.`,
        public_showToast_4:`Please Wait`,
        public_showToast_5:`Payment has been successful, please try refreshing the page later to update the plan.`,
        public_showToast_6:`Subscription successfully. Enjoy the chat!`,
        public_showToast_7:`Cancel subscription renewal successful!`,
        public_showToast_8:`Cancellation failed. Please try again later or contact us.`,
        public_showToast_9:`Please check the notice.`,
        pricing_showToast_10:`Failed to go to the payment page, please try again later.`,
        pricing_showToast_11:`Could not find the subscription plan, please try again later.`,
        pricing_showToast_12:`Could not get your country information, please contact us to solve the problem.`,
        pricing_showToast_13:`Sorry, but switching between annual and monthly subscriptions is not available for now.`,
        pricing_showToast_14:`Sorry, we do not support subscription downgrades for now.`,
        pricing_Credit:`Pay with Credit Card`,
    pricing_Wallet:`Pay with E-Wallet`,
        public_Achievement:`\'s Achievement(s)`,
        public_Login_Required:`Login Required`,
        public_In_order:`In order to proceed, please log in to your account.`,
        public_Network_error:`Network error, please try again later.`,
        public_New_Character:`New Character`,
        public_Explore_Now:`Explore Now`,
        public_Check_Now:`Check Now`,
        public_Review:`Review`,
        public_Follow:`Follow`,
        public_Following:`Following`,
        public_Unfollow:`Unfollow`,
        public_notifications:`No notifications.`,
        public_Successfully_Unfollow:`Successfully Unfollow`,
        public_Successfully_Follow:`Successfully Follow`,
        public_Failed_Unlike:`Failed to Unlike the Character`,
        public_Failed_Followed:`Failed to Followed`,
        public_Successfully_Like:`Successfully Like the Character`,
        public_Successfully_Unlike:`Successfully Unlike the Character`,
        public_Failed_Like:`Failed to Like the Character`,
        public_too_fast:`It\'s clicking too fast. Please hold.`,
        public_Log_in_to_get:`Log in to get`,
        public_Login_for_Achievements:`Login for Achievements`,
        public_Subscribe:`Subscribe`,
        pricing_subscription:`Please wait for your subscription to expire and return to the free plan.`,
        pricing_Confirm_Payment_Completion:`Confirm Payment Completion`,
        pricing_complete_the_payment:`Please complete the payment in the new window. And complete the account binding here after successful payment.`,
        pricing_Paid:`Paid`,
        pricing_Payment_Info_not_detected:`Payment Info not detected, please try again later or contact us through Dsicord`,
        pricing_character_finish_loading:`Please wait for the character cards to finish loading.`,
        public_Report:`Report`,
        public_Paid:`Edit Character`,
        public_Failed_Show_Achievements:`Failed to Show the Achievements`,
        public_results_create:`The results you want are not found. Click "create" now to create the one you like.`,
        public_create:`Create`,
        public_Views:`Views`,
        public_Likes:`Likes`,
        public_Comment:`Comment`,
        public_Private:`Private`,
        public_Restricted_Display:`Restricted Display`,
        public_Under_Review:`Under Review`,
        public_Claim:`Claim`,
        public_Resubmit:`Resubmit`,
        public_results_not_found:`The results you want are not found.`,
        public_story_anonymous:`The author of this story is anonymous.`,
        public_no_chat_stories:`No chat stories for now, go create one!`,
        public_Earn:`Earn`,
        public_Submit:`Submit`,
public_Unlock_My_Achievement:`Unlock My Achievement`,
        public_no_characters:`There are no characters available at this time, we recommend the following characters for you:`,
        public_enter_character:`Please enter the name of the character.`,
        public_length_characters_2:`The length of the name must be greater than 2 characters.`,
        public_length_characters_3:`The name must be 3 to 40 characters.`,
        public_length_characters_40:`The length of the name cannot exceed 40 characters.`,
        public_length_characters_205:`The description must be 5 to 200 characters.`,
        public_length_characters_500:`Introduction content is limited to a maximum of 500 characters.`,
        public_no_Introduction:`No Introduction yet.`,
        public_Image_uploading:`Image uploading! Please wait for a second.`,
        public_select_gender:`Please select the gender of the character.`,
        public_length_Introduction_500:`Introduction content is limited to a maximum of 500 characters.`,
        public_length_characters_200:`The comment should must be 1 to 200 characters.`,
        public_length_characters_201:`Description must be 5-200 characters.`,
        public_length_characters_1000:`The maximum number of characters is 1000.`,
        public_length_characters_1001:`The greeting must be 3 to 1000 characters.`,
        public_length_characters_4000:`Personality content must be 0 to 4000 characters.`,
        public_length_characters_1002:`Scenario content must be 0 to 1000 characters.`,
        public_creation_failed:`Character creation failed, please try again.`,
        public_Description_characters:`Description must be 5-500 characters.`,
        public_pornographic_illegal:`Please don\'t use pornographic and illegal words, otherwise the character image generation will be failed!`,
        creator_edit_description:`The generated image contains sensitive content, please edit the description and try again.`,
        creator_Generate_failed:`Generate images failed!`,
        creator_exceed_10M:`The image size cannot exceed 10M`,
        creator_Database_Error:`8001, Database processing failed`,
        creator_Save_failed:`Save failed, please try again.`,
        bonus_Reward_Title:`Reward: Limited Title`,
        bonus_Go_Create:`Go to Create!`,
        bonus_Earn:`Earn`,
        bonus_Finished:`Finished`,
        bonus_Completed:`Completed!`,
        bonus_Complete:`Complete!`,
        bonus_messages:`messages`,
        bonus_image_unlock_props:`image unlock props`,
        bonus_correct_link:`Please enter the correct link!`,
        bonus_Get_your_title:`Get your title!`,
        bonus_New_achievment:`New achievment completed!`,
        bonus_submission_failed:`Sorry, submission failed. Please resubmit.`,
        bonus_Check_in_failed:`Check-in failed. Please try again later.`,
        bonus_Chat_with:`Chat with various AI characters without any filter on HeyReal.ai. Input the invite code`,
        bonus_Chat_with_1:`after you sign up to get tons of free messages.`,
        recommend_Characters:`Characters`,
        recommend_Interactions:`Interactions`,
        recommend_Created_by:`Created by:`,
        chat_story_Successfully:`Successfully `,
        chat_story_Failed:`Failed `,
        chat_story_story:` the Story`,
        chat_story_like:`Like`,
        chat_story_unlike:`Unlike`,
        chat_story_characters:`The comment should not be over 200 characters.`,
        chat_story_Author:`Author:`,
        character_not_info:`The creator didn\'t leave any info here.`,
        character_hidden_details:`The creator has hidden the relevant character details`,
        character_info_public:`The creator did not make this info public.`,
        character_restore:`This character is restricted because of inappropriate images. Edit to restore it.`,
        character_info_1:`This character is restricted because of`,
        character_info_2:`text and inappropriate images. Edit to restore it.`,
        character_info_3:`text. Edit to restore it.`,
        character_info_4:`This character is under review and is currently only visible to yourself. It will be made public once the review is complete.`,
        character_View_all:`View All`,
        character_Chat_Now:`Chat Now`,
        character_restricted:`This character is restricted from display because of violation our content guideline. Please try another character.`,
        character_Share_Story:`Share the First Story before Everyone Else!`,
        character_Start_Chat:`Start Chat`,
        character_Edit:`Edit`,
        character_View_Profile:`View Profile &gt;&gt;`,
        character_Photo_Album:`Photo Album`,
        character_Successfully_Remove:`Successfully Remove from Favorites`,
        character_Failed_Remove:`Failed to Remove from Favorites`,
        character_Successfully_Add:`Successfully Add to Favorites`,
        character_Failed_Add:`Failed to Add to Favorites`,
        character_info_4:`Sever Error!`,
        creator_Sever_Error:`Sever Error!`,
        public_username_is_taken:`This username is taken. Please try another.`,
        public_Sever_failed:`Save changes failed, please try again.`,
        public_image_exceed_5:`The image size cannot exceed 5M`,
        public_Something_wrong:`Something went wrong. Please try again.`,
        public_Some_errors:`Some errors that we are not aware of!`,
        public_select_reason:`Please select the reason for the report before submitting.`,
        public_Successful_report:`Successful report, thank you for your contribution to the community environment!`,
        public_Successful_report1:`Successful report`,
        public_Reported_too_often:`Reported too often, please try again later!`,
        public_Reported_too_often1:`Reported too often`,
        public_Failed_report:`Failed report`,
        public_take:`Take a look!`,
        album_Unlock:`Unlock`,
        album_Chat_unlock:`Chat to unlock`,
        album_error:`Sorry, an unknown error has occurred. Please try again.`,
        album_private:`This character is restricted from display because it is private. Please try another character.`,
        album_loading:`Please wait for the album cards to finish loading.`,
        coins_not_enough:`You don't have enough coins, please get more coins first.`,
        coins_eligible_receive:`The user you're tipping is not eligible to receive tips for now.`,
        coins_sent_successfully:`The tips have been sent successfully!`,
        coins_reached_limit:`Sorry, this creator has reached its limit for tips today, please try again tomorrow!`,
        coins_Unlock:`Unlock`,
 overtime_1:`Error code: `,
        email_placeholder:`Email`,
        email_empty:`Please input email`,
        email_not_valid:`Email is not valid`,
        email_not_valid_1:`Please input your email`,
        email_not_valid_2:`Email is not valid, please use a different address.`,
        email_not_valid_3:`No email input`,
        password_placeholder:`Password`,
        password_empty:`Please input password`,
        password_not_valid:`Incorrect account or password`,
        password_not_valid_1:`Password above 8 characters is required`,
        password_not_valid_2:`Please create a password`,
        password_placeholder_1:`Create your password`,
        password_placeholder_2:`Confirm your Password`,
        password_placeholder_3:`Create new password`,
        password_placeholder_4:`Confirm new password`,
        password_placeholder_5:`Input old password`,
        copy_password_empty:`Please confirm password`,
        copy_password_not_valid:`Please confirm your password`,
        copy_passwords_inconsistent:`Your password confirmation does not match`,
        code_empty:`Please input verification code`,
        code_not_valid:`Invalid verification code`,
        code_placeholder:`Verification Code`,
        not_received_code:`If your mailbox has not received the verification code for a long time, please get the verification code again.`,
        get_first_code:`Please get the verification code first.`,
        connect_your_email_placeholder:`Connect your email`,
        last_name_placeholder:`Please enter your last name`,
        first_name_placeholder:`Please enter your first name`,
        address_placeholder:`Please enter your address`,
        error_24901:`Current account has no email linked, and cannot find the orders. Please connect an email.`,
        user_guide:`User Guide>>`,
        download:`Download`,
        order_number:`Order Number:`,
        Refund:`Refund`,
        Disabled:`Disabled`,
        Normal:`Normal`,
        Modify:`Modify`,
        Modify_1:`Modify>>`,
        error_20101:`Please input your email (error code: 20101)`,
        error_20102:`Email is not valid (error code: 20102)`,
        error_20103:`Request failed (error code: 20103). Please try it again`,
        error_20104:`Email is already in use, please <a href="/account/login/">log in</a> or register with a new one`,
        error_20105:`Request failed (error code: 20105). Please try it again`,
        error_20106:`Failed to send email, please retry it`,
        error_20107:`Deleted Account. Please wait for 3 days or use another email.`,
        error_20201:`Please input your email (error code: 20201)`,
        error_20202:`Please input your password (error code: 20202)`,
        error_20203:`Please input verification code (error code: 20203)`,
        error_20204:`Email is not valid (error code: 20204)`,
        error_20205:`Password above 8 characters is required (error code: 20205)`,
        error_20206:`Request failed (error code: 20206). Please try it again`,
        error_20207:`Invalid verification code`,
        error_20208:`Request failed (error code: 20208). Please try it again`,
        error_20209:`Request failed (error code: 20209). Please try it again`,
        error_20210:`Deleted Account. Please wait for 3 days or use another email.`,
        error_20301:`Please input your email (error code: 20301)`,
        error_20302:`Error: 20302. Please contact us`,
        error_20303:`Email is not valid (error code: 20303)`,
        error_20304:`Request failed (error code: 20304). Please try it again`,
        error_20305:`Account does not exist. Please re-enter or <a href="/account/register/">Create it</a> first.`,
        error_20306:`You haven't set a password yet, please use the <a href="/account/passwordless-login/">passwordless login</a>.`,
        error_20308:`Request failed (error code: 20308). Please try it again`,
        error_20401:`Failed to log out (error code: 20401). Please try it again`,
        error_20501:`Please input your email (error code: 20501)`,
        error_20502:`Email is not valid (error code: 20502)`,
        error_20503:`Request failed (error code: 20503). Please try it again`,
        error_20504:`Failed to send email. Please try it again.`,
        error_20601:`Please input your email (error code: 20601)`,
        error_20602:`Please input verification code (error code: 20602)`,
        error_20603:`Email is not valid (error code: 20603)`,
        error_20604:`Request failed (error code: 20604). Please try it again`,
        error_20606:`Request failed (error code: 20606). Please try it again`,
        error_20607:`Request failed (error code: 20607). Please try it again`,
        error_20608:`Request failed (error code: 20608). Please try it again`,
        error_20701:`Please input your email (error code: 20701)`,
        error_20702:`Email is not valid (error code: 20702)`,
        error_20703:`Request failed (error code: 20703). Please try it again`,
        error_20704:`Account does not exist. Please re-enter or <a href="/account/register/">Create it</a> first.`,
        error_20705:`Request failed (error code: 20705). Please try it again`,
        error_20706:`Failed to send email. Please try it again`,
        error_20801:`Please input your email (error code: 20801)`,
        error_20802:`Error: 20802. Please contact us`,
        error_20803:`Please input verification code (error code: 20803)`,
        error_20804:`Email is not valid (error code: 20804)`,
        error_20805:`Password above 8 characters is required (error code: 20805)`,
        error_20806:`Request failed (error code: 20806). Please try it again`,
        error_20808:`Request failed (error code: 20808). Please try it again`,
        error_21000:`Changes are saved`,
        error_21001:`No information is submitted (error code: 21001)`,
        error_21002:`Request failed (error code: 21002). Please try it again`,
        error_21101:`Please input your email (error code: 21101)`,
        error_21102:`Email is not valid (error code: 21102)`,
        error_21103:`Request failed (error code: 21103), plesase retry it again`,
        error_21104:`Email is already connected, please use a new one`,
        error_21105:`Request failed (error code: 21105), plesase retry it again`,
        error_21106:`Failed to send email. Please try it again`,
        error_21201:`Please input your email (error code: 21201)`,
        error_21202:`Please input verification code (error code: 21202)`,
        error_21203:`Email is not valid (error code: 21203)`,
        error_21204:`Error: 21204. Please contact us`,
        error_21205:`Error: 21205. Please contact us`,
        error_21206:`Password above 8 characters is required (error code: 21206)`,
        error_21207:`Request failed (error code: 21207). Please try it again`,
        error_21209:`Request failed (error code: 21209). Please try it again`,
        error_21301:`Please input old password (error code: 21301)`,
        error_21302:`Please create a new password (error code: 21302)`,
        error_21303:`The new password cannot be the same as the old one. (Error: 21303)`,
        error_21304:`Password above 8 characters is required (error code: 21304)`,
        error_21306:`Request failed (error code: 21306). Please try it again`,
        error_21402:`Request failed (error code: 21402). Please try it again`,
        error_21403:`Failed to send verification code. Please resend it`,
        error_21500:`The account has been deleted`,
        error_21501:`Please input verification code (error code: 21501)`,
        error_21502:`Login session has expired (Error: 21502). Please log in again.`,
        error_21503:`Request failed (error code: 21503). Please try it again`,
        error_21505:`Request failed (error code: 21505), plesase retry it`,
        error_21901:`Error: 21901. Please contact us`,
        error_21902:`Request failed (error code: 21902). Please try it again`,
        error_21903:`The account status has changed (error code: 21903), please refresh the page and try again`,
        error_21904:`Error: 21904. Please try it again`,
        error_21905:`Error: 21905. Please try it again`,
        error_21906:`Request failed (error code: 21906). Please try it again`,
        error_21907:`Google account has been linked to other account`,
        error_21908:`Request failed (error code: 21908). Please try it again`,
        error_22001:`Request failed (error code: 22001). Please try it again`,
        error_22002:`Unlink failed with no additional login`,
        error_22003:`Request failed (error code: 22003). Please try it again`,
        error_22101:`Error: 22101. Please contact us`,
        error_22102:`The account status has changed (error code: 22102), please refresh the page and try again`,
        error_22103:`Request failed (error code: 22103). Please try it again`,
        error_22104:`The account status has changed (error code: 22104), please refresh the page and try again`,
        error_22105:`Error: 22105. Please try it again`,
        error_22106:`Error: 22106. Please try it again`,
        error_22107:`Error: 22107. Please contact us`,
        error_22108:`Request failed (error code: 22108). Please try it again`,
        error_22201:`Error: 22201. Please contact us`,
        error_22202:`Invalid Verification (Error: 22202). Please try it again.`,
        error_22203:`Error: 22203. Please try it again"`,
        error_22204:`Request failed (error code: 22204). Please try it again`,
        error_22206:`Request failed (error code: 22206). Please try it again`,
        error_22401:`Error: 22401. Please contact us`,
        error_22402:`Invalid Verification (Error: 22402). Please try it again.`,
        error_22403:`Error: 22403. Please try it again`,
        error_22404:`Request failed (error code: 22404). Please try it again`,
        error_22405:`Facebook account has been linked to other email`,
        error_22406:`Error: 22406. Please try it again`,
        error_22407:`Error: 22407. Please contact us`,
        error_22408:`Error: 22408. Please contact us`,
        error_22409:`Error: 22409. Please contact us`,
        error_22410:`Error: 224010. Please contact us`,
        error_22411:`Error: 224011. Please contact us`,
        error_22412:`Error: 224012. Please contact us`,
        error_22413:`Error: 22413. Please contact us`,
        error_22414:`Request failed (error code: 22414). Please try it again`,
        error_22415:`Error: 22415. Please contact us`,
        error_22416:`Error: 22416. Please contact us`,
        error_22417:`Error: 22417. Please contact us`,
        error_22418:`Request failed (error code: 22418). Please try it again`,
        error_22419:`Error: 22419. Please contact us`,
        error_22420:`Error: 22420. Please contact us`,
        error_22421:`Error: 22421. Please contact us`,
        error_22422:`Request failed (error code: 22422). Please try it again`,
        error_22423:`Request failed (error code: 22423). Please try it again`,
        error_22424:`Request failed (error code: 22424). Please try it again`,
        error_22425:`Request failed (error code: 22425). Please try it again`,
        error_20098:`Error code: 20098. If you are browsing in Private mode, please switch to Normal mode and try again.`,
        error_22498:`Request for Facebook failed (Error: 22498). Please try it again.`,
        error_24902:`Request failed (error code: 24902). Please try it again`,
        error_24903:`Request failed (error code: 24903). Please try it again`,
        error_24904:`Request failed (error code: 24904). Please try it again`,
        error_24905:`Request failed (error code: 24905). Please try it again`,
        login_title:`Log in to HeyReal`,
        no_account:`No account?`,
        create_it:`Create it`,
        or_log_in_with:`Or log in with`,
        passwordless_login:`Passwordless login`,
        log_in_done:`Log In Done`,
        three_rd_account_connect_info:`Congratulations! You have logged in successfully. Now you can connect one email account that is used to log in in the future.`,
        connect_now:`Connect now`,
        see_my_account:`See my account`,
        three_rd_login_merge_account:`The third-party account email address has been signed up, do you want to connect and log in with this email address directly?`,
        connect_log_in:`Connect & Log In`,
        create_an_account:`Create an account`,
        connect_account:`Connect Account`,
        connect_account_info:`After connecting, you can log in with this account.`,
        back_to_log_in:`Back to log in`,
        create_password:`Create Password`,
        create_now:`Create Now`,
        password_login_subtitle:`Passwordless login with email`,
        account_login:`Account Login`,
        rights:`By creating this account, you agree with to <a href="https://heyreal.ai/terms-and-conditions/">Terms of Service</a> and  <a href="https://heyreal.ai/privacy-policy/">Privacy Policy</a>`,
        passwordless_login_done:`Passwordless login done`,
        passwordless_login_info:`Congratulations, you have completed passwordless login successfully. You can create a password for this account and log in with the account and password in the future. <a href="/account/create-password/" style="display: initial;">Create Now</a>`,
        sign_up:`Sign Up`,
        register_info:`Create your account`,
        reset_now:`Reset Now`,
        forgot_password:`Forgot Password`,
        reset_password_subtitle:`Use your account email to reset password`,
        plan_products:`Plan & Products`,
        nick_name:`Nick name:`,
        email:`Email:`,
        unlink:`Unlink`,
        link:`Link`,
        change_now:`Change Now`,
        connect_email:`Connect email`,
        delete_account:`Delete account`,
        delete_account_info:`When your account is deleted, all the data in Plan & Products associated with your account will be permanently deleted, and you might not be able to recover it. We recommend you tread warily.`,
        Delete:`Delete`,
        Logout:`Logout`,
        to:`to`,
        footer:`Copyright 漏 2024 HeyReal Studio. All rights reserved.`,
        google_login:`Sign in with Google`,
        State:`State`,
        images:`image(s)`,
        email_verification:`Email Verification`,
        email_verification_info:`We have sent the verification message to your email <span class="email"></span>, and please finish the verification. After verifying, the benefits will be in sync automatically.`,
        error_26301:`Error code: 26301, please contact us`,
        error_26302:`Error code: 26302, please contact us`,
        error_26303:`Email format error (error code: 26303). Please enter it again`,
        error_26304:`Password above 8 characters is recommended (error code: 26304)`,
        error_26305:`Reuqest failed (error code: 26305). Please retry it`,
        error_26306:`Email has been registered, please <a href="/account/login/">go to log in</a>`,
        error_26307:`Reuqest failed (error code: 26307). Please retry it`,
        error_26308:`Reuqest failed (error code: 26308). Please retry it`,
        error_26401:`Error code: 26401, please retry it`,
        error_26402:`Email has been verified (error code: 26402), please retry it`,
        error_26403:`Reuqest failed (error code: 26403). Please retry it`,
        error_26404:`Request failed (error code: 26404). Please retry it`,
        error_26501:`Error code: 26501, please contact us`,
        error_26502:`Error code: 26502, please contact us`,
        error_26503:`Email format error (error code: 26503). Please enter it again`,
        error_26504:`Reuqest failed (error code: 26504). Please retry it`,
        error_26505:`Email has not been registered, please <a href="/account/register/">register it first</a>`,
        error_26506:`Email has been verified.`,
        error_26507:`Reuqest failed (error code: 26507). Please retry it`,
        error_26508:`Verification fialed (error code: 26508), please retry it`,
        error_26509:`Request failed (error code: 26509), please retry it`,
        error_26510:`Error code: 26510, please contact us`,
        error_26601:`Error code: 26601, please contact us`,
        error_26602:`Error code: 26602, please contact us`,
        error_26603:`Reuqest failed (error code: 26603). Please retry it`,
        error_26604:`Error code: 26604, please contact us`,
        error_26605:`Error code: 26605, please contact us`,
        no_cookie:`You have turned on the Block all cookies function in your browser, so you cannot log in. Please go to Settings to check the box of Allow all cookies.`,
        error_26801:`Error code: 26801, please contact us`,
        error_26802:`Error code: 26802, please contact us`,
        error_26803:`Request failed (error code: 26803). Please retry it`,
        error_26804:`Request failed (error code: 26804). Please retry it`,
        error_order:`Request failed (error code: 27098), please try it again!`,
        error_order1:`The order query is incomplete (error code: `,
        error_order2:`) , please refresh and try it again.`,
        modify_email_title:`Modify Email`,
        modify_email_info:`You can use the modified email to log into your account.`,
        images_per:`Images per`,
        error_26101:`Error: 26101. Please contact us`,
        error_26102:`Error: 26102. Please contact us`,
        error_26103:`Request failed (error code:26103). Please try it again`,
        error_26104:`Error code: 26104, plesase retry it`,
        error_26105:`Error code: 26105, plesase retry it`,
        error_26106:`Delete failed (error code: 26106). Please try it again`,
        error_26201:`Error: 26201. Please contact us`,
        error_26202:`Request failed (error code:26202). Please try it again`,
        error_26001:`Error: 26001. Please contact us`,
        error_26002:`Error: 26002. Please contact us`,
        error_26003:`Error: 26003. Please contact us`,
        error_26004:`Error: 26004. Please contact us`,
        error_26005:`Request failed (error code:26005). Please try it again`,
        error_26006:`Error code: 26006, plesase retry it`,
        error_26008:`Error: 26008. Please contact us`,
        go_to_the_home_page:`Go to the Home page`,        
    },
    ja:{
        overtime_1:	`エラーコード:`,
        overtime_2:	`、再試行してください`,
        isnetwork:	`インターネットエラー。確認して再試行してください`,
        edit_photo:	`写真を編集する`,
        select_photo:	`写真を選択`,
        change_photo:	`写真を変更する`,
        cancel:	`キャンセル`,
        hide_password:	`パスワードを隠す`,
        show_password:	`パスワードを表示する`,
        zoom_in:	`ズームイン`,
        zoom_out:	`ズームアウト`,
        rotate:	`回転`,
        horizontal_flip:	`水平反転`,
        vertical_flip:	`垂直反転`,
        Connect:	`接続する`,
        unlink_success:	`リンクが正常に解除されました`,
        connect_success:	`正常に接続されました`,
        feedback_title:	`フィードバックをお寄せいただきありがとうございます。問題を残してください。24時間以内に対応いたします。`,
        feedback_thank_you:	`ありがとうございます!<br />フィードバックは正常に送信されました。`,
        feedback_email:	`ここにメールアドレスを入力してください。`,
        feedback_content:	`発生した問題や提案をここに残してください。`,
        feedback_submit:	`提出する`,
        form_contents:	`説明が入力されていません。入力して再度送信してください。`,
        old_password:	`古いパスワードを入力してください`,
        new_password:	`新しいパスワードを作成してください`,
        old_new_password:	`新しいパスワードを古いパスワードと同じにすることはできません`,
        incorrect_password:	`パスワードが間違っています`,
        delete_no:	`今すぐ削除`,
        Caps:	`CapsLockがオンになっている`,
        Get:	`得る`,
        Done:	`終わり`,
        error_20001:	`エラー: 20001。再度ログインしてください。`,
        error_20002:	`エラー: 20002。再度ログインしてください。`,
        error_20003:	`エラー: 20003。再度ログインしてください。`,
        error_20004:	`リクエストが失敗しました (エラー コード: 20004)。もう一度お試しください。`,
        error_20005:	`ログイン セッションの有効期限が切れました (エラー: 20005)。再度ログインしてください。`,
        error_20006:	`リクエストが失敗しました (エラー コード: 20006)。もう一度お試しください。`,
        error_20007:	`ログイン セッションの有効期限が切れました (エラー: 20007)。再度ログインしてください。`,
        error_20008:	`ログイン セッションの有効期限が切れました (エラー: 20008)。再度ログインしてください。`,
        error_20009:	`ログイン セッションの有効期限が切れました (エラー: 20009)。再度ログインしてください。`,
        error_20901:	`リクエストが失敗しました (エラー コード: 20901)。もう一度お試しください`,
        error_20902:	`リクエストが失敗しました (エラー コード: 20902)。もう一度お試しください`,
        error_22298:	`Google へのリクエストが失敗しました (エラー: 22298)。もう一度お試しください。`,
        error_21601:	`エラー: 21601。お問い合わせください。`,
        error_21602:	`無効な検証 (エラー: 21602)。もう一度お試しください。`,
        error_21603:	`エラー: 21603。もう一度お試しください。`,
        error_21604:	`リクエストが失敗しました (エラー コード: 21604)。もう一度お試しください`,
        error_21606:	`リクエストが失敗しました (エラー コード: 21606)。もう一度お試しください`,
        error_21611:	`リクエストが失敗しました (エラー コード: 21611)。もう一度お試しください`,
        error_21613:	`頻繁に登録しすぎます。後でもう一度お試しください。`,
        error_21801:	`エラー: 21801。お問い合わせください。`,
        error_21802:	`リクエストが失敗しました (エラー: 21802)。もう一度お試しください`,
        error_21803:	`エラー: 21803。もう一度お試しください。`,
        error_21804:	`リクエストが失敗しました (エラー コード: 21804)。もう一度お試しください`,
        error_21806:	`エラー: 21806。もう一度お試しください。`,
        error_21807:	`エラー: 21807。お問い合わせください。`,
        error_21808:	`エラー: 21808。お問い合わせください。`,
        error_21809:	`エラー: 21809。お問い合わせください。`,
        error_21810:	`エラー: 21810。お問い合わせください。`,
        error_21811:	`エラー: 21811。お問い合わせください。`,
        error_21812:	`エラー: 21812。お問い合わせください。`,
        error_21813:	`リクエストが失敗しました (エラー コード: 21813)。もう一度お試しください`,
        error_21814:	`エラー: 21814。お問い合わせください。`,
        error_21815:	`リクエストが失敗しました (エラー コード: 21815)。もう一度お試しください`,
        error_21816:	`エラー: 21816。お問い合わせください。`,
        error_21817:	`エラー: 21817。お問い合わせください。`,
        error_21818:	`エラー: 21818。お問い合わせください。`,
        error_21819:	`リクエストが失敗しました (エラー コード: 21819)。もう一度お試しください`,
        error_21820:	`エラー: 21820。お問い合わせください。`,
        error_21821:	`エラー: 21821。お問い合わせください。`,
        error_21822:	`エラー: 21822。お問い合わせください。`,
        error_21823:	`リクエストが失敗しました (エラー コード: 21823)。もう一度お試しください`,
        error_21824:	`リクエストが失敗しました (エラー コード: 21824)。もう一度お試しください`,
        error_21825:	`リクエストが失敗しました (エラー コード: 21825)。もう一度お試しください`,
        error_21826:	`リクエストが失敗しました (エラー コード: 21826)。もう一度お試しください`,
        error_21827:	`リクエストが失敗しました (エラー コード: 21827)。もう一度お試しください`,
        error_21828:	`アカウントが削除されました。 3 日間待つか、別のメールアドレスを使用してください。`,
        error_21829:	`ログインに失敗しました！`,
        error_26701:	`エラーコード: 26701、お問い合わせください`,
        error_26702:	`Reuqest が失敗しました (エラー コード: 26702)。再試行してください`,
        error_26703:	`エラーコード: 26703、お問い合わせください`,
        error_26704:	`エラーコード: 26704、お問い合わせください`,
        error_26705:	`ログインを待ちます (エラー コード: 26705)。再試行してください`,
        no_code_text:	`確認コードを送信しました。コードを入力してください。 <span class='tips'>コードを受信しませんでしたか?`,
        no_code_text_1:	`1. メールアドレスが有効であり、メールを受信できることを確認してください。`,
        no_code_text_2:	`2. 電子メールはシステムによって自動的に送信されるため、スパムまたは迷惑メールとしてフラグが付けられる場合があります。メールがゴミ箱フォルダーにあるかどうかを確認してください。`,
        no_code_text_3:	`3. 問題を解決できませんか?`,
        no_code_text_3_span:	`<a href="https://discord.gg/CB5W97Z9eG" rel="nofollow">ここ</a>をクリックしてご連絡ください。`,
        no_code_text_4_span:	`<b>注意:</b> アカウントを削除すると、3 日間は同じメールアドレスを使用して登録およびログインできなくなります。`,
        log_in:	`ログイン`,
        public_Network_error:	`ネットワークエラー。後でもう一度試してください。`,
        public_showToast_Success:	`成功`,
        public_showToast_Warning:	`警告`,
        public_showToast_Error:	`エラー`,
        public_showToast_1:	`支払いが完了しました。チャットをお楽しみください。`,
        public_showToast_2:	`お支払いを確認しましたので、後ほどもう一度ご確認ください。`,
        public_showToast_3:	`支払いに失敗しました。もう一度お試しいただくか、お問い合わせください。`,
        public_showToast_4:	`お待ちください`,
        public_showToast_5:	`支払いは正常に完了しました。後でページを更新してプランを更新してください。`,
        public_showToast_6:	`購読が正常に完了しました。チャットをお楽しみください!`,
        public_showToast_7:	`サブスクリプション更新のキャンセルが成功しました。`,
        public_showToast_8:	`キャンセルに失敗しました。しばらくしてからもう一度お試しいただくか、お問い合わせください。`,
        public_showToast_9:	`お知らせをご確認ください。`,
        pricing_showToast_10:	`支払いページに移動できませんでした。後でもう一度お試しください。`,
        pricing_showToast_11:	`サブスクリプション プランが見つかりませんでした。後でもう一度お試しください。`,
        pricing_showToast_12:	`あなたの国の情報を取得できませんでした。問題を解決するには、お問い合わせください。`,
        pricing_showToast_13:	`申し訳ございませんが、現時点では年間サブスクリプションと月次サブスクリプションを切り替えることはできません。`,
        pricing_showToast_14:	`申し訳ございませんが、現時点ではサブスクリプションのダウングレードはサポートされていません。`,
        pricing_Credit:	`クレジットカードで支払う`,
        pricing_Wallet:	`Eウォレットで支払う`,
        public_Achievement:	` の業績`,
        public_Login_Required:	`ログインが必要です`,
        public_In_order:	`続行するには、アカウントにログインしてください。`,
        public_Network_error:	`ネットワークエラー。後でもう一度試してください。`,
        public_New_Character:	`新キャラクター`,
        public_Explore_Now:	`今すぐ探索してみよう`,
        public_Check_Now:	`今すぐチェック`,
        public_Review:	`レビュー`,
        public_Follow:	`フォローする`,
        public_Following:	`続く`,
        public_Unfollow:	`フォローを解除する`,
        public_notifications:	`通知はありません。`,
        public_Successfully_Unfollow:	`フォローを解除しました`,
        public_Successfully_Follow:	`フォローに成功しました`,
        public_Failed_Unlike:	`キャラクターとの相違点に失敗しました`,
        public_Failed_Followed:	`フォローに失敗しました`,
        public_Successfully_Like:	`キャラクターを好きになることに成功する`,
        public_Successfully_Unlike:	`キャラクターとの違いに成功`,
        public_Failed_Like:	`キャラクターを好きになれませんでした`,
        public_too_fast:	`クリックが速すぎます。待ってください。`,
        public_Log_in_to_get:	`ログインして入手`,
        public_Login_for_Achievements:	`実績のためにログインする`,
        public_Subscribe:	`購読する`,
        pricing_subscription:	`サブスクリプションの有効期限が切れるまで待って、無料プランに戻ってください。`,
        pricing_Confirm_Payment_Completion:	`支払い完了の確認`,
        pricing_complete_the_payment:	`新しいウィンドウでお支払いを完了してください。支払いが成功したら、ここでアカウントのバインドを完了します。`,
        pricing_Paid:	`有料`,
        pricing_Payment_Info_not_detected:	`支払い情報が検出されませんでした。後でもう一度試すか、Dsicord を通じてお問い合わせください。`,
        pricing_character_finish_loading:	`キャラクターカードの読み込みが完了するまでお待ちください。`,
        public_Report:	`報告`,
        public_Paid:	`キャラクターの編集`,
        public_Failed_Show_Achievements:	`実績の表示に失敗しました`,
        public_results_create:	`必要な結果が見つかりません。今すぐ「作成」をクリックして、お好みのものを作成してください。`,
        public_create:	`作成する`,
        public_Views:	`ビュー`,
        public_Likes:	`いいね！`,
        public_Comment:	`コメント`,
        public_Private:	`プライベート`,
        public_Restricted_Display:	`制限された表示`,
        public_Under_Review:	`検討中`,
                public_Claim:`請求`,
                public_Resubmit:`再提出`,
        public_results_not_found:	`必要な結果が見つかりません。`,
        public_story_anonymous:	`この物語の作者は匿名です。`,
        public_no_chat_stories:	`今のところチャット ストーリーはありません。チャット ストーリーを作成してください。`,
        public_Earn:	`得る`,
        public_Submit:	`提出する`,
        public_Unlock_My_Achievement:`Unlock My Achievement`,
        public_no_characters:	`現時点では利用可能なキャラクターはありません。次のキャラクターをお勧めします。`,
        public_enter_character:	`キャラクターの名前を入力してください。`,
        public_length_characters_2:	`名前の長さは 2 文字以上である必要があります。`,
        public_length_characters_3:	`名前は 3 ～ 40 文字にする必要があります。`,
        public_length_characters_40:	`名前の長さは 40 文字を超えることはできません。`,
        public_length_characters_205:	`説明は 5 ～ 200 文字にする必要があります。`,
        public_length_characters_500:	`紹介内容は最大500文字までとなります。`,
        public_no_Introduction:	`まだ紹介はありません。`,
        public_Image_uploading:	`画像アップロード中！しばらくお待ちください。`,
        public_select_gender:	`キャラクターの性別を選択してください。`,
        public_length_Introduction_500:	`紹介コンテンツは最大 500 文字に制限されています。`,
        public_length_characters_200:	`コメントは 1 ～ 200 文字にする必要があります。`,
        public_length_characters_201:	`説明は 5 ～ 200 文字にする必要があります。`,
        public_length_characters_1000:	`最大文字数は 1000 文字です。`,
        public_length_characters_1001:	`挨拶文は 3 ～ 1000 文字にする必要があります。`,
        public_length_characters_4000:	`パーソナリティの内容は 0 ～ 4000 文字にする必要があります。`,
        public_length_characters_1002:	`シナリオの内容は 0 ～ 1000 文字にする必要があります。`,
        public_creation_failed:	`キャラクターの作成に失敗しました。もう一度お試しください。`,
        public_Description_characters:	`説明は 5 ～ 500 文字にする必要があります。`,
        public_pornographic_illegal:	`ポルノや違法な単語は使用しないでください。使用しないと、キャラクター画像の生成に失敗します。`,
        creator_edit_description:	`生成された画像には機密コンテンツが含まれています。説明を編集して再試行してください。`,
        creator_Generate_failed:	`画像の生成に失敗しました!`,
        creator_exceed_10M:	`画像サイズは 10M を超えることはできません`,
        creator_Database_Error:	`8001, データベース処理に失敗しました`,
        creator_Save_failed:	`保存に失敗しました。もう一度お試しください。`,
        bonus_Reward_Title:	`報酬：限定称号`,
        bonus_Go_Create:	`「作成」に進みましょう！`,
        bonus_Earn:	`得る`,
        bonus_Finished:	`終了した`,
        bonus_Completed:	`完成しました！`,
        bonus_Complete:	`完了！`,
                bonus_messages:`メッセージ`,
                bonus_image_unlock_props:`画像のロック解除小道具`,
        bonus_correct_link:	`正しいリンクを入力してください。`,
        bonus_Get_your_title:	`タイトルを手に入れましょう！`,
        bonus_New_achievment:	`新しい実績が完成しました！`,
        bonus_submission_failed:	`申し訳ありませんが、送信できませんでした。再提出してください。`,
        bonus_Check_in_failed:	`チェックインに失敗しました。後でもう一度試してください。`,
        bonus_Chat_with:`Chat with various AI characters without any filter on HeyReal.ai. Input the invite code`,
        bonus_Chat_with_1:`after you sign up to get tons of free messages.`,
        recommend_Characters:	`キャラクター`,
        recommend_Interactions:	`インタラクション`,
        recommend_Created_by:	`作成者:`,
        chat_story_Successfully:	`成功しました`,
        chat_story_Failed:	`失敗した`,
        chat_story_story:	`物語`,
        chat_story_like:	`のように`,
        chat_story_unlike:	`とは異なり`,
        chat_story_characters:	`コメントは 200 文字を超えてはなりません。`,
        chat_story_Author:	`著者：`,
        character_not_info:	`作成者はここに何も情報を残していません。`,
        character_hidden_details:	`作成者は関連するキャラクターの詳細を非表示にしました`,
        character_info_public:	`作成者はこの情報を公開していません。`,
        character_restore:	`このキャラクターは不適切な画像のため制限されています。編集して復元します。`,
        character_info_1:	`このキャラクターは次の理由で制限されています`,
        character_info_2:	`テキストや不適切な画像。編集して復元します。`,
        character_info_3:	`文章。編集して復元します。`,
        character_info_4:	`このキャラクターは審査中であり、現在は自分にのみ表示されます。審査が完了次第、公開させていただきます。`,
        character_View_all:	`すべて見る`,
        character_Chat_Now:	`今すぐチャット`,
        character_restricted:	`この文字はコンテンツガイドラインに違反しているため、表示が制限されています。別の文字を試してください。`,
        character_Share_Story:	`他の人より先に最初のストーリーを共有しましょう!`,
        character_Start_Chat:	`チャットを開始する`,
        character_Edit:	`編集`,
        character_View_Profile:	`プロフィールを見る &gt;&gt;`,
        character_Photo_Album:	`フォトアルバム`,
        character_Successfully_Remove:	`お気に入りから正常に削除されました`,
        character_Failed_Remove:	`お気に入りから削除できませんでした`,
        character_Successfully_Add:	`お気に入りに正常に追加されました`,
        character_Failed_Add:	`お気に入りに追加できませんでした`,
        character_info_4:	`サーバーエラー!`,
        creator_Sever_Error:	`サーバーエラー!`,
        public_username_is_taken:	`このユーザー名は使用されています。別のものをお試しください。`,
        public_Sever_failed:	`変更の保存に失敗しました。もう一度お試しください。`,
        public_image_exceed_5:	`画像サイズは5Mを超えることはできません`,
        public_Something_wrong:	`何か問題が発生しました。もう一度試してください。`,
        public_Some_errors:	`私たちが気づいていないいくつかのエラーがあります。`,
        public_select_reason:	`送信する前にレポートの理由を選択してください。`,
        public_Successful_report:	`成功のご報告、コミュニティ環境への貢献に感謝します!`,
        public_Successful_report1:	`成功報告`,
        public_Reported_too_often:	`報告が多すぎます。後でもう一度試してください。`,
        public_Reported_too_often1:	`報告が多すぎる`,
        public_Failed_report:	`失敗したレポート`,
        public_take:`見てください！`,
        album_Unlock:	`ロックを解除する`,
        album_Chat_unlock:	`チャットしてロックを解除する`,
        album_error:	`申し訳ありませんが、不明なエラーが発生しました。もう一度試してください。`,
        album_private:	`この文字は非公開文字であるため表示が制限されています。別の文字を試してください。`,
        album_loading:	`アルバム カードの読み込みが完了するまでお待ちください。`,
        coins_not_enough:	`コインが足りません。先にコインを増やしてください。`,
        coins_eligible_receive:	`あなたがチップを送っているユーザーは、現時点ではチップを受け取る資格がありません。`,
        coins_sent_successfully:	`ヒントは正常に送信されました。`,
        coins_reached_limit:	`申し訳ありませんが、このクリエイターは今日チップの上限に達しました。明日もう一度お試しください。`,
        coins_Unlock:	`ロックを解除する`,
        聽overtime_1:	`エラーコード:`,
        email_placeholder:	`電子メール`,
        email_empty:	`メールアドレスを入力してください`,
        email_not_valid:	`電子メールが無効です`,
        email_not_valid_1:	`メールアドレスを入力してください`,
        email_not_valid_2:	`電子メールが無効です。別のアドレスを使用してください。`,
        email_not_valid_3:	`メールアドレスの入力がありません`,
        password_placeholder:	`パスワード`,
        password_empty:	`パスワードを入力してください`,
        password_not_valid:	`アカウントまたはパスワードが間違っています`,
        password_not_valid_1:	`8文字以上のパスワードが必要です`,
        password_not_valid_2:	`パスワードを作成してください`,
        password_placeholder_1:	`パスワードを作成する`,
        password_placeholder_2:	`パスワードを確認してください`,
        password_placeholder_3:	`新しいパスワードを作成する`,
        password_placeholder_4:	`新しいパスワードを確認します`,
        password_placeholder_5:	`古いパスワードを入力してください`,
        copy_password_empty:	`パスワードを確認してください`,
        copy_password_not_valid:	`パスワードを確認してください`,
        copy_passwords_inconsistent:	`パスワードの確認が一致しません`,
        code_empty:	`確認コードを入力してください`,
        code_not_valid:	`無効な確認コード`,
        code_placeholder:	`検証コード`,
        not_received_code:	`メールボックスに認証コードが長期間届かない場合は、再度認証コードを取得してください。`,
        get_first_code:	`まずは認証コードを取得してください。`,
        connect_your_email_placeholder:	`メールを接続する`,
        last_name_placeholder:	`姓を入力してください`,
        first_name_placeholder:	`あなたの名を入力してください`,
        address_placeholder:	`住所を入力してください`,
        error_24901:	`現在のアカウントには電子メールがリンクされていないため、注文が見つかりません。メールを接続してください。`,
        user_guide:	`ユーザーガイド>>`,
        download:	`ダウンロード`,
        order_number:	`注文番号：`,
        Refund:	`返金`,
        Disabled:	`無効`,
        Normal:	`普通`,
        Modify:	`修正する`,
        Modify_1:	`変更>>`,
        error_20101:	`メールアドレスを入力してください (エラーコード: 20101)`,
        error_20102:	`電子メールが無効です (エラー コード: 20102)`,
        error_20103:	`リクエストが失敗しました (エラー コード: 20103)。もう一度お試しください`,
        error_20104:	`メールはすでに使用されています。<a href="/ja/account/login/">ログイン</a>するか、新しいメールで登録してください。`,
        error_20105:	`リクエストが失敗しました (エラー コード: 20105)。もう一度お試しください`,
        error_20106:	`メールの送信に失敗しました。再試行してください`,
        error_20107:	`アカウントが削除されました。 3 日間待つか、別のメールアドレスを使用してください。`,
        error_20201:	`メールアドレスを入力してください (エラーコード: 20201)`,
        error_20202:	`パスワードを入力してください（エラーコード：20202）`,
        error_20203:	`確認コードを入力してください（エラーコード：20203）`,
        error_20204:	`電子メールが無効です (エラー コード: 20204)`,
        error_20205:	`8文字以上のパスワードが必要です（エラーコード：20205）`,
        error_20206:	`リクエストが失敗しました (エラー コード: 20206)。もう一度お試しください`,
        error_20207:	`無効な確認コード`,
        error_20208:	`リクエストが失敗しました (エラー コード: 20208)。もう一度お試しください`,
        error_20209:	`リクエストが失敗しました (エラー コード: 20209)。もう一度お試しください`,
        error_20210:	`アカウントが削除されました。 3 日間待つか、別のメールアドレスを使用してください。`,
        error_20301:	`メールアドレスを入力してください (エラーコード: 20301)`,
        error_20302:	`エラー: 20302。お問い合わせください。`,
        error_20303:	`電子メールが無効です (エラー コード: 20303)`,
        error_20304:	`リクエストが失敗しました (エラー コード: 20304)。もう一度お試しください`,
        error_20305:	`アカウントが存在しません。再入力するか、最初に<a href="/ja/account/register/">作成</a>してください。`,
        error_20306:	`まだパスワードを設定していません。<a href="/ja/account/passwordless-login/">パスワードなしのログイン</a>を使用してください。`,
        error_20308:	`リクエストが失敗しました (エラー コード: 20308)。もう一度お試しください`,
        error_20401:	`ログアウトに失敗しました（エラーコード：20401）。もう一度お試しください`,
        error_20501:	`メールアドレスを入力してください (エラーコード: 20501)`,
        error_20502:	`電子メールが無効です (エラー コード: 20502)`,
        error_20503:	`リクエストが失敗しました (エラー コード: 20503)。もう一度お試しください`,
        error_20504:	`メールの送信に失敗しました。もう一度お試しください。`,
        error_20601:	`メールアドレスを入力してください (エラーコード: 20601)`,
        error_20602:	`確認コードを入力してください（エラーコード：20602）`,
        error_20603:	`電子メールが無効です (エラー コード: 20603)`,
        error_20604:	`リクエストが失敗しました (エラー コード: 20604)。もう一度お試しください`,
        error_20606:	`リクエストが失敗しました (エラー コード: 20606)。もう一度お試しください`,
        error_20607:	`リクエストが失敗しました (エラー コード: 20607)。もう一度お試しください`,
        error_20608:	`リクエストが失敗しました (エラー コード: 20608)。もう一度お試しください`,
        error_20701:	`メールアドレスを入力してください (エラーコード: 20701)`,
        error_20702:	`電子メールが無効です (エラー コード: 20702)`,
        error_20703:	`リクエストが失敗しました (エラー コード: 20703)。もう一度お試しください`,
        error_20704:	`アカウントが存在しません。再入力するか、最初に<a href="/ja/account/register/">作成</a>してください。`,
        error_20705:	`リクエストが失敗しました (エラー コード: 20705)。もう一度お試しください`,
        error_20706:	`メールの送信に失敗しました。もう一度お試しください`,
        error_20801:	`メールアドレスを入力してください (エラーコード: 20801)`,
        error_20802:	`エラー: 20802。お問い合わせください。`,
        error_20803:	`確認コードを入力してください（エラーコード：20803）`,
        error_20804:	`電子メールが無効です (エラー コード: 20804)`,
        error_20805:	`8文字以上のパスワードが必要です（エラーコード：20805）`,
        error_20806:	`リクエストが失敗しました (エラー コード: 20806)。もう一度お試しください`,
        error_20808:	`リクエストが失敗しました (エラー コード: 20808)。もう一度お試しください`,
        error_21000:	`変更は保存されます`,
        error_21001:	`情報が送信されていません (エラー コード: 21001)`,
        error_21002:	`リクエストが失敗しました (エラー コード: 21002)。もう一度お試しください`,
        error_21101:	`メールアドレスを入力してください (エラーコード: 21101)`,
        error_21102:	`電子メールが無効です (エラー コード: 21102)`,
        error_21103:	`リクエストが失敗しました (エラー コード: 21103)。もう一度やり直してください。`,
        error_21104:	`メールはすでに接続されています。新しいメールを使用してください`,
        error_21105:	`リクエストが失敗しました (エラー コード: 21105)。もう一度やり直してください。`,
        error_21106:	`メールの送信に失敗しました。もう一度お試しください`,
        error_21201:	`メールアドレスを入力してください (エラーコード: 21201)`,
        error_21202:	`確認コードを入力してください（エラーコード：21202）`,
        error_21203:	`電子メールが無効です (エラー コード: 21203)`,
        error_21204:	`エラー: 21204。お問い合わせください。`,
        error_21205:	`エラー: 21205。お問い合わせください。`,
        error_21206:	`8文字以上のパスワードが必要です（エラーコード：21206）`,
        error_21207:	`リクエストが失敗しました (エラー コード: 21207)。もう一度お試しください`,
        error_21209:	`リクエストが失敗しました (エラー コード: 21209)。もう一度お試しください`,
        error_21301:	`古いパスワードを入力してください (エラーコード: 21301)`,
        error_21302:	`新しいパスワードを作成してください (エラーコード: 21302)`,
        error_21303:	`新しいパスワードを古いパスワードと同じにすることはできません。 (エラー: 21303)`,
        error_21304:	`8文字以上のパスワードが必要です（エラーコード：21304）`,
        error_21306:	`リクエストが失敗しました (エラー コード: 21306)。もう一度お試しください`,
        error_21402:	`リクエストが失敗しました (エラー コード: 21402)。もう一度お試しください`,
        error_21403:	`確認コードの送信に失敗しました。再送信してください`,
        error_21500:	`アカウントが削除されました`,
        error_21501:	`確認コードを入力してください（エラーコード：21501）`,
        error_21502:	`ログイン セッションの有効期限が切れました (エラー: 21502)。再度ログインしてください。`,
        error_21503:	`リクエストが失敗しました (エラー コード: 21503)。もう一度お試しください`,
        error_21505:	`リクエストが失敗しました (エラー コード: 21505)。再試行してください。`,
        error_21901:	`エラー: 21901。お問い合わせください。`,
        error_21902:	`リクエストが失敗しました (エラー コード: 21902)。もう一度お試しください`,
        error_21903:	`アカウントのステータスが変更されました (エラー コード: 21903)。ページを更新してもう一度お試しください。`,
        error_21904:	`エラー: 21904。もう一度お試しください。`,
        error_21905:	`エラー: 21905。もう一度お試しください。`,
        error_21906:	`リクエストが失敗しました (エラー コード: 21906)。もう一度お試しください`,
        error_21907:	`Google アカウントが他のアカウントにリンクされています`,
        error_21908:	`リクエストが失敗しました (エラー コード: 21908)。もう一度お試しください`,
        error_22001:	`リクエストが失敗しました (エラー コード: 22001)。もう一度お試しください`,
        error_22002:	`追加ログインせずにリンク解除に失敗しました`,
        error_22003:	`リクエストが失敗しました (エラー コード: 22003)。もう一度お試しください`,
        error_22101:	`エラー: 22101。お問い合わせください。`,
        error_22102:	`アカウントのステータスが変更されました (エラー コード: 22102)。ページを更新して再試行してください。`,
        error_22103:	`リクエストが失敗しました (エラー コード: 22103)。もう一度お試しください`,
        error_22104:	`アカウントのステータスが変更されました (エラー コード: 22104)。ページを更新して再試行してください。`,
        error_22105:	`エラー: 22105。もう一度お試しください。`,
        error_22106:	`エラー: 22106。もう一度お試しください。`,
        error_22107:	`エラー: 22107。お問い合わせください。`,
        error_22108:	`リクエストが失敗しました (エラー コード: 22108)。もう一度お試しください`,
        error_22201:	`エラー: 22201。お問い合わせください。`,
        error_22202:	`無効な検証 (エラー: 22202)。もう一度お試しください。`,
        error_22203:	`エラー: 22203。もう一度お試しください。」`,
        error_22204:	`リクエストが失敗しました (エラー コード: 22204)。もう一度お試しください`,
        error_22206:	`リクエストが失敗しました (エラー コード: 22206)。もう一度お試しください`,
        error_22401:	`エラー: 22401。お問い合わせください。`,
        error_22402:	`無効な検証 (エラー: 22402)。もう一度お試しください。`,
        error_22403:	`エラー: 22403。もう一度お試しください。`,
        error_22404:	`リクエストが失敗しました (エラー コード: 22404)。もう一度お試しください`,
        error_22405:	`Facebook アカウントが他のメールアドレスにリンクされています`,
        error_22406:	`エラー: 22406。もう一度お試しください。`,
        error_22407:	`エラー: 22407。お問い合わせください。`,
        error_22408:	`エラー: 22408。お問い合わせください。`,
        error_22409:	`エラー: 22409。お問い合わせください。`,
        error_22410:	`エラー: 224010。お問い合わせください。`,
        error_22411:	`エラー: 224011。お問い合わせください。`,
        error_22412:	`エラー: 224012。お問い合わせください。`,
        error_22413:	`エラー: 22413。お問い合わせください。`,
        error_22414:	`リクエストが失敗しました (エラー コード: 22414)。もう一度お試しください`,
        error_22415:	`エラー: 22415。お問い合わせください。`,
        error_22416:	`エラー: 22416。お問い合わせください。`,
        error_22417:	`エラー: 22417。お問い合わせください。`,
        error_22418:	`リクエストが失敗しました (エラー コード: 22418)。もう一度お試しください`,
        error_22419:	`エラー: 22419。お問い合わせください。`,
        error_22420:	`エラー: 22420。お問い合わせください。`,
        error_22421:	`エラー: 22421。お問い合わせください。`,
        error_22422:	`リクエストが失敗しました (エラー コード: 22422)。もう一度お試しください`,
        error_22423:	`リクエストが失敗しました (エラー コード: 22423)。もう一度お試しください`,
        error_22424:	`リクエストが失敗しました (エラー コード: 22424)。もう一度お試しください`,
        error_22425:	`リクエストが失敗しました (エラー コード: 22425)。もう一度お試しください`,
        error_20098:	`エラー コード: 20098。プライベート モードで閲覧している場合は、通常モードに切り替えてもう一度お試しください。`,
        error_22498:	`Facebook のリクエストが失敗しました (エラー: 22498)。もう一度お試しください。`,
        error_24902:	`リクエストが失敗しました (エラー コード: 24902)。もう一度お試しください`,
        error_24903:	`リクエストが失敗しました (エラー コード: 24903)。もう一度お試しください`,
        error_24904:	`リクエストが失敗しました (エラー コード: 24904)。もう一度お試しください`,
        error_24905:	`リクエストが失敗しました (エラー コード: 24905)。もう一度お試しください`,
        login_title:	`HeyReal にログインする`,
        no_account:	`アカウントがありませんか?`,
        create_it:	`作成してください`,
        or_log_in_with:	`または次の方法でログインします`,
        passwordless_login:	`パスワードなしのログイン`,
        log_in_done:	`ログイン完了`,
        three_rd_account_connect_info:	`おめでとう！ログインに成功しました。これで、今後のログインに使用する 1 つの電子メール アカウントに接続できるようになります。`,
        connect_now:	`今すぐ接続してください`,
        see_my_account:	`私のアカウントを見てください`,
        three_rd_login_merge_account:	`サードパーティ アカウントの電子メール アドレスがサインアップされました。この電子メール アドレスで直接接続してログインしますか?`,
        connect_log_in:	`接続してログイン`,
        create_an_account:	`アカウントを作成する`,
        connect_account:	`アカウントを接続する`,
        connect_account_info:	`接続後、このアカウントでログインできるようになります。`,
        back_to_log_in:	`ログインに戻る`,
        create_password:	`パスワードの作成`,
        create_now:	`今すぐ作成`,
        password_login_subtitle:	`メールによるパスワードレスログイン`,
        account_login:	`アカウントログイン`,
        rights:	`このアカウントを作成すると、<a href="https://heyreal.ai/ja/terms-and-conditions/">利用規約</a>と<a href="https://heyreal.ai/ja/privacy-policy/">プライバシー ポリシー</a>に同意したことになります。`,
        passwordless_login_done:	`パスワードレスログインが完了しました`,
        passwordless_login_info:	`おめでとうございます。パスワードなしのログインが正常に完了しました。このアカウントのパスワードを作成し、今後はそのアカウントとパスワードを使用してログインできます。<a href="/ja/account/create-password/" style="display: initial;">今すぐ作成</a>`,
        sign_up:	`サインアップ`,
        register_info:	`アカウントを作成する`,
        reset_now:	`今すぐリセット`,
        forgot_password:	`パスワードをお忘れですか`,
        reset_password_subtitle:	`アカウントのメールアドレスを使用してパスワードをリセットする`,
        plan_products:	`企画・商品`,
        nick_name:	`ニックネーム：`,
        email:	`電子メール:`,
        unlink:	`リンクを解除する`,
        link:	`リンク`,
        change_now:	`今すぐ変更してください`,
        connect_email:	`電子メールを接続する`,
        delete_account:	`アカウントを削除する`,
        delete_account_info:	`アカウントが削除されると、アカウントに関連付けられているプラ​​ンと製品のすべてのデータが完全に削除され、復元できなくなる可能性があります。慎重に行動することをお勧めします。`,
        Delete:	`消去`,
        Logout:	`ログアウト`,
        to:	`に`,
        footer:	`Copyright 流出 2024 HeyReal Studio.無断転載を禁じます。`,
        google_login:	`Googleでサインイン`,
        State:	`州`,
        images:	`画像`,
        email_verification:	`メール認証`,
        email_verification_info:	`確認メッセージをあなたの電子メール <span class="email"></span> に送信しました。確認を完了してください。確認後、特典は自動的に同期されます。`,
        error_26301:	`エラーコード: 26301、お問い合わせください`,
        error_26302:	`エラーコード: 26302、お問い合わせください`,
        error_26303:	`電子メール形式エラー (エラー コード: 26303)。もう一度入力してください`,
        error_26304:	`パスワードは8文字以上を推奨します（エラーコード：26304）`,
        error_26305:	`Reuqest が失敗しました (エラー コード: 26305)。再試行してください`,
        error_26306:	`メールアドレスが登録されました。<a href="/ja/account/login/">ログインしてください</a>`,
        error_26307:	`Reuqest が失敗しました (エラー コード: 26307)。再試行してください`,
        error_26308:	`Reuqest が失敗しました (エラー コード: 26308)。再試行してください`,
        error_26401:	`エラーコード: 26401、再試行してください`,
        error_26402:	`メールが確認されました (エラー コード: 26402)。もう一度お試しください。`,
        error_26403:	`Reuqest が失敗しました (エラー コード: 26403)。再試行してください`,
        error_26404:	`リクエストが失敗しました (エラー コード: 26404)。再試行してください`,
        error_26501:	`エラーコード: 26501、お問い合わせください`,
        error_26502:	`エラーコード: 26502、お問い合わせください`,
        error_26503:	`電子メール形式エラー (エラー コード: 26503)。もう一度入力してください`,
        error_26504:	`Reuqest が失敗しました (エラー コード: 26504)。再試行してください`,
        error_26505:	`メールが登録されていません。<a href="/ja/account/register/">まず登録してください</a>`,
        error_26506:	`メールアドレスが確認されました。`,
        error_26507:	`Reuqest が失敗しました (エラー コード: 26507)。再試行してください`,
        error_26508:	`検証が完了しました (エラー コード: 26508)。再試行してください。`,
        error_26509:	`リクエストが失敗しました (エラー コード: 26509)。再試行してください。`,
        error_26510:	`エラーコード: 26510、お問い合わせください`,
        error_26601:	`エラーコード: 26601、お問い合わせください`,
        error_26602:	`エラーコード: 26602、お問い合わせください`,
        error_26603:	`Reuqest が失敗しました (エラー コード: 26603)。再試行してください`,
        error_26604:	`エラーコード: 26604、お問い合わせください`,
        error_26605:	`エラーコード: 26605、お問い合わせください`,
        no_cookie:	`ブラウザで [すべての Cookie をブロック] 機能がオンになっているため、ログインできません。[設定] に移動して、[すべての Cookie を許可する] チェックボックスをオンにしてください。`,
        error_26801:	`エラーコード: 26801、お問い合わせください`,
        error_26802:	`エラーコード: 26802、お問い合わせください`,
        error_26803:	`リクエストが失敗しました (エラー コード: 26803)。再試行してください`,
        error_26804:	`リクエストが失敗しました (エラー コード: 26804)。再試行してください`,
        error_order:	`リクエストが失敗しました (エラー コード: 27098)。もう一度お試しください。`,
        error_order1:	`注文クエリが不完全です (エラー コード:`,
        error_order2:	`)、更新してもう一度お試しください。`,
        modify_email_title:	`電子メールの変更`,
        modify_email_info:	`変更した電子メールを使用してアカウントにログインできます。`,
        images_per:	`あたりの画像`,
        error_26101:	`エラー: 26101。お問い合わせください。`,
        error_26102:	`エラー: 26102。お問い合わせください。`,
        error_26103:	`リクエストが失敗しました (エラー コード:26103)。もう一度お試しください`,
        error_26104:	`エラーコード: 26104、再試行してください`,
        error_26105:	`エラーコード: 26105、再試行してください`,
        error_26106:	`削除に失敗しました (エラー コード: 26106)。もう一度お試しください`,
        error_26201:	`エラー: 26201。お問い合わせください。`,
        error_26202:	`リクエストが失敗しました (エラー コード:26202)。もう一度お試しください`,
        error_26001:	`エラー: 26001。お問い合わせください。`,
        error_26002:	`エラー: 26002。お問い合わせください。`,
        error_26003:	`エラー: 26003。お問い合わせください。`,
        error_26004:	`エラー: 26004。お問い合わせください。`,
        error_26005:	`リクエストが失敗しました (エラー コード:26005)。もう一度お試しください`,
        error_26006:	`エラーコード: 26006、再試行してください`,
        error_26008:	`エラー: 26008。お問い合わせください。`,
        go_to_the_home_page:	`ホームページに移動します`,
    },
    ko:{
        overtime_1:	`오류 코드:`,
        overtime_2:	`, 다시 시도해 주세요`,
        isnetwork:	`인터넷 오류입니다. 확인하고 다시 시도해 주세요.`,
        edit_photo:	`사진 편집`,
        select_photo:	`사진 선택`,
        change_photo:	`사진 변경`,
        cancel:	`취소`,
        hide_password:	`비밀번호 숨기기`,
        show_password:	`비밀번호 표시`,
        zoom_in:	`확대`,
        zoom_out:	`축소`,
        rotate:	`회전`,
        horizontal_flip:	`수평 뒤집기`,
        vertical_flip:	`수직 뒤집기`,
        Connect:	`연결하다`,
        unlink_success:	`연결이 해제되었습니다.`,
        connect_success:	`성공적으로 연결되었습니다`,
        feedback_title:	`피드백을 보내주셔서 감사합니다. 문제를 남겨주시면 24시간 이내에 답변해드리겠습니다.`,
        feedback_thank_you:	`감사합니다!<br />귀하의 의견이 성공적으로 제출되었습니다.`,
        feedback_email:	`여기에 이메일을 입력하세요!`,
        feedback_content:	`발생한 문제나 제안 사항을 여기에 남겨주세요.`,
        feedback_submit:	`제출하다`,
        form_contents:	`설명을 입력하지 않았습니다. 입력하신 후 다시 제출해 주세요.`,
        old_password:	`이전 비밀번호를 입력해주세요`,
        new_password:	`새로운 비밀번호를 만들어주세요`,
        old_new_password:	`새 비밀번호는 이전 비밀번호와 같을 수 없습니다.`,
        incorrect_password:	`잘못된 비밀번호`,
        delete_no:	`지금 삭제`,
        Caps:	`Caps Lock이 켜져 있습니다.`,
        Get:	`얻다`,
        Done:	`완료`,
        error_20001:	`오류: 20001. 다시 로그인하십시오.`,
        error_20002:	`오류: 20002. 다시 로그인하십시오.`,
        error_20003:	`오류: 20003. 다시 로그인하십시오.`,
        error_20004:	`요청이 실패했습니다(오류 코드: 20004). 다시 시도해 주세요.`,
        error_20005:	`로그인 세션이 만료되었습니다(오류: 20005). 다시 로그인해주세요.`,
        error_20006:	`요청이 실패했습니다(오류 코드: 20006). 다시 시도해 주세요.`,
        error_20007:	`로그인 세션이 만료되었습니다(오류: 20007). 다시 로그인해주세요.`,
        error_20008:	`로그인 세션이 만료되었습니다(오류: 20008). 다시 로그인해주세요.`,
        error_20009:	`로그인 세션이 만료되었습니다(오류: 20009). 다시 로그인해주세요.`,
        error_20901:	`요청이 실패했습니다(오류 코드: 20901). 다시 시도해 주세요`,
        error_20902:	`요청이 실패했습니다(오류 코드: 20902). 다시 시도해 주세요`,
        error_22298:	`Google 요청이 실패했습니다(오류: 22298). 다시 시도해 주세요.`,
        error_21601:	`오류: 21601. 문의해 주세요.`,
        error_21602:	`잘못된 검증(오류: 21602). 다시 시도해 주세요.`,
        error_21603:	`오류: 21603. 다시 시도해 주세요.`,
        error_21604:	`요청이 실패했습니다(오류 코드: 21604). 다시 시도해 주세요`,
        error_21606:	`요청이 실패했습니다(오류 코드: 21606). 다시 시도해 주세요`,
        error_21611:	`요청이 실패했습니다(오류 코드: 21611). 다시 시도해 주세요`,
        error_21613:	`너무 자주 가입하세요. 나중에 다시 시도해 주세요.`,
        error_21801:	`오류: 21801. 문의해 주세요.`,
        error_21802:	`요청이 실패했습니다(오류: 21802). 다시 시도해 주세요`,
        error_21803:	`오류: 21803. 다시 시도해 주세요.`,
        error_21804:	`요청이 실패했습니다(오류 코드: 21804). 다시 시도해 주세요`,
        error_21806:	`오류: 21806. 다시 시도해 주세요.`,
        error_21807:	`오류: 21807. 문의해 주세요.`,
        error_21808:	`오류: 21808. 문의해 주세요.`,
        error_21809:	`오류: 21809. 문의해 주세요.`,
        error_21810:	`오류: 21810. 문의해 주세요.`,
        error_21811:	`오류: 21811. 문의해 주세요.`,
        error_21812:	`오류: 21812. 문의해 주세요.`,
        error_21813:	`요청이 실패했습니다(오류 코드: 21813). 다시 시도해 주세요`,
        error_21814:	`오류: 21814. 문의해 주세요.`,
        error_21815:	`요청이 실패했습니다(오류 코드: 21815). 다시 시도해 주세요`,
        error_21816:	`오류: 21816. 문의해 주세요.`,
        error_21817:	`오류: 21817. 문의해 주세요.`,
        error_21818:	`오류: 21818. 문의해 주세요.`,
        error_21819:	`요청이 실패했습니다(오류 코드: 21819). 다시 시도해 주세요`,
        error_21820:	`오류: 21820. 문의해 주세요.`,
        error_21821:	`오류: 21821. 문의해 주세요.`,
        error_21822:	`오류: 21822. 문의해 주세요.`,
        error_21823:	`요청이 실패했습니다(오류 코드: 21823). 다시 시도해 주세요`,
        error_21824:	`요청이 실패했습니다(오류 코드: 21824). 다시 시도해 주세요`,
        error_21825:	`요청이 실패했습니다(오류 코드: 21825). 다시 시도해 주세요`,
        error_21826:	`요청이 실패했습니다(오류 코드: 21826). 다시 시도해 주세요`,
        error_21827:	`요청이 실패했습니다(오류 코드: 21827). 다시 시도해 주세요`,
        error_21828:	`삭제된 계정. 3일 정도 기다리시거나 다른 이메일을 이용해 주세요.`,
        error_21829:	`로그인 실패!`,
        error_26701:	`오류 코드: 26701, 문의해 주세요.`,
        error_26702:	`Reuqest가 실패했습니다(오류 코드: 26702). 다시 시도해주세요`,
        error_26703:	`오류 코드: 26703, 문의해 주세요.`,
        error_26704:	`오류 코드: 26704, 문의해 주세요.`,
        error_26705:	`로그인을 기다립니다(오류 코드: 26705). 다시 시도해주세요`,
        no_code_text:	`인증 코드를 보냈습니다. 코드를 입력하세요. <span class='tips'>코드를 받지 못하셨나요?`,
        no_code_text_1:	`1. 이메일 주소가 유효한지, 이메일을 받을 수 있는지 확인하세요.`,
        no_code_text_2:	`2. 이메일이 시스템에 의해 자동으로 전송되는 경우 스팸 또는 정크 이메일로 표시될 수 있습니다. 이메일이 휴지통에 있는지 확인해주세요.`,
        no_code_text_3:	`3. 문제를 해결할 수 없나요?`,
        no_code_text_3_span:	`그런 다음 <a href="https://discord.gg/CB5W97Z9eG" rel="nofollow">여기</a>를 클릭하여 저희에게 연락하세요.`,
        no_code_text_4_span:	`<b>주의:</b> 계정을 삭제한 후에는 3일 동안 동일한 이메일을 사용하여 등록하고 로그인할 수 없습니다.`,
        log_in:	`로그인`,
        public_Network_error:	`네트워크 오류입니다. 나중에 다시 시도해 주세요.`,
        public_showToast_Success:	`성공`,
        public_showToast_Warning:	`경고`,
        public_showToast_Error:	`오류`,
        public_showToast_1:	`결제가 완료되었습니다. 채팅을 즐겨보세요!`,
        public_showToast_2:	`결제를 확인하신 후 나중에 다시 확인해 주세요.`,
        public_showToast_3:	`결제에 실패했습니다. 다시 시도하거나 문의해 주세요.`,
        public_showToast_4:	`기다리세요`,
        public_showToast_5:	`결제가 완료되었습니다. 나중에 페이지를 새로 고쳐 요금제를 업데이트해 보세요.`,
        public_showToast_6:	`구독이 성공적으로 완료되었습니다. 채팅을 즐겨보세요!`,
        public_showToast_7:	`구독 갱신 취소가 완료되었습니다!`,
        public_showToast_8:	`취소하지 못했습니다. 나중에 다시 시도하거나 당사에 문의해 주세요.`,
        public_showToast_9:	`공지를 확인해주세요.`,
        pricing_showToast_10:	`결제 페이지로 이동하지 못했습니다. 나중에 다시 시도해 주세요.`,
        pricing_showToast_11:	`구독 요금제를 찾을 수 없습니다. 나중에 다시 시도해 주세요.`,
        pricing_showToast_12:	`귀하의 국가 정보를 얻을 수 없습니다. 문제를 해결하려면 당사에 문의하십시오.`,
        pricing_showToast_13:	`죄송합니다. 현재는 연간 구독과 월간 구독 간 전환이 불가능합니다.`,
        pricing_showToast_14:	`죄송합니다. 현재로서는 구독 다운그레이드를 지원하지 않습니다.`,
        pricing_Credit:	`신용카드로 결제`,
        pricing_Wallet:	`전자 지갑으로 결제`,
        public_Achievement:	`의 업적`,
        public_Login_Required:	`로그인 필요`,
        public_In_order:	`계속 진행하려면 계정에 로그인하세요.`,
        public_Network_error:	`네트워크 오류가 발생했습니다. 나중에 다시 시도해 주세요.`,
        public_New_Character:	`새로운 캐릭터`,
        public_Explore_Now:	`지금 살펴보세요`,
        public_Check_Now:	`지금 확인하세요`,
        public_Review:	`검토`,
        public_Follow:	`따르다`,
        public_Following:	`수행원`,
        public_Unfollow:	`언팔로우`,
        public_notifications:	`알림이 없습니다.`,
        public_Successfully_Unfollow:	`팔로우를 성공적으로 취소했습니다.`,
        public_Successfully_Follow:	`성공적으로 팔로우`,
        public_Failed_Unlike:	`캐릭터 좋아요 실패`,
        public_Failed_Followed:	`팔로우 실패`,
        public_Successfully_Like:	`캐릭터 좋아요 성공`,
        public_Successfully_Unlike:	`성공적으로 캐릭터와 달리`,
        public_Failed_Like:	`캐릭터를 좋아하는데 실패했습니다`,
        public_too_fast:	`클릭 속도가 너무 빠릅니다. 기다려 주세요.`,
        public_Log_in_to_get:	`받으려면 로그인하세요`,
        public_Login_for_Achievements:	`업적을 위해 로그인하세요`,
        public_Subscribe:	`구독하다`,
        pricing_subscription:	`구독이 만료되어 무료 플랜으로 돌아갈 때까지 기다리십시오.`,
        pricing_Confirm_Payment_Completion:	`결제 완료 확인`,
        pricing_complete_the_payment:	`새 창에서 결제를 완료해주세요. 결제가 성공적으로 완료되면 여기에서 계정 바인딩을 완료하세요.`,
        pricing_Paid:	`유급의`,
        pricing_Payment_Info_not_detected:	`결제 정보가 감지되지 않았습니다. 나중에 다시 시도하거나 Dsicord를 통해 문의하세요.`,
        pricing_character_finish_loading:	`캐릭터 카드 로딩이 완료될 때까지 기다려주세요.`,
        public_Report:	`보고서`,
        public_Paid:	`캐릭터 편집`,
        public_Failed_Show_Achievements:	`업적을 표시하지 못했습니다.`,
        public_results_create:	`원하는 결과를 찾을 수 없습니다. 지금 "만들기"를 클릭하여 원하는 것을 만드세요.`,
        public_create:	`만들다`,
        public_Views:	`조회수`,
        public_Likes:	`좋아요`,
        public_Comment:	`논평`,
        public_Private:	`사적인`,
        public_Restricted_Display:	`제한된 디스플레이`,
        public_Under_Review:	`검토중`,
                public_Claim:`주장하다`,
                public_Resubmit:`다시 제출`,
        public_results_not_found:	`원하는 결과를 찾을 수 없습니다.`,
        public_story_anonymous:	`이 이야기의 작가는 익명입니다.`,
        public_no_chat_stories:	`지금은 채팅 스토리가 없습니다. 가서 스토리를 만들어 보세요!`,
        public_Earn:	`벌다`,
        public_Submit:	`제출하다`,
        public_Unlock_My_Achievement:`Unlock My Achievement`,
        public_no_characters:	`현재 사용할 수 있는 캐릭터가 없습니다. 다음 캐릭터를 추천해 드립니다.`,
        public_enter_character:	`캐릭터 이름을 입력해주세요.`,
        public_length_characters_2:	`이름의 길이는 2자 이상이어야 합니다.`,
        public_length_characters_3:	`이름은 3~40자여야 합니다.`,
        public_length_characters_40:	`이름의 길이는 40자를 초과할 수 없습니다.`,
        public_length_characters_205:	`설명은 5~200자여야 합니다.`,
        public_length_characters_500:	`소개 내용은 최대 500자로 제한됩니다.`,
        public_no_Introduction:	`아직 소개가 없습니다.`,
        public_Image_uploading:	`이미지 업로드! 잠시만 기다려주세요.`,
        public_select_gender:	`캐릭터의 성별을 선택해주세요.`,
        public_length_Introduction_500:	`소개 내용은 최대 500자로 제한됩니다.`,
        public_length_characters_200:	`설명은 1~200자여야 합니다.`,
        public_length_characters_201:	`설명은 5~200자여야 합니다.`,
        public_length_characters_1000:	`최대 문자 수는 1000자입니다.`,
        public_length_characters_1001:	`인사말은 3~1000자여야 합니다.`,
        public_length_characters_4000:	`성격 콘텐츠는 0~4000자여야 합니다.`,
        public_length_characters_1002:	`시나리오 콘텐츠는 0~1,000자(영문 기준)여야 합니다.`,
        public_creation_failed:	`캐릭터 생성에 실패했습니다. 다시 시도해 주세요.`,
        public_Description_characters:	`설명은 5~500자여야 합니다.`,
        public_pornographic_illegal:	`외설적이고 불법적인 단어를 사용하지 마십시오. 그렇지 않으면 캐릭터 이미지 생성이 실패합니다!`,
        creator_edit_description:	`생성된 이미지에는 민감한 콘텐츠가 포함되어 있습니다. 설명을 수정하고 다시 시도해 주세요.`,
        creator_Generate_failed:	`이미지 생성에 실패했습니다!`,
        creator_exceed_10M:	`이미지 크기는 10M를 초과할 수 없습니다.`,
        creator_Database_Error:	`8001, 데이터베이스 처리 실패`,
        creator_Save_failed:	`저장하지 못했습니다. 다시 시도해 주세요.`,
        bonus_Reward_Title:	`보상: 한정 타이틀`,
        bonus_Go_Create:	`만들기로 이동하세요!`,
        bonus_Earn:	`벌다`,
        bonus_Finished:	`완성된`,
        bonus_Completed:	`완전한!`,
        bonus_Complete:	`완벽한!`,
                bonus_messages:`메시지`,
                bonus_image_unlock_props:`이미지 잠금 해제 소품`,
        bonus_correct_link:	`올바른 링크를 입력해주세요!`,
        bonus_Get_your_title:	`타이틀을 획득하세요!`,
        bonus_New_achievment:	`새로운 업적 완료!`,
        bonus_submission_failed:	`죄송합니다. 제출에 실패했습니다. 다시 제출해 주세요.`,
        bonus_Check_in_failed:	`체크인에 실패했습니다. 나중에 다시 시도해 주세요.`,
        bonus_Chat_with:`Chat with various AI characters without any filter on HeyReal.ai. Input the invite code`,
        bonus_Chat_with_1:`after you sign up to get tons of free messages.`,
        recommend_Characters:	`캐릭터`,
        recommend_Interactions:	`상호작용`,
        recommend_Created_by:	`작성자:`,
        chat_story_Successfully:	`성공적으로`,
        chat_story_Failed:	`실패한`,
        chat_story_story:	`이야기`,
        chat_story_like:	`좋다`,
        chat_story_unlike:	`같지 않은`,
        chat_story_characters:	`댓글은 200자를 넘을 수 없습니다.`,
        chat_story_Author:	`작가:`,
        character_not_info:	`작성자는 여기에 어떤 정보도 남기지 않았습니다.`,
        character_hidden_details:	`제작자가 관련 캐릭터 세부정보를 숨겼습니다.`,
        character_info_public:	`작성자는 이 정보를 공개하지 않았습니다.`,
        character_restore:	`부적절한 이미지로 인해 이용이 제한된 캐릭터입니다. 복원하려면 편집하세요.`,
        character_info_1:	`이 캐릭터는 다음으로 인해 제한됩니다.`,
        character_info_2:	`텍스트와 부적절한 이미지. 복원하려면 편집하세요.`,
        character_info_3:	`텍스트. 복원하려면 편집하세요.`,
        character_info_4:	`이 캐릭터는 검토 중이며 현재 본인에게만 표시됩니다. 검토가 완료되면 공개될 예정입니다.`,
        character_View_all:	`모두 보기`,
        character_Chat_Now:	`지금 채팅`,
        character_restricted:	`이 캐릭터는 콘텐츠 가이드라인을 위반하여 표시가 제한되었습니다. 다른 캐릭터를 사용해 보세요.`,
        character_Share_Story:	`다른 사람보다 먼저 첫 번째 이야기를 공유하세요!`,
        character_Start_Chat:	`채팅 시작`,
        character_Edit:	`편집하다`,
        character_View_Profile:	`프로필 보기 &gt;&gt;`,
        character_Photo_Album:	`사진앨범`,
        character_Successfully_Remove:	`즐겨찾기에서 성공적으로 제거되었습니다.`,
        character_Failed_Remove:	`즐겨찾기에서 제거하지 못했습니다.`,
        character_Successfully_Add:	`즐겨찾기에 성공적으로 추가되었습니다`,
        character_Failed_Add:	`즐겨찾기에 추가하지 못했습니다.`,
        character_info_4:	`서버 오류!`,
        creator_Sever_Error:	`서버 오류!`,
        public_username_is_taken:	`이 사용자 이름은 이미 사용 중입니다. 다른 것을 시도해 보세요.`,
        public_Sever_failed:	`변경사항을 저장하지 못했습니다. 다시 시도해 주세요.`,
        public_image_exceed_5:	`이미지 크기는 5M를 초과할 수 없습니다.`,
        public_Something_wrong:	`문제가 발생했습니다. 다시 시도해 주세요.`,
        public_Some_errors:	`우리가 인지하지 못하는 일부 오류!`,
        public_select_reason:	`제출하기 전에 신고 사유를 선택해 주세요.`,
        public_Successful_report:	`성공적인 보고서 작성, 지역사회 환경에 대한 귀하의 기여에 감사드립니다!`,
        public_Successful_report1:	`성공적인 보고`,
        public_Reported_too_often:	`너무 자주 신고됩니다. 나중에 다시 시도해 주세요.`,
        public_Reported_too_often1:	`너무 자주 신고됨`,
        public_Failed_report:	`실패한 보고서`,
        public_take:`보세요!`,
        album_Unlock:	`터놓다`,
        album_Chat_unlock:	`잠금 해제하려면 채팅하세요`,
        album_error:	`죄송합니다. 알 수 없는 오류가 발생했습니다. 다시 시도해 주세요.`,
        album_private:	`이 캐릭터는 비공개이므로 표시가 제한됩니다. 다른 캐릭터를 사용해 보세요.`,
        album_loading:	`앨범 카드 로드가 완료될 때까지 기다려 주세요.`,
        coins_not_enough:	`코인이 부족합니다. 먼저 코인을 더 확보하세요.`,
        coins_eligible_receive:	`귀하가 팁을 제공하는 사용자는 현재 팁을 받을 수 없습니다.`,
        coins_sent_successfully:	`팁이 성공적으로 전송되었습니다!`,
        coins_reached_limit:	`죄송합니다. 이 크리에이터는 오늘 팁 한도에 도달했습니다. 내일 다시 시도해 주세요!`,
        coins_Unlock:	`터놓다`,
        聽overtime_1:	`오류 코드:`,
        email_placeholder:	`이메일`,
        email_empty:	`이메일을 입력해주세요`,
        email_not_valid:	`이메일이 유효하지 않습니다`,
        email_not_valid_1:	`이메일을 입력해주세요`,
        email_not_valid_2:	`이메일이 유효하지 않습니다. 다른 주소를 사용해 주세요.`,
        email_not_valid_3:	`이메일 입력이 없습니다`,
        password_placeholder:	`비밀번호`,
        password_empty:	`비밀번호를 입력해주세요`,
        password_not_valid:	`잘못된 계정 또는 비밀번호`,
        password_not_valid_1:	`8자 이상의 비밀번호가 필요합니다`,
        password_not_valid_2:	`비밀번호를 생성해주세요`,
        password_placeholder_1:	`비밀번호를 만드세요`,
        password_placeholder_2:	`비밀번호를 확인하세요`,
        password_placeholder_3:	`새 비밀번호 만들기`,
        password_placeholder_4:	`새 비밀번호 확인`,
        password_placeholder_5:	`이전 비밀번호를 입력하세요`,
        copy_password_empty:	`비밀번호를 확인해 주세요`,
        copy_password_not_valid:	`비밀번호를 확인해 주세요`,
        copy_passwords_inconsistent:	`비밀번호 확인이 일치하지 않습니다`,
        code_empty:	`인증번호를 입력해주세요`,
        code_not_valid:	`잘못된 인증 코드`,
        code_placeholder:	`인증코드`,
        not_received_code:	`오랫동안 인증번호를 받지 못한 경우, 인증번호를 다시 받아보시기 바랍니다.`,
        get_first_code:	`먼저 인증번호를 받아주세요.`,
        connect_your_email_placeholder:	`이메일을 연결하세요`,
        last_name_placeholder:	`성을 입력하세요.`,
        first_name_placeholder:	`이름을 입력하세요.`,
        address_placeholder:	`주소를 입력해주세요`,
        error_24901:	`현재 계정에는 연결된 이메일이 없으며 주문을 찾을 수 없습니다. 이메일을 연결해주세요.`,
        user_guide:	`이용안내>>`,
        download:	`다운로드`,
        order_number:	`주문 번호:`,
        Refund:	`환불하다`,
        Disabled:	`장애가 있는`,
        Normal:	`정상`,
        Modify:	`수정하다`,
        Modify_1:	`수정>>`,
        error_20101:	`이메일을 입력해주세요. (오류코드: 20101)`,
        error_20102:	`이메일이 유효하지 않습니다(오류 코드: 20102).`,
        error_20103:	`요청이 실패했습니다(오류 코드: 20103). 다시 시도해 주세요`,
        error_20104:	`이메일이 이미 사용 중입니다. <a href="/ko/account/login/">로그인</a>하거나 새 이메일로 등록하세요.`,
        error_20105:	`요청이 실패했습니다(오류 코드: 20105). 다시 시도해 주세요`,
        error_20106:	`이메일을 보내지 못했습니다. 다시 시도해 주세요.`,
        error_20107:	`삭제된 계정. 3일 정도 기다리시거나 다른 이메일을 이용해 주세요.`,
        error_20201:	`이메일을 입력해주세요. (오류코드: 20201)`,
        error_20202:	`비밀번호를 입력해주세요. (오류코드: 20202)`,
        error_20203:	`인증코드를 입력해주세요. (오류코드: 20203)`,
        error_20204:	`이메일이 유효하지 않습니다(오류 코드: 20204).`,
        error_20205:	`8자 이상의 비밀번호가 필요합니다. (에러코드: 20205)`,
        error_20206:	`요청이 실패했습니다(오류 코드: 20206). 다시 시도해 주세요`,
        error_20207:	`잘못된 인증 코드`,
        error_20208:	`요청이 실패했습니다(오류 코드: 20208). 다시 시도해 주세요`,
        error_20209:	`요청이 실패했습니다(오류 코드: 20209). 다시 시도해 주세요`,
        error_20210:	`삭제된 계정. 3일 정도 기다리시거나 다른 이메일을 이용해 주세요.`,
        error_20301:	`이메일을 입력해주세요. (오류코드: 20301)`,
        error_20302:	`오류: 20302. 문의해 주세요.`,
        error_20303:	`이메일이 유효하지 않습니다(오류 코드: 20303).`,
        error_20304:	`요청이 실패했습니다(오류 코드: 20304). 다시 시도해 주세요`,
        error_20305:	`계정이 존재하지 않습니다. 먼저 다시 입력하거나 <a href="/ko/account/register/">만들기</a>하세요.`,
        error_20306:	`아직 비밀번호를 설정하지 않으셨다면 <a href="/ko/account/passwordless-login/">비밀번호 없이 로그인</a>을 이용해 주세요.`,
        error_20308:	`요청이 실패했습니다(오류 코드: 20308). 다시 시도해 주세요`,
        error_20401:	`로그아웃에 실패했습니다(오류 코드: 20401). 다시 시도해 주세요`,
        error_20501:	`이메일을 입력해주세요. (오류코드: 20501)`,
        error_20502:	`이메일이 유효하지 않습니다(오류 코드: 20502).`,
        error_20503:	`요청이 실패했습니다(오류 코드: 20503). 다시 시도해 주세요`,
        error_20504:	`이메일을 보내지 못했습니다. 다시 시도해 주세요.`,
        error_20601:	`이메일을 입력해주세요. (오류코드: 20601)`,
        error_20602:	`인증코드를 입력해주세요. (오류코드: 20602)`,
        error_20603:	`이메일이 유효하지 않습니다(오류 코드: 20603).`,
        error_20604:	`요청이 실패했습니다(오류 코드: 20604). 다시 시도해 주세요`,
        error_20606:	`요청이 실패했습니다(오류 코드: 20606). 다시 시도해 주세요`,
        error_20607:	`요청이 실패했습니다(오류 코드: 20607). 다시 시도해 주세요`,
        error_20608:	`요청이 실패했습니다(오류 코드: 20608). 다시 시도해 주세요`,
        error_20701:	`이메일을 입력해주세요. (오류코드: 20701)`,
        error_20702:	`이메일이 유효하지 않습니다(오류 코드: 20702).`,
        error_20703:	`요청이 실패했습니다(오류 코드: 20703). 다시 시도해 주세요`,
        error_20704:	`계정이 존재하지 않습니다. 먼저 다시 입력하거나 <a href="/ko/account/register/">만들기</a>하세요.`,
        error_20705:	`요청이 실패했습니다(오류 코드: 20705). 다시 시도해 주세요`,
        error_20706:	`이메일을 보내지 못했습니다. 다시 시도해 주세요`,
        error_20801:	`이메일을 입력해주세요. (오류코드: 20801)`,
        error_20802:	`오류: 20802. 문의해 주세요.`,
        error_20803:	`인증코드를 입력해주세요. (오류코드: 20803)`,
        error_20804:	`이메일이 유효하지 않습니다(오류 코드: 20804).`,
        error_20805:	`8자 이상의 비밀번호가 필요합니다. (에러코드: 20805)`,
        error_20806:	`요청이 실패했습니다(오류 코드: 20806). 다시 시도해 주세요`,
        error_20808:	`요청이 실패했습니다(오류 코드: 20808). 다시 시도해 주세요`,
        error_21000:	`변경사항이 저장되었습니다.`,
        error_21001:	`제출된 정보가 없습니다(오류 코드: 21001).`,
        error_21002:	`요청이 실패했습니다(오류 코드: 21002). 다시 시도해 주세요`,
        error_21101:	`이메일을 입력해주세요. (오류코드: 21101)`,
        error_21102:	`이메일이 유효하지 않습니다(오류 코드: 21102).`,
        error_21103:	`요청이 실패했습니다(오류 코드: 21103). 다시 시도해 주세요.`,
        error_21104:	`이메일이 이미 연결되어 있습니다. 새 이메일을 사용해 주세요.`,
        error_21105:	`요청이 실패했습니다(오류 코드: 21105). 다시 시도해 주세요.`,
        error_21106:	`이메일을 보내지 못했습니다. 다시 시도해 주세요`,
        error_21201:	`이메일을 입력해주세요. (오류코드: 21201)`,
        error_21202:	`인증코드를 입력해주세요. (오류코드: 21202)`,
        error_21203:	`이메일이 유효하지 않습니다(오류 코드: 21203).`,
        error_21204:	`오류: 21204. 문의해 주세요.`,
        error_21205:	`오류: 21205. 문의해 주세요.`,
        error_21206:	`8자 이상의 비밀번호가 필요합니다. (에러코드: 21206)`,
        error_21207:	`요청이 실패했습니다(오류 코드: 21207). 다시 시도해 주세요`,
        error_21209:	`요청이 실패했습니다(오류 코드: 21209). 다시 시도해 주세요`,
        error_21301:	`이전 비밀번호를 입력해주세요. (오류코드: 21301)`,
        error_21302:	`새로운 비밀번호를 만드세요. (오류코드: 21302)`,
        error_21303:	`새 비밀번호는 이전 비밀번호와 같을 수 없습니다. (오류: 21303)`,
        error_21304:	`8자 이상의 비밀번호가 필요합니다. (에러코드: 21304)`,
        error_21306:	`요청이 실패했습니다(오류 코드: 21306). 다시 시도해 주세요`,
        error_21402:	`요청이 실패했습니다(오류 코드: 21402). 다시 시도해 주세요`,
        error_21403:	`인증코드 전송에 실패했습니다. 다시 보내주세요`,
        error_21500:	`계정이 삭제되었습니다`,
        error_21501:	`인증코드를 입력해주세요. (오류코드: 21501)`,
        error_21502:	`로그인 세션이 만료되었습니다(오류: 21502). 다시 로그인해주세요.`,
        error_21503:	`요청이 실패했습니다(오류 코드: 21503). 다시 시도해 주세요`,
        error_21505:	`요청이 실패했습니다(오류 코드: 21505). 다시 시도해 주세요.`,
        error_21901:	`오류: 21901. 문의해 주세요.`,
        error_21902:	`요청이 실패했습니다(오류 코드: 21902). 다시 시도해 주세요`,
        error_21903:	`계정 상태가 변경되었습니다(오류 코드: 21903). 페이지를 새로 고친 후 다시 시도해 주세요.`,
        error_21904:	`오류: 21904. 다시 시도해 주세요.`,
        error_21905:	`오류: 21905. 다시 시도해 주세요.`,
        error_21906:	`요청이 실패했습니다(오류 코드: 21906). 다시 시도해 주세요`,
        error_21907:	`Google 계정이 다른 계정에 연결되었습니다`,
        error_21908:	`요청이 실패했습니다(오류 코드: 21908). 다시 시도해 주세요`,
        error_22001:	`요청이 실패했습니다(오류 코드: 22001). 다시 시도해 주세요`,
        error_22002:	`추가 로그인 없이 연결 해제에 실패했습니다.`,
        error_22003:	`요청이 실패했습니다(오류 코드: 22003). 다시 시도해 주세요`,
        error_22101:	`오류: 22101. 문의해 주세요.`,
        error_22102:	`계정 상태가 변경되었습니다(오류 코드: 22102). 페이지를 새로 고친 후 다시 시도해 주세요.`,
        error_22103:	`요청이 실패했습니다(오류 코드: 22103). 다시 시도해 주세요`,
        error_22104:	`계정 상태가 변경되었습니다(오류 코드: 22104). 페이지를 새로 고친 후 다시 시도해 주세요.`,
        error_22105:	`오류: 22105. 다시 시도해 주세요.`,
        error_22106:	`오류: 22106. 다시 시도해 주세요.`,
        error_22107:	`오류: 22107. 문의해 주세요.`,
        error_22108:	`요청이 실패했습니다(오류 코드: 22108). 다시 시도해 주세요`,
        error_22201:	`오류: 22201. 문의해 주세요.`,
        error_22202:	`잘못된 검증(오류: 22202). 다시 시도해 주세요.`,
        error_22203:	`오류: 22203. 다시 시도해 주세요."`,
        error_22204:	`요청이 실패했습니다(오류 코드: 22204). 다시 시도해 주세요`,
        error_22206:	`요청이 실패했습니다(오류 코드: 22206). 다시 시도해 주세요`,
        error_22401:	`오류: 22401. 문의해 주세요.`,
        error_22402:	`잘못된 검증(오류: 22402). 다시 시도해 주세요.`,
        error_22403:	`오류: 22403. 다시 시도해 주세요.`,
        error_22404:	`요청이 실패했습니다(오류 코드: 22404). 다시 시도해 주세요`,
        error_22405:	`Facebook 계정이 다른 이메일에 연결되었습니다`,
        error_22406:	`오류: 22406. 다시 시도해 주세요.`,
        error_22407:	`오류: 22407. 문의해 주세요.`,
        error_22408:	`오류: 22408. 문의해 주세요.`,
        error_22409:	`오류: 22409. 문의해 주세요.`,
        error_22410:	`오류: 224010. 문의해 주세요.`,
        error_22411:	`오류: 224011. 문의해 주세요.`,
        error_22412:	`오류: 224012. 문의해 주세요.`,
        error_22413:	`오류: 22413. 문의해 주세요.`,
        error_22414:	`요청이 실패했습니다(오류 코드: 22414). 다시 시도해 주세요`,
        error_22415:	`오류: 22415. 문의해 주세요.`,
        error_22416:	`오류: 22416. 문의해 주세요.`,
        error_22417:	`오류: 22417. 문의해 주세요.`,
        error_22418:	`요청이 실패했습니다(오류 코드: 22418). 다시 시도해 주세요`,
        error_22419:	`오류: 22419. 문의해 주세요.`,
        error_22420:	`오류: 22420. 문의해 주세요.`,
        error_22421:	`오류: 22421. 문의해 주세요.`,
        error_22422:	`요청이 실패했습니다(오류 코드: 22422). 다시 시도해 주세요`,
        error_22423:	`요청이 실패했습니다(오류 코드: 22423). 다시 시도해 주세요`,
        error_22424:	`요청이 실패했습니다(오류 코드: 22424). 다시 시도해 주세요`,
        error_22425:	`요청이 실패했습니다(오류 코드: 22425). 다시 시도해 주세요`,
        error_20098:	`오류 코드: 20098. 비공개 모드에서 검색하는 경우 일반 모드로 전환한 후 다시 시도하세요.`,
        error_22498:	`Facebook 요청이 실패했습니다(오류: 22498). 다시 시도해 주세요.`,
        error_24902:	`요청이 실패했습니다(오류 코드: 24902). 다시 시도해 주세요`,
        error_24903:	`요청이 실패했습니다(오류 코드: 24903). 다시 시도해 주세요`,
        error_24904:	`요청이 실패했습니다(오류 코드: 24904). 다시 시도해 주세요`,
        error_24905:	`요청이 실패했습니다(오류 코드: 24905). 다시 시도해 주세요`,
        login_title:	`헤이리얼에 로그인하세요`,
        no_account:	`계정이 없나요?`,
        create_it:	`만들기`,
        or_log_in_with:	`또는 다음으로 로그인하세요.`,
        passwordless_login:	`비밀번호 없는 로그인`,
        log_in_done:	`로그인 완료`,
        three_rd_account_connect_info:	`축하해요! 성공적으로 로그인되었습니다. 이제 향후 로그인에 사용되는 하나의 이메일 계정을 연결할 수 있습니다.`,
        connect_now:	`지금 연결하세요`,
        see_my_account:	`내 계정 보기`,
        three_rd_login_merge_account:	`타사 계정 이메일 주소가 가입되어 있습니다. 해당 이메일 주소로 직접 접속하여 로그인하시겠습니까?`,
        connect_log_in:	`연결 및 로그인`,
        create_an_account:	`계정 만들기`,
        connect_account:	`계정 연결`,
        connect_account_info:	`연결 후 이 계정으로 로그인할 수 있습니다.`,
        back_to_log_in:	`로그인으로 돌아가기`,
        create_password:	`비밀번호 생성`,
        create_now:	`지금 만들기`,
        password_login_subtitle:	`이메일을 이용한 비밀번호 없는 로그인`,
        account_login:	`계정 로그인`,
        rights:	`이 계정을 만들면 <a href="https://heyreal.ai/ko/terms-and-conditions/">서비스 약관</a> 및 <a href="https://heyreal.ai/ko/privacy-policy/">개인정보 보호정책</a>에 동의하게 됩니다.`,
        passwordless_login_done:	`비밀번호 없이 로그인 완료`,
        passwordless_login_info:	`축하합니다. 비밀번호 없는 로그인이 성공적으로 완료되었습니다. 이 계정에 대한 비밀번호를 생성하고 나중에 해당 계정과 비밀번호로 로그인할 수 있습니다. <a href="/ko/account/create-password/" style="display: initial;">지금 만들기</a>`,
        sign_up:	`가입`,
        register_info:	`계정 만들기`,
        reset_now:	`지금 재설정`,
        forgot_password:	`비밀번호를 잊으셨나요?`,
        reset_password_subtitle:	`계정 이메일을 사용하여 비밀번호를 재설정하세요.`,
        plan_products:	`계획 및 제품`,
        nick_name:	`닉네임:`,
        email:	`이메일:`,
        unlink:	`풀리다`,
        link:	`링크`,
        change_now:	`지금 변경`,
        connect_email:	`이메일 연결`,
        delete_account:	`계정 삭제`,
        delete_account_info:	`귀하의 계정이 삭제되면 귀하의 계정과 관련된 플랜 및 제품의 모든 데이터가 영구적으로 삭제되며 복구가 불가능할 수도 있습니다. 조심스럽게 밟으시길 권합니다.`,
        Delete:	`삭제`,
        Logout:	`로그아웃`,
        to:	`에게`,
        footer:	`Copyright 漏 2024 HeyReal Studio. 모든 권리 보유.`,
        google_login:	`Google로 로그인`,
        State:	`상태`,
        images:	`이미지`,
        email_verification:	`이메일 확인`,
        email_verification_info:	`귀하의 이메일 <span class="email"></span>으로 확인 메시지를 보냈으니 확인을 완료해 주시기 바랍니다. 인증 후 혜택은 자동으로 동기화됩니다.`,
        error_26301:	`오류 코드: 26301, 문의해 주세요.`,
        error_26302:	`오류 코드: 26302, 문의해 주세요.`,
        error_26303:	`이메일 형식 오류(오류 코드: 26303) 다시 입력해주세요`,
        error_26304:	`비밀번호는 8자 이상을 권장합니다. (에러코드: 26304)`,
        error_26305:	`Reuqest가 실패했습니다(오류 코드: 26305). 다시 시도해주세요`,
        error_26306:	`이메일이 등록되었습니다. <a href="/ko/account/login/">로그인으로 이동</a>하세요.`,
        error_26307:	`Reuqest가 실패했습니다(오류 코드: 26307). 다시 시도해주세요`,
        error_26308:	`Reuqest가 실패했습니다(오류 코드: 26308). 다시 시도해주세요`,
        error_26401:	`오류 코드: 26401, 다시 시도해 주세요.`,
        error_26402:	`이메일이 확인되었습니다(오류 코드: 26402). 다시 시도해 주세요.`,
        error_26403:	`Reuqest가 실패했습니다(오류 코드: 26403). 다시 시도해주세요`,
        error_26404:	`요청이 실패했습니다(오류 코드: 26404). 다시 시도해주세요`,
        error_26501:	`오류 코드: 26501, 문의해 주세요.`,
        error_26502:	`오류 코드: 26502, 문의해 주세요.`,
        error_26503:	`이메일 형식 오류(오류 코드: 26503) 다시 입력해주세요`,
        error_26504:	`Reuqest가 실패했습니다(오류 코드: 26504). 다시 시도해주세요`,
        error_26505:	`이메일이 등록되지 않았습니다. <a href="/ko/account/register/">먼저 등록</a>하세요.`,
        error_26506:	`이메일이 확인되었습니다.`,
        error_26507:	`Reuqest가 실패했습니다(오류 코드: 26507). 다시 시도해주세요`,
        error_26508:	`확인이 실패했습니다(오류 코드: 26508). 다시 시도해 주세요.`,
        error_26509:	`요청이 실패했습니다(오류 코드: 26509). 다시 시도해 주세요.`,
        error_26510:	`오류 코드: 26510, 문의해 주세요.`,
        error_26601:	`오류 코드: 26601, 문의해 주세요.`,
        error_26602:	`오류 코드: 26602, 문의해 주세요.`,
        error_26603:	`Reuqest가 실패했습니다(오류 코드: 26603). 다시 시도해주세요`,
        error_26604:	`오류 코드: 26604, 문의해 주세요.`,
        error_26605:	`오류 코드: 26605, 문의해 주세요.`,
        no_cookie:	`귀하의 브라우저에서 모든 쿠키 차단 기능이 켜져 있어 로그인할 수 없습니다. 설정으로 이동하여 모든 쿠키 허용 확인란을 선택하세요.`,
        error_26801:	`오류 코드: 26801, 문의해 주세요.`,
        error_26802:	`오류 코드: 26802, 문의해 주세요.`,
        error_26803:	`요청이 실패했습니다(오류 코드: 26803). 다시 시도해주세요`,
        error_26804:	`요청이 실패했습니다(오류 코드: 26804). 다시 시도해주세요`,
        error_order:	`요청이 실패했습니다(오류 코드: 27098). 다시 시도해 주세요!`,
        error_order1:	`주문 쿼리가 불완전합니다(오류 코드:`,
        error_order2:	`) 새로고침한 후 다시 시도해 주세요.`,
        modify_email_title:	`이메일 수정`,
        modify_email_info:	`수정된 이메일을 사용하여 계정에 로그인할 수 있습니다.`,
        images_per:	`당 이미지`,
        error_26101:	`오류: 26101. 문의해 주세요.`,
        error_26102:	`오류: 26102. 문의해 주세요.`,
        error_26103:	`요청이 실패했습니다(오류 코드:26103). 다시 시도해 주세요`,
        error_26104:	`오류 코드: 26104, 다시 시도해 주세요.`,
        error_26105:	`오류 코드: 26105, 다시 시도해 주세요.`,
        error_26106:	`삭제에 실패했습니다(오류 코드: 26106). 다시 시도해 주세요`,
        error_26201:	`오류: 26201. 문의해 주세요.`,
        error_26202:	`요청이 실패했습니다(오류 코드:26202). 다시 시도해 주세요`,
        error_26001:	`오류: 26001. 문의해 주세요.`,
        error_26002:	`오류: 26002. 문의해 주세요.`,
        error_26003:	`오류: 26003. 문의해 주세요.`,
        error_26004:	`오류: 26004. 문의해 주세요.`,
        error_26005:	`요청이 실패했습니다(오류 코드:26005). 다시 시도해 주세요`,
        error_26006:	`오류 코드: 26006, 다시 시도해 주세요.`,
        error_26008:	`오류: 26008. 문의해 주세요.`,
        go_to_the_home_page:	`홈 페이지로 이동`,
    },
    de:{
        overtime_1:	`Fehlercode:`,
        overtime_2:	`, bitte versuchen Sie es erneut`,
        isnetwork:	`Internetfehler. Bitte überprüfen Sie es und versuchen Sie es erneut`,
        edit_photo:	`Foto bearbeiten`,
        select_photo:	`Wählen Sie Foto`,
        change_photo:	`Foto ändern`,
        cancel:	`Stornieren`,
        hide_password:	`Passwort verbergen`,
        show_password:	`Passwort anzeigen`,
        zoom_in:	`Vergrößern`,
        zoom_out:	`Herauszoomen`,
        rotate:	`Drehen`,
        horizontal_flip:	`Horizontaler Flip`,
        vertical_flip:	`Vertikaler Flip`,
        Connect:	`Verbinden`,
        unlink_success:	`Verknüpfung erfolgreich aufheben`,
        connect_success:	`Erfolgreich verbinden`,
        feedback_title:	`Vielen Dank für Ihr Feedback. Bitte hinterlassen Sie Ihr Problem und wir werden Ihnen innerhalb von 24 Stunden antworten.`,
        feedback_thank_you:	`Vielen Dank!<br />Ihr Feedback wurde erfolgreich übermittelt.`,
        feedback_email:	`Geben Sie hier Ihre E-Mail-Adresse ein!`,
        feedback_content:	`Hinterlassen Sie hier alle Probleme oder Vorschläge, auf die Sie gestoßen sind.`,
        feedback_submit:	`Einreichen`,
        form_contents:	`Sie haben keine Beschreibung eingegeben. Bitte geben Sie es ein und senden Sie es erneut ab.`,
        old_password:	`Bitte geben Sie das alte Passwort ein`,
        new_password:	`Bitte erstellen Sie ein neues Passwort`,
        old_new_password:	`Das neue Passwort darf nicht mit dem alten identisch sein`,
        incorrect_password:	`Falsches Passwort`,
        delete_no:	`Jetzt löschen`,
        Caps:	`Die Feststelltaste ist aktiviert`,
        Get:	`Erhalten`,
        Done:	`Erledigt`,
        error_20001:	`Fehler: 20001. Bitte melden Sie sich erneut an.`,
        error_20002:	`Fehler: 20002. Bitte melden Sie sich erneut an.`,
        error_20003:	`Fehler: 20003. Bitte melden Sie sich erneut an.`,
        error_20004:	`Anfrage fehlgeschlagen (Fehlercode: 20004). Bitte versuchen Sie es noch einmal.`,
        error_20005:	`Die Anmeldesitzung ist abgelaufen (Fehler: 20005). Bitte melden Sie sich erneut an.`,
        error_20006:	`Anfrage fehlgeschlagen (Fehlercode: 20006). Bitte versuchen Sie es noch einmal.`,
        error_20007:	`Die Anmeldesitzung ist abgelaufen (Fehler: 20007). Bitte melden Sie sich erneut an.`,
        error_20008:	`Die Anmeldesitzung ist abgelaufen (Fehler: 20008). Bitte melden Sie sich erneut an.`,
        error_20009:	`Die Anmeldesitzung ist abgelaufen (Fehler: 20009). Bitte melden Sie sich erneut an.`,
        error_20901:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 20901). Bitte versuchen Sie es noch einmal`,
        error_20902:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 20902). Bitte versuchen Sie es noch einmal`,
        error_22298:	`Die Anfrage an Google ist fehlgeschlagen (Fehler: 22298). Bitte versuchen Sie es noch einmal.`,
        error_21601:	`Fehler: 21601. Bitte kontaktieren Sie uns`,
        error_21602:	`Ungültige Verifizierung (Fehler: 21602). Bitte versuchen Sie es noch einmal.`,
        error_21603:	`Fehler: 21603. Bitte versuchen Sie es erneut`,
        error_21604:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 21604). Bitte versuchen Sie es noch einmal`,
        error_21606:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 21606). Bitte versuchen Sie es noch einmal`,
        error_21611:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 21611). Bitte versuchen Sie es noch einmal`,
        error_21613:	`Melden Sie sich zu oft an. Bitte versuchen Sie es später noch einmal.`,
        error_21801:	`Fehler: 21801. Bitte kontaktieren Sie uns`,
        error_21802:	`Die Anfrage ist fehlgeschlagen (Fehler: 21802). Bitte versuchen Sie es noch einmal`,
        error_21803:	`Fehler: 21803. Bitte versuchen Sie es erneut`,
        error_21804:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 21804). Bitte versuchen Sie es noch einmal`,
        error_21806:	`Fehler: 21806. Bitte versuchen Sie es erneut`,
        error_21807:	`Fehler: 21807. Bitte kontaktieren Sie uns`,
        error_21808:	`Fehler: 21808. Bitte kontaktieren Sie uns`,
        error_21809:	`Fehler: 21809. Bitte kontaktieren Sie uns`,
        error_21810:	`Fehler: 21810. Bitte kontaktieren Sie uns`,
        error_21811:	`Fehler: 21811. Bitte kontaktieren Sie uns`,
        error_21812:	`Fehler: 21812. Bitte kontaktieren Sie uns`,
        error_21813:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 21813). Bitte versuchen Sie es noch einmal`,
        error_21814:	`Fehler: 21814. Bitte kontaktieren Sie uns`,
        error_21815:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 21815). Bitte versuchen Sie es noch einmal`,
        error_21816:	`Fehler: 21816. Bitte kontaktieren Sie uns`,
        error_21817:	`Fehler: 21817. Bitte kontaktieren Sie uns`,
        error_21818:	`Fehler: 21818. Bitte kontaktieren Sie uns`,
        error_21819:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 21819). Bitte versuchen Sie es noch einmal`,
        error_21820:	`Fehler: 21820. Bitte kontaktieren Sie uns`,
        error_21821:	`Fehler: 21821. Bitte kontaktieren Sie uns`,
        error_21822:	`Fehler: 21822. Bitte kontaktieren Sie uns`,
        error_21823:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 21823). Bitte versuchen Sie es noch einmal`,
        error_21824:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 21824). Bitte versuchen Sie es noch einmal`,
        error_21825:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 21825). Bitte versuchen Sie es noch einmal`,
        error_21826:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 21826). Bitte versuchen Sie es noch einmal`,
        error_21827:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 21827). Bitte versuchen Sie es noch einmal`,
        error_21828:	`Gelöschtes Konto. Bitte warten Sie 3 Tage oder verwenden Sie eine andere E-Mail-Adresse.`,
        error_21829:	`Fehler bei der Anmeldung!`,
        error_26701:	`Fehlercode: 26701, bitte kontaktieren Sie uns`,
        error_26702:	`Reuqest ist fehlgeschlagen (Fehlercode: 26702). Bitte versuchen Sie es erneut`,
        error_26703:	`Fehlercode: 26703, bitte kontaktieren Sie uns`,
        error_26704:	`Fehlercode: 26704, bitte kontaktieren Sie uns`,
        error_26705:	`Warten Sie auf die Anmeldung (Fehlercode: 26705). Bitte versuchen Sie es erneut`,
        no_code_text:	`Wir haben einen Bestätigungscode gesendet. Bitte geben Sie Ihren Code ein. <span class='tips'>Sie haben keinen Code erhalten?`,
        no_code_text_1:	`1. Bitte stellen Sie sicher, dass die E-Mail-Adresse gültig ist und E-Mails empfangen kann.`,
        no_code_text_2:	`2. Da die E-Mail vom System automatisch gesendet wird, kann sie als Spam- oder Junk-E-Mail gekennzeichnet werden. Bitte prüfen Sie, ob sich die E-Mail im Papierkorb befindet.`,
        no_code_text_3:	`3. Können Sie Ihr Problem nicht lösen?`,
        no_code_text_3_span:	`Dann klicken Sie <a href="https://discord.gg/CB5W97Z9eG" rel="nofollow">hier</a>, um mit uns Kontakt aufzunehmen.`,
        no_code_text_4_span:	`<b>Achtung:</b> Nach dem Löschen Ihres Kontos können Sie sich drei Tage lang nicht mehr mit derselben E-Mail-Adresse registrieren und anmelden.`,
        log_in:	`Einloggen`,
        public_Network_error:	`Netzwerkfehler. Bitte versuchen Sie es später noch einmal.`,
        public_showToast_Success:	`Erfolg`,
        public_showToast_Warning:	`Warnung`,
        public_showToast_Error:	`Fehler`,
        public_showToast_1:	`Zahlung erfolgreich, viel Spaß beim Chat!`,
        public_showToast_2:	`Bestätigen Sie Ihre Zahlung. Bitte versuchen Sie es später noch einmal.`,
        public_showToast_3:	`Die Zahlung ist fehlgeschlagen. Bitte versuchen Sie es erneut oder kontaktieren Sie uns.`,
        public_showToast_4:	`Bitte warten`,
        public_showToast_5:	`Die Zahlung war erfolgreich. Bitte versuchen Sie später, die Seite zu aktualisieren, um den Plan zu aktualisieren.`,
        public_showToast_6:	`Abonnement erfolgreich. Viel Spaß beim Chat!`,
        public_showToast_7:	`Abonnementverlängerung erfolgreich kündigen!`,
        public_showToast_8:	`Die Stornierung ist fehlgeschlagen. Bitte versuchen Sie es später noch einmal oder kontaktieren Sie uns.`,
        public_showToast_9:	`Bitte überprüfen Sie den Hinweis.`,
        pricing_showToast_10:	`Die Zahlungsseite konnte nicht aufgerufen werden. Bitte versuchen Sie es später noch einmal.`,
        pricing_showToast_11:	`Das Abonnement konnte nicht gefunden werden. Bitte versuchen Sie es später erneut.`,
        pricing_showToast_12:	`Die Informationen zu Ihrem Land konnten nicht abgerufen werden. Bitte kontaktieren Sie uns, um das Problem zu lösen.`,
        pricing_showToast_13:	`Leider ist der Wechsel zwischen Jahres- und Monatsabonnements derzeit nicht möglich.`,
        pricing_showToast_14:	`Leider unterstützen wir derzeit keine Abonnement-Downgrades.`,
        pricing_Credit:	`Bezahlen Sie mit Kreditkarte`,
        pricing_Wallet:	`Bezahlen Sie mit E-Wallet`,
        public_Achievement:	`\'s Erfolg(e)`,
        public_Login_Required:	`Anmeldung erforderlich`,
        public_In_order:	`Um fortzufahren, melden Sie sich bitte bei Ihrem Konto an.`,
        public_Network_error:	`Netzwerkfehler, bitte versuchen Sie es später noch einmal.`,
        public_New_Character:	`Neuer Charakter`,
        public_Explore_Now:	`Jetzt entdecken`,
        public_Check_Now:	`Jetzt prüfen`,
        public_Review:	`Rezension`,
        public_Follow:	`Folgen`,
        public_Following:	`Nachfolgend`,
        public_Unfollow:	`Nicht mehr folgen`,
        public_notifications:	`Keine Benachrichtigungen.`,
        public_Successfully_Unfollow:	`Entfolgen Sie erfolgreich`,
        public_Successfully_Follow:	`Erfolgreich folgen`,
        public_Failed_Unlike:	`Der Charakter konnte nicht abgeglichen werden`,
        public_Failed_Followed:	`Fehler beim Folgen`,
        public_Successfully_Like:	`Den Charakter erfolgreich liken`,
        public_Successfully_Unlike:	`Erfolgreich im Gegensatz zum Charakter`,
        public_Failed_Like:	`Der Charakter hat mir nicht gefallen`,
        public_too_fast:	`Es klickt zu schnell. Bitte warten.`,
        public_Log_in_to_get:	`Melden Sie sich an, um zu erhalten`,
        public_Login_for_Achievements:	`Melden Sie sich für Erfolge an`,
        public_Subscribe:	`Abonnieren`,
        pricing_subscription:	`Bitte warten Sie, bis Ihr Abonnement abläuft, und kehren Sie zum kostenlosen Plan zurück.`,
        pricing_Confirm_Payment_Completion:	`Bestätigen Sie den Zahlungsabschluss`,
        pricing_complete_the_payment:	`Bitte schließen Sie die Zahlung im neuen Fenster ab. Und schließen Sie hier nach erfolgreicher Zahlung die Kontobindung ab.`,
        pricing_Paid:	`Bezahlt`,
        pricing_Payment_Info_not_detected:	`Zahlungsinformationen wurden nicht erkannt. Bitte versuchen Sie es später noch einmal oder kontaktieren Sie uns über Dsicord`,
        pricing_character_finish_loading:	`Bitte warten Sie, bis die Charakterkarten vollständig geladen sind.`,
        public_Report:	`Bericht`,
        public_Paid:	`Charakter bearbeiten`,
        public_Failed_Show_Achievements:	`Die Erfolge konnten nicht angezeigt werden`,
        public_results_create:	`Die gewünschten Ergebnisse wurden nicht gefunden. Klicken Sie jetzt auf „Erstellen“, um das gewünschte zu erstellen.`,
        public_create:	`Erstellen`,
        public_Views:	`Ansichten`,
        public_Likes:	`Gefällt mir`,
        public_Comment:	`Kommentar`,
        public_Private:	`Privat`,
        public_Restricted_Display:	`Eingeschränkte Anzeige`,
        public_Under_Review:	`Wird überprüft`,
                public_Claim:`Beanspruchen`,
                public_Resubmit:`Erneut einreichen`,
        public_results_not_found:	`Die gewünschten Ergebnisse wurden nicht gefunden.`,
        public_story_anonymous:	`Der Autor dieser Geschichte ist anonym.`,
        public_no_chat_stories:	`Im Moment gibt es keine Chat-Stories, erstellen Sie doch einfach eine!`,
        public_Earn:	`Verdienen`,
        public_Submit:	`Einreichen`,
        public_Unlock_My_Achievement:`Unlock My Achievement`,
        public_no_characters:	`Derzeit sind keine Charaktere verfügbar. Wir empfehlen Ihnen die folgenden Charaktere:`,
        public_enter_character:	`Bitte geben Sie den Namen des Charakters ein.`,
        public_length_characters_2:	`Der Name muss länger als 2 Zeichen sein.`,
        public_length_characters_3:	`Der Name muss 3 bis 40 Zeichen lang sein.`,
        public_length_characters_40:	`Die Länge des Namens darf 40 Zeichen nicht überschreiten.`,
        public_length_characters_205:	`Die Beschreibung muss 5 bis 200 Zeichen lang sein.`,
        public_length_characters_500:	`Der Einführungsinhalt ist auf maximal 500 Zeichen begrenzt.`,
        public_no_Introduction:	`Noch keine Einführung.`,
        public_Image_uploading:	`Bild hochladen! Bitte warten Sie eine Sekunde.`,
        public_select_gender:	`Bitte wählen Sie das Geschlecht des Charakters aus.`,
        public_length_Introduction_500:	`Der Einführungsinhalt ist auf maximal 500 Zeichen begrenzt.`,
        public_length_characters_200:	`Der Kommentar sollte 1 bis 200 Zeichen lang sein.`,
        public_length_characters_201:	`Die Beschreibung muss 5–200 Zeichen lang sein.`,
        public_length_characters_1000:	`Die maximale Zeichenanzahl beträgt 1000.`,
        public_length_characters_1001:	`Die Begrüßung muss zwischen 3 und 1000 Zeichen lang sein.`,
        public_length_characters_4000:	`Persönlichkeitsinhalte müssen zwischen 0 und 4000 Zeichen lang sein.`,
        public_length_characters_1002:	`Der Inhalt des Szenarios muss zwischen 0 und 1000 Zeichen lang sein.`,
        public_creation_failed:	`Die Charaktererstellung ist fehlgeschlagen. Bitte versuchen Sie es erneut.`,
        public_Description_characters:	`Die Beschreibung muss 5–500 Zeichen lang sein.`,
        public_pornographic_illegal:	`Bitte verwenden Sie keine pornografischen und illegalen Wörter, da sonst die Charakterbildgenerierung fehlschlägt!`,
        creator_edit_description:	`Das generierte Bild enthält vertrauliche Inhalte. Bitte bearbeiten Sie die Beschreibung und versuchen Sie es erneut.`,
        creator_Generate_failed:	`Bilder generieren fehlgeschlagen!`,
        creator_exceed_10M:	`Die Bildgröße darf 10 MB nicht überschreiten`,
        creator_Database_Error:	`8001, Datenbankverarbeitung fehlgeschlagen`,
        creator_Save_failed:	`Das Speichern ist fehlgeschlagen. Bitte versuchen Sie es erneut.`,
        bonus_Reward_Title:	`Belohnung: Begrenzter Titel`,
        bonus_Go_Create:	`Gehen Sie zu Erstellen!`,
        bonus_Earn:	`Verdienen`,
        bonus_Finished:	`Fertig`,
        bonus_Completed:	`Vollendet!`,
        bonus_Complete:	`Vollständig!`,
                bonus_messages:`Nachrichten`,
                bonus_image_unlock_props:`Bild wird entsperrt`,
        bonus_correct_link:	`Bitte geben Sie den richtigen Link ein!`,
        bonus_Get_your_title:	`Holen Sie sich Ihren Titel!`,
        bonus_New_achievment:	`Neuer Erfolg abgeschlossen!`,
        bonus_submission_failed:	`Entschuldigung, die Übermittlung ist fehlgeschlagen. Bitte erneut einreichen.`,
        bonus_Check_in_failed:	`Der Check-in ist fehlgeschlagen. Bitte versuchen Sie es später noch einmal.`,
        bonus_Chat_with:`Chat with various AI characters without any filter on HeyReal.ai. Input the invite code`,
        bonus_Chat_with_1:`after you sign up to get tons of free messages.`,
        recommend_Characters:	`Charaktere`,
        recommend_Interactions:	`Interaktionen`,
        recommend_Created_by:	`Erstellt von:`,
        chat_story_Successfully:	`Erfolgreich`,
        chat_story_Failed:	`Fehlgeschlagen`,
        chat_story_story:	`die Geschichte`,
        chat_story_like:	`Wie`,
        chat_story_unlike:	`Im Gegensatz zu`,
        chat_story_characters:	`Der Kommentar sollte nicht länger als 200 Zeichen sein.`,
        chat_story_Author:	`Autor:`,
        character_not_info:	`Der Ersteller hat hier keine Informationen hinterlassen.`,
        character_hidden_details:	`Der Ersteller hat die relevanten Charakterdetails ausgeblendet`,
        character_info_public:	`Der Ersteller hat diese Informationen nicht veröffentlicht.`,
        character_restore:	`Dieser Charakter ist aufgrund unangemessener Bilder eingeschränkt. Bearbeiten, um es wiederherzustellen.`,
        character_info_1:	`Dieser Charakter ist aufgrund von eingeschränkt`,
        character_info_2:	`Text und unangemessene Bilder. Bearbeiten, um es wiederherzustellen.`,
        character_info_3:	`Text. Bearbeiten, um es wiederherzustellen.`,
        character_info_4:	`Dieser Charakter wird derzeit überprüft und ist derzeit nur für Sie sichtbar. Es wird veröffentlicht, sobald die Überprüfung abgeschlossen ist.`,
        character_View_all:	`Alle anzeigen`,
        character_Chat_Now:	`Jetzt chatten`,
        character_restricted:	`Die Anzeige dieses Zeichens ist aufgrund eines Verstoßes gegen unsere Inhaltsrichtlinien eingeschränkt. Bitte versuchen Sie es mit einem anderen Charakter.`,
        character_Share_Story:	`Teilen Sie die erste Geschichte vor allen anderen!`,
        character_Start_Chat:	`Chat starten`,
        character_Edit:	`Bearbeiten`,
        character_View_Profile:	`Profil anzeigen &gt;&gt;`,
        character_Photo_Album:	`Fotoalbum`,
        character_Successfully_Remove:	`Erfolgreich aus den Favoriten entfernen`,
        character_Failed_Remove:	`Aus den Favoriten entfernen fehlgeschlagen`,
        character_Successfully_Add:	`Erfolgreich zu den Favoriten hinzufügen`,
        character_Failed_Add:	`Zu den Favoriten hinzufügen fehlgeschlagen`,
        character_info_4:	`Schwerwiegender Fehler!`,
        creator_Sever_Error:	`Schwerwiegender Fehler!`,
        public_username_is_taken:	`Dieser Benutzername ist vergeben. Bitte versuchen Sie es mit einem anderen.`,
        public_Sever_failed:	`Das Speichern der Änderungen ist fehlgeschlagen. Bitte versuchen Sie es erneut.`,
        public_image_exceed_5:	`Die Bildgröße darf 5 MB nicht überschreiten`,
        public_Something_wrong:	`Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.`,
        public_Some_errors:	`Einige Fehler, die uns nicht bekannt sind!`,
        public_select_reason:	`Bitte wählen Sie vor dem Absenden den Grund für die Meldung aus.`,
        public_Successful_report:	`Erfolgreicher Bericht, vielen Dank für Ihren Beitrag zum Community-Umfeld!`,
        public_Successful_report1:	`Erfolgreicher Bericht`,
        public_Reported_too_often:	`Zu oft gemeldet, bitte versuchen Sie es später noch einmal!`,
        public_Reported_too_often1:	`Zu oft gemeldet`,
        public_Failed_report:	`Fehlgeschlagener Bericht`,
        public_take:`Werfen Sie einen Blick darauf!`,
        album_Unlock:	`Entsperren`,
        album_Chat_unlock:	`Zum Entsperren chatten`,
        album_error:	`Leider ist ein unbekannter Fehler aufgetreten. Bitte versuchen Sie es erneut.`,
        album_private:	`Die Anzeige dieses Zeichens ist eingeschränkt, da es privat ist. Bitte versuchen Sie es mit einem anderen Charakter.`,
        album_loading:	`Bitte warten Sie, bis die Albumkarten vollständig geladen sind.`,
        coins_not_enough:	`Sie haben nicht genügend Münzen, bitte besorgen Sie sich zuerst mehr Münzen.`,
        coins_eligible_receive:	`Der Benutzer, dem Sie ein Trinkgeld geben, ist derzeit nicht berechtigt, Trinkgelder zu erhalten.`,
        coins_sent_successfully:	`Die Tipps wurden erfolgreich versendet!`,
        coins_reached_limit:	`Leider hat dieser Ersteller heute sein Limit für Tipps erreicht. Bitte versuchen Sie es morgen noch einmal!`,
        coins_Unlock:	`Entsperren`,
        聽overtime_1:	`Fehlercode:`,
        email_placeholder:	`E-Mail`,
        email_empty:	`Bitte geben Sie Ihre E-Mail-Adresse ein`,
        email_not_valid:	`E-Mail ist ungültig`,
        email_not_valid_1:	`Bitte geben Sie Ihre E-Mail-Adresse ein`,
        email_not_valid_2:	`Die E-Mail-Adresse ist ungültig. Bitte verwenden Sie eine andere Adresse.`,
        email_not_valid_3:	`Keine E-Mail-Eingabe`,
        password_placeholder:	`Passwort`,
        password_empty:	`Bitte geben Sie das Passwort ein`,
        password_not_valid:	`Falsches Konto oder Passwort`,
        password_not_valid_1:	`Es ist ein Passwort mit mehr als 8 Zeichen erforderlich`,
        password_not_valid_2:	`Bitte erstellen Sie ein Passwort`,
        password_placeholder_1:	`Erstellen Sie Ihr Passwort`,
        password_placeholder_2:	`Bestätigen Sie Ihr Passwort`,
        password_placeholder_3:	`Neues Passwort erstellen`,
        password_placeholder_4:	`Neues Passwort bestätigen`,
        password_placeholder_5:	`Geben Sie das alte Passwort ein`,
        copy_password_empty:	`Bitte bestätigen Sie das Passwort`,
        copy_password_not_valid:	`Bitte bestätigen Sie Ihr Passwort`,
        copy_passwords_inconsistent:	`Ihre Passwortbestätigung stimmt nicht überein`,
        code_empty:	`Bitte geben Sie den Bestätigungscode ein`,
        code_not_valid:	`Ungültiger Bestätigungscode`,
        code_placeholder:	`Bestätigungscode`,
        not_received_code:	`Wenn Ihr Postfach den Bestätigungscode längere Zeit nicht erhalten hat, holen Sie sich den Bestätigungscode bitte erneut.`,
        get_first_code:	`Bitte besorgen Sie sich zuerst den Bestätigungscode.`,
        connect_your_email_placeholder:	`Verknüpfen Sie Ihre E-Mail`,
        last_name_placeholder:	`Bitte geben Sie Ihren Nachnamen ein`,
        first_name_placeholder:	`Bitte geben Sie Ihren Vornamen ein`,
        address_placeholder:	`Bitte geben Sie Ihre Adresse ein`,
        error_24901:	`Mit dem aktuellen Konto ist keine E-Mail verknüpft und die Bestellungen können nicht gefunden werden. Bitte verbinden Sie eine E-Mail.`,
        user_guide:	`Benutzerhandbuch >>`,
        download:	`Herunterladen`,
        order_number:	`Bestellnummer:`,
        Refund:	`Erstattung`,
        Disabled:	`Deaktiviert`,
        Normal:	`Normal`,
        Modify:	`Ändern`,
        Modify_1:	`Ändern>>`,
        error_20101:	`Bitte geben Sie Ihre E-Mail-Adresse ein (Fehlercode: 20101)`,
        error_20102:	`E-Mail ist ungültig (Fehlercode: 20102)`,
        error_20103:	`Anfrage fehlgeschlagen (Fehlercode: 20103). Bitte versuchen Sie es noch einmal`,
        error_20104:	`Die E-Mail-Adresse wird bereits verwendet. Bitte <a href="/de/account/login/">melden Sie sich an</a> oder registrieren Sie sich mit einer neuen`,
        error_20105:	`Anfrage fehlgeschlagen (Fehlercode: 20105). Bitte versuchen Sie es noch einmal`,
        error_20106:	`E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es erneut`,
        error_20107:	`Gelöschtes Konto. Bitte warten Sie 3 Tage oder verwenden Sie eine andere E-Mail-Adresse.`,
        error_20201:	`Bitte geben Sie Ihre E-Mail-Adresse ein (Fehlercode: 20201)`,
        error_20202:	`Bitte geben Sie Ihr Passwort ein (Fehlercode: 20202)`,
        error_20203:	`Bitte geben Sie den Bestätigungscode ein (Fehlercode: 20203)`,
        error_20204:	`E-Mail ist ungültig (Fehlercode: 20204)`,
        error_20205:	`Es ist ein Passwort mit mehr als 8 Zeichen erforderlich (Fehlercode: 20205)`,
        error_20206:	`Anfrage fehlgeschlagen (Fehlercode: 20206). Bitte versuchen Sie es noch einmal`,
        error_20207:	`Ungültiger Bestätigungscode`,
        error_20208:	`Anfrage fehlgeschlagen (Fehlercode: 20208). Bitte versuchen Sie es noch einmal`,
        error_20209:	`Anfrage fehlgeschlagen (Fehlercode: 20209). Bitte versuchen Sie es noch einmal`,
        error_20210:	`Gelöschtes Konto. Bitte warten Sie 3 Tage oder verwenden Sie eine andere E-Mail-Adresse.`,
        error_20301:	`Bitte geben Sie Ihre E-Mail-Adresse ein (Fehlercode: 20301)`,
        error_20302:	`Fehler: 20302. Bitte kontaktieren Sie uns`,
        error_20303:	`E-Mail ist ungültig (Fehlercode: 20303)`,
        error_20304:	`Anfrage fehlgeschlagen (Fehlercode: 20304). Bitte versuchen Sie es noch einmal`,
        error_20305:	`Konto existiert nicht. Bitte geben Sie es erneut ein oder <a href="/de/account/register/">erstellen Sie es zuerst</a>.`,
        error_20306:	`Sie haben noch kein Passwort festgelegt, verwenden Sie bitte die <a href="/de/account/passwordless-login/">passwortlose Anmeldung</a>.`,
        error_20308:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 20308). Bitte versuchen Sie es noch einmal`,
        error_20401:	`Abmelden fehlgeschlagen (Fehlercode: 20401). Bitte versuchen Sie es noch einmal`,
        error_20501:	`Bitte geben Sie Ihre E-Mail-Adresse ein (Fehlercode: 20501)`,
        error_20502:	`E-Mail ist ungültig (Fehlercode: 20502)`,
        error_20503:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 20503). Bitte versuchen Sie es noch einmal`,
        error_20504:	`E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es noch einmal.`,
        error_20601:	`Bitte geben Sie Ihre E-Mail-Adresse ein (Fehlercode: 20601)`,
        error_20602:	`Bitte geben Sie den Bestätigungscode ein (Fehlercode: 20602)`,
        error_20603:	`E-Mail ist ungültig (Fehlercode: 20603)`,
        error_20604:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 20604). Bitte versuchen Sie es noch einmal`,
        error_20606:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 20606). Bitte versuchen Sie es noch einmal`,
        error_20607:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 20607). Bitte versuchen Sie es noch einmal`,
        error_20608:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 20608). Bitte versuchen Sie es noch einmal`,
        error_20701:	`Bitte geben Sie Ihre E-Mail-Adresse ein (Fehlercode: 20701)`,
        error_20702:	`E-Mail ist ungültig (Fehlercode: 20702)`,
        error_20703:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 20703). Bitte versuchen Sie es noch einmal`,
        error_20704:	`Konto existiert nicht. Bitte geben Sie es erneut ein oder <a href="/de/account/register/">erstellen Sie es zuerst</a>.`,
        error_20705:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 20705). Bitte versuchen Sie es noch einmal`,
        error_20706:	`E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es noch einmal`,
        error_20801:	`Bitte geben Sie Ihre E-Mail-Adresse ein (Fehlercode: 20801)`,
        error_20802:	`Fehler: 20802. Bitte kontaktieren Sie uns`,
        error_20803:	`Bitte geben Sie den Bestätigungscode ein (Fehlercode: 20803)`,
        error_20804:	`E-Mail ist ungültig (Fehlercode: 20804)`,
        error_20805:	`Es ist ein Passwort mit mehr als 8 Zeichen erforderlich (Fehlercode: 20805)`,
        error_20806:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 20806). Bitte versuchen Sie es noch einmal`,
        error_20808:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 20808). Bitte versuchen Sie es noch einmal`,
        error_21000:	`Änderungen werden gespeichert`,
        error_21001:	`Es werden keine Informationen übermittelt (Fehlercode: 21001)`,
        error_21002:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 21002). Bitte versuchen Sie es noch einmal`,
        error_21101:	`Bitte geben Sie Ihre E-Mail-Adresse ein (Fehlercode: 21101)`,
        error_21102:	`E-Mail ist ungültig (Fehlercode: 21102)`,
        error_21103:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 21103). Bitte versuchen Sie es erneut`,
        error_21104:	`E-Mail ist bereits verbunden, bitte verwenden Sie eine neue`,
        error_21105:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 21105). Bitte versuchen Sie es erneut`,
        error_21106:	`E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es noch einmal`,
        error_21201:	`Bitte geben Sie Ihre E-Mail-Adresse ein (Fehlercode: 21201)`,
        error_21202:	`Bitte geben Sie den Bestätigungscode ein (Fehlercode: 21202)`,
        error_21203:	`E-Mail ist ungültig (Fehlercode: 21203)`,
        error_21204:	`Fehler: 21204. Bitte kontaktieren Sie uns`,
        error_21205:	`Fehler: 21205. Bitte kontaktieren Sie uns`,
        error_21206:	`Es ist ein Passwort mit mehr als 8 Zeichen erforderlich (Fehlercode: 21206)`,
        error_21207:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 21207). Bitte versuchen Sie es noch einmal`,
        error_21209:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 21209). Bitte versuchen Sie es noch einmal`,
        error_21301:	`Bitte geben Sie das alte Passwort ein (Fehlercode: 21301)`,
        error_21302:	`Bitte erstellen Sie ein neues Passwort (Fehlercode: 21302)`,
        error_21303:	`Das neue Passwort darf nicht mit dem alten identisch sein. (Fehler: 21303)`,
        error_21304:	`Es ist ein Passwort mit mehr als 8 Zeichen erforderlich (Fehlercode: 21304)`,
        error_21306:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 21306). Bitte versuchen Sie es noch einmal`,
        error_21402:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 21402). Bitte versuchen Sie es noch einmal`,
        error_21403:	`Der Bestätigungscode konnte nicht gesendet werden. Bitte senden Sie es erneut`,
        error_21500:	`Das Konto wurde gelöscht`,
        error_21501:	`Bitte geben Sie den Bestätigungscode ein (Fehlercode: 21501)`,
        error_21502:	`Die Anmeldesitzung ist abgelaufen (Fehler: 21502). Bitte melden Sie sich erneut an.`,
        error_21503:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 21503). Bitte versuchen Sie es noch einmal`,
        error_21505:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 21505). Bitte versuchen Sie es erneut`,
        error_21901:	`Fehler: 21901. Bitte kontaktieren Sie uns`,
        error_21902:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 21902). Bitte versuchen Sie es noch einmal`,
        error_21903:	`Der Kontostatus hat sich geändert (Fehlercode: 21903). Bitte aktualisieren Sie die Seite und versuchen Sie es erneut`,
        error_21904:	`Fehler: 21904. Bitte versuchen Sie es erneut`,
        error_21905:	`Fehler: 21905. Bitte versuchen Sie es erneut`,
        error_21906:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 21906). Bitte versuchen Sie es noch einmal`,
        error_21907:	`Das Google-Konto wurde mit einem anderen Konto verknüpft`,
        error_21908:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 21908). Bitte versuchen Sie es noch einmal`,
        error_22001:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 22001). Bitte versuchen Sie es noch einmal`,
        error_22002:	`Das Aufheben der Verknüpfung ist ohne zusätzliche Anmeldung fehlgeschlagen`,
        error_22003:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 22003). Bitte versuchen Sie es noch einmal`,
        error_22101:	`Fehler: 22101. Bitte kontaktieren Sie uns`,
        error_22102:	`Der Kontostatus hat sich geändert (Fehlercode: 22102). Bitte aktualisieren Sie die Seite und versuchen Sie es erneut`,
        error_22103:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 22103). Bitte versuchen Sie es noch einmal`,
        error_22104:	`Der Kontostatus hat sich geändert (Fehlercode: 22104). Bitte aktualisieren Sie die Seite und versuchen Sie es erneut`,
        error_22105:	`Fehler: 22105. Bitte versuchen Sie es erneut`,
        error_22106:	`Fehler: 22106. Bitte versuchen Sie es erneut`,
        error_22107:	`Fehler: 22107. Bitte kontaktieren Sie uns`,
        error_22108:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 22108). Bitte versuchen Sie es noch einmal`,
        error_22201:	`Fehler: 22201. Bitte kontaktieren Sie uns`,
        error_22202:	`Ungültige Verifizierung (Fehler: 22202). Bitte versuchen Sie es noch einmal.`,
        error_22203:	`Fehler: 22203. Bitte versuchen Sie es erneut.`,
        error_22204:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 22204). Bitte versuchen Sie es noch einmal`,
        error_22206:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 22206). Bitte versuchen Sie es noch einmal`,
        error_22401:	`Fehler: 22401. Bitte kontaktieren Sie uns`,
        error_22402:	`Ungültige Verifizierung (Fehler: 22402). Bitte versuchen Sie es noch einmal.`,
        error_22403:	`Fehler: 22403. Bitte versuchen Sie es erneut`,
        error_22404:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 22404). Bitte versuchen Sie es noch einmal`,
        error_22405:	`Das Facebook-Konto wurde mit einer anderen E-Mail-Adresse verknüpft`,
        error_22406:	`Fehler: 22406. Bitte versuchen Sie es erneut`,
        error_22407:	`Fehler: 22407. Bitte kontaktieren Sie uns`,
        error_22408:	`Fehler: 22408. Bitte kontaktieren Sie uns`,
        error_22409:	`Fehler: 22409. Bitte kontaktieren Sie uns`,
        error_22410:	`Fehler: 224010. Bitte kontaktieren Sie uns`,
        error_22411:	`Fehler: 224011. Bitte kontaktieren Sie uns`,
        error_22412:	`Fehler: 224012. Bitte kontaktieren Sie uns`,
        error_22413:	`Fehler: 22413. Bitte kontaktieren Sie uns`,
        error_22414:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 22414). Bitte versuchen Sie es noch einmal`,
        error_22415:	`Fehler: 22415. Bitte kontaktieren Sie uns`,
        error_22416:	`Fehler: 22416. Bitte kontaktieren Sie uns`,
        error_22417:	`Fehler: 22417. Bitte kontaktieren Sie uns`,
        error_22418:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 22418). Bitte versuchen Sie es noch einmal`,
        error_22419:	`Fehler: 22419. Bitte kontaktieren Sie uns`,
        error_22420:	`Fehler: 22420. Bitte kontaktieren Sie uns`,
        error_22421:	`Fehler: 22421. Bitte kontaktieren Sie uns`,
        error_22422:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 22422). Bitte versuchen Sie es noch einmal`,
        error_22423:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 22423). Bitte versuchen Sie es noch einmal`,
        error_22424:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 22424). Bitte versuchen Sie es noch einmal`,
        error_22425:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 22425). Bitte versuchen Sie es noch einmal`,
        error_20098:	`Fehlercode: 20098. Wenn Sie im privaten Modus surfen, wechseln Sie bitte in den normalen Modus und versuchen Sie es erneut.`,
        error_22498:	`Anfrage für Facebook fehlgeschlagen (Fehler: 22498). Bitte versuchen Sie es noch einmal.`,
        error_24902:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 24902). Bitte versuchen Sie es noch einmal`,
        error_24903:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 24903). Bitte versuchen Sie es noch einmal`,
        error_24904:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 24904). Bitte versuchen Sie es noch einmal`,
        error_24905:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 24905). Bitte versuchen Sie es noch einmal`,
        login_title:	`Melden Sie sich bei HeyReal an`,
        no_account:	`Kein Konto?`,
        create_it:	`Erstellen Sie es`,
        or_log_in_with:	`Oder loggen Sie sich mit ein`,
        passwordless_login:	`Passwortlose Anmeldung`,
        log_in_done:	`Anmelden Fertig`,
        three_rd_account_connect_info:	`Glückwunsch! Sie haben sich erfolgreich angemeldet. Jetzt können Sie ein E-Mail-Konto verbinden, mit dem Sie sich in Zukunft anmelden.`,
        connect_now:	`Jetzt verbinden`,
        see_my_account:	`Siehe mein Konto`,
        three_rd_login_merge_account:	`Die E-Mail-Adresse des Drittanbieterkontos wurde registriert. Möchten Sie sich direkt mit dieser E-Mail-Adresse verbinden und anmelden?`,
        connect_log_in:	`Verbinden und anmelden`,
        create_an_account:	`Ein Konto erstellen`,
        connect_account:	`Konto verbinden`,
        connect_account_info:	`Nach der Verbindung können Sie sich mit diesem Konto anmelden.`,
        back_to_log_in:	`Zurück zum Anmelden`,
        create_password:	`Passwort erstellen`,
        create_now:	`Jetzt erstellen`,
        password_login_subtitle:	`Passwortlose Anmeldung per E-Mail`,
        account_login:	`Kontoanmeldung`,
        rights:	`Durch die Erstellung dieses Kontos stimmen Sie den <a href="https://heyreal.ai/de/terms-and-conditions/">Nutzungsbedingungen</a> und der <a href="https://heyreal.ai/de/privacy-policy/">Datenschutzerklärung</a> zu`,
        passwordless_login_done:	`Passwortlose Anmeldung erledigt`,
        passwordless_login_info:	`Herzlichen Glückwunsch, Sie haben die passwortlose Anmeldung erfolgreich abgeschlossen. Sie können ein Passwort für dieses Konto erstellen und sich in Zukunft mit dem Konto und Passwort anmelden. <a href="/de/account/create-password/" style="display: initial;">Jetzt erstellen</a>`,
        sign_up:	`Melden Sie sich an`,
        register_info:	`Erstellen Sie Ihr Konto`,
        reset_now:	`Jetzt zurücksetzen`,
        forgot_password:	`Passwort vergessen`,
        reset_password_subtitle:	`Verwenden Sie die E-Mail-Adresse Ihres Kontos, um das Passwort zurückzusetzen`,
        plan_products:	`Plan & Produkte`,
        nick_name:	`Spitzname:`,
        email:	`E-Mail:`,
        unlink:	`Verknüpfung aufheben`,
        link:	`Link`,
        change_now:	`Jetzt ändern`,
        connect_email:	`E-Mail verbinden`,
        delete_account:	`Konto löschen`,
        delete_account_info:	`Wenn Ihr Konto gelöscht wird, werden alle mit Ihrem Konto verknüpften Daten in „Plan & Produkte“ dauerhaft gelöscht und Sie können sie möglicherweise nicht wiederherstellen. Wir empfehlen Ihnen, vorsichtig vorzugehen.`,
        Delete:	`Löschen`,
        Logout:	`Abmelden`,
        to:	`Zu`,
        footer:	`Copyright 2024 HeyReal Studio. Alle Rechte vorbehalten.`,
        google_login:	`Melden Sie sich mit Google an`,
        State:	`Zustand`,
        images:	`Bild(er)`,
        email_verification:	`E-Mail-Verifizierung`,
        email_verification_info:	`Wir haben die Bestätigungsnachricht an Ihre E-Mail-Adresse <span class="email"></span> gesendet. Bitte schließen Sie die Bestätigung ab. Nach der Überprüfung werden die Vorteile automatisch synchronisiert.`,
        error_26301:	`Fehlercode: 26301, bitte kontaktieren Sie uns`,
        error_26302:	`Fehlercode: 26302, bitte kontaktieren Sie uns`,
        error_26303:	`E-Mail-Formatfehler (Fehlercode: 26303). Bitte geben Sie es erneut ein`,
        error_26304:	`Es wird ein Passwort mit mehr als 8 Zeichen empfohlen (Fehlercode: 26304)`,
        error_26305:	`Reuqest ist fehlgeschlagen (Fehlercode: 26305). Bitte versuchen Sie es erneut`,
        error_26306:	`Die E-Mail-Adresse wurde registriert. Bitte <a href="/de/account/login/">loggen Sie sich ein</a>`,
        error_26307:	`Reuqest ist fehlgeschlagen (Fehlercode: 26307). Bitte versuchen Sie es erneut`,
        error_26308:	`Reuqest ist fehlgeschlagen (Fehlercode: 26308). Bitte versuchen Sie es erneut`,
        error_26401:	`Fehlercode: 26401, bitte versuchen Sie es erneut`,
        error_26402:	`E-Mail wurde bestätigt (Fehlercode: 26402), bitte versuchen Sie es erneut`,
        error_26403:	`Reuqest ist fehlgeschlagen (Fehlercode: 26403). Bitte versuchen Sie es erneut`,
        error_26404:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 26404). Bitte versuchen Sie es erneut`,
        error_26501:	`Fehlercode: 26501, bitte kontaktieren Sie uns`,
        error_26502:	`Fehlercode: 26502, bitte kontaktieren Sie uns`,
        error_26503:	`E-Mail-Formatfehler (Fehlercode: 26503). Bitte geben Sie es erneut ein`,
        error_26504:	`Reuqest ist fehlgeschlagen (Fehlercode: 26504). Bitte versuchen Sie es erneut`,
        error_26505:	`E-Mail wurde nicht registriert, bitte <a href="/de/account/register/">registrieren Sie sie zuerst</a>`,
        error_26506:	`E-Mail wurde bestätigt.`,
        error_26507:	`Reuqest ist fehlgeschlagen (Fehlercode: 26507). Bitte versuchen Sie es erneut`,
        error_26508:	`Verifizierung fehlgeschlagen (Fehlercode: 26508), bitte versuchen Sie es erneut`,
        error_26509:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 26509). Bitte versuchen Sie es erneut`,
        error_26510:	`Fehlercode: 26510, bitte kontaktieren Sie uns`,
        error_26601:	`Fehlercode: 26601, bitte kontaktieren Sie uns`,
        error_26602:	`Fehlercode: 26602, bitte kontaktieren Sie uns`,
        error_26603:	`Reuqest ist fehlgeschlagen (Fehlercode: 26603). Bitte versuchen Sie es erneut`,
        error_26604:	`Fehlercode: 26604, bitte kontaktieren Sie uns`,
        error_26605:	`Fehlercode: 26605, bitte kontaktieren Sie uns`,
        no_cookie:	`Sie haben die Funktion „Alle Cookies blockieren“ in Ihrem Browser aktiviert und können sich daher nicht anmelden. Gehen Sie bitte zu „Einstellungen“ und aktivieren Sie das Kontrollkästchen „Alle Cookies zulassen“.`,
        error_26801:	`Fehlercode: 26801, bitte kontaktieren Sie uns`,
        error_26802:	`Fehlercode: 26802, bitte kontaktieren Sie uns`,
        error_26803:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 26803). Bitte versuchen Sie es erneut`,
        error_26804:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 26804). Bitte versuchen Sie es erneut`,
        error_order:	`Die Anfrage ist fehlgeschlagen (Fehlercode: 27098), bitte versuchen Sie es erneut!`,
        error_order1:	`Die Bestellabfrage ist unvollständig (Fehlercode:`,
        error_order2:	`), bitte aktualisieren Sie es und versuchen Sie es erneut.`,
        modify_email_title:	`E-Mail ändern`,
        modify_email_info:	`Sie können die geänderte E-Mail-Adresse verwenden, um sich bei Ihrem Konto anzumelden.`,
        images_per:	`Bilder pro`,
        error_26101:	`Fehler: 26101. Bitte kontaktieren Sie uns`,
        error_26102:	`Fehler: 26102. Bitte kontaktieren Sie uns`,
        error_26103:	`Die Anfrage ist fehlgeschlagen (Fehlercode:26103). Bitte versuchen Sie es noch einmal`,
        error_26104:	`Fehlercode: 26104, bitte versuchen Sie es erneut`,
        error_26105:	`Fehlercode: 26105, bitte versuchen Sie es erneut`,
        error_26106:	`Das Löschen ist fehlgeschlagen (Fehlercode: 26106). Bitte versuchen Sie es noch einmal`,
        error_26201:	`Fehler: 26201. Bitte kontaktieren Sie uns`,
        error_26202:	`Die Anfrage ist fehlgeschlagen (Fehlercode:26202). Bitte versuchen Sie es noch einmal`,
        error_26001:	`Fehler: 26001. Bitte kontaktieren Sie uns`,
        error_26002:	`Fehler: 26002. Bitte kontaktieren Sie uns`,
        error_26003:	`Fehler: 26003. Bitte kontaktieren Sie uns`,
        error_26004:	`Fehler: 26004. Bitte kontaktieren Sie uns`,
        error_26005:	`Die Anfrage ist fehlgeschlagen (Fehlercode:26005). Bitte versuchen Sie es noch einmal`,
        error_26006:	`Fehlercode: 26006, bitte versuchen Sie es erneut`,
        error_26008:	`Fehler: 26008. Bitte kontaktieren Sie uns`,
        go_to_the_home_page:	`Gehen Sie zur Startseite`,
    },
    fr:{
        KEY:	`FR`,
        overtime_1:	`Code d'erreur :`,
        overtime_2:	`, veuillez réessayer`,
        isnetwork:	`Erreur Internet. Veuillez vérifier et réessayer`,
        edit_photo:	`Modifier la photo`,
        select_photo:	`Sélectionnez une photo`,
        change_photo:	`Changer de photo`,
        cancel:	`Annuler`,
        hide_password:	`Masquer le mot de passe`,
        show_password:	`Afficher le mot de passe`,
        zoom_in:	`Zoomer`,
        zoom_out:	`Zoom arrière`,
        rotate:	`Tourner`,
        horizontal_flip:	`Retournement horizontal`,
        vertical_flip:	`Retournement vertical`,
        Connect:	`Connecter`,
        unlink_success:	`Dissocier avec succès`,
        connect_success:	`Connectez-vous avec succès`,
        feedback_title:	`Merci pour vos commentaires. Veuillez laisser votre problème et nous vous répondrons dans les 24 heures.`,
        feedback_thank_you:	`Merci !<br />Vos commentaires ont été soumis avec succès.`,
        feedback_email:	`Entrez votre email ici!`,
        feedback_content:	`Laissez ici tout problème ou suggestion que vous avez rencontré.`,
        feedback_submit:	`Soumettre`,
        form_contents:	`Vous n'avez saisi aucune description. Veuillez le saisir et soumettre à nouveau.`,
        old_password:	`Veuillez saisir l'ancien mot de passe`,
        new_password:	`Veuillez créer un nouveau mot de passe`,
        old_new_password:	`Le nouveau mot de passe ne peut pas être le même que l'ancien`,
        incorrect_password:	`Mot de passe incorrect`,
        delete_no:	`Supprimer maintenant`,
        Caps:	`Le verrouillage des majuscules est activé`,
        Get:	`Obtenir`,
        Done:	`Fait`,
        error_20001:	`Erreur : 20001. Veuillez vous reconnecter.`,
        error_20002:	`Erreur : 20002. Veuillez vous reconnecter.`,
        error_20003:	`Erreur : 20003. Veuillez vous reconnecter.`,
        error_20004:	`La requête a échoué (code d'erreur : 20004). Veuillez réessayer.`,
        error_20005:	`La session de connexion a expiré (Erreur : 20005). Veuillez vous reconnecter.`,
        error_20006:	`La requête a échoué (code d'erreur : 20006). Veuillez réessayer.`,
        error_20007:	`La session de connexion a expiré (Erreur : 20007). Veuillez vous reconnecter.`,
        error_20008:	`La session de connexion a expiré (Erreur : 20008). Veuillez vous reconnecter.`,
        error_20009:	`La session de connexion a expiré (Erreur : 20009). Veuillez vous reconnecter.`,
        error_20901:	`La requête a échoué (code d'erreur : 20901). Veuillez réessayer`,
        error_20902:	`La requête a échoué (code d'erreur : 20902). Veuillez réessayer`,
        error_22298:	`La demande de Google a échoué (Erreur : 22298). Veuillez réessayer.`,
        error_21601:	`Erreur : 21601. Veuillez nous contacter`,
        error_21602:	`Vérification invalide (Erreur : 21602). Veuillez réessayer.`,
        error_21603:	`Erreur : 21603. Veuillez réessayer`,
        error_21604:	`La requête a échoué (code d'erreur : 21604). Veuillez réessayer`,
        error_21606:	`La demande a échoué (code d'erreur : 21606). Veuillez réessayer`,
        error_21611:	`La requête a échoué (code d'erreur : 21611). Veuillez réessayer`,
        error_21613:	`Inscrivez-vous trop souvent, veuillez réessayer plus tard.`,
        error_21801:	`Erreur : 21801. Veuillez nous contacter`,
        error_21802:	`La demande a échoué (Erreur : 21802). Veuillez réessayer`,
        error_21803:	`Erreur : 21803. Veuillez réessayer`,
        error_21804:	`La requête a échoué (code d'erreur : 21804). Veuillez réessayer`,
        error_21806:	`Erreur : 21806. Veuillez réessayer`,
        error_21807:	`Erreur : 21807. Veuillez nous contacter`,
        error_21808:	`Erreur : 21808. Veuillez nous contacter`,
        error_21809:	`Erreur : 21809. Veuillez nous contacter`,
        error_21810:	`Erreur : 21810. Veuillez nous contacter`,
        error_21811:	`Erreur : 21811. Veuillez nous contacter`,
        error_21812:	`Erreur : 21812. Veuillez nous contacter`,
        error_21813:	`La requête a échoué (code d'erreur : 21813). Veuillez réessayer`,
        error_21814:	`Erreur : 21814. Veuillez nous contacter`,
        error_21815:	`La demande a échoué (code d'erreur : 21815). Veuillez réessayer`,
        error_21816:	`Erreur : 21816. Veuillez nous contacter`,
        error_21817:	`Erreur : 21817. Veuillez nous contacter`,
        error_21818:	`Erreur : 21818. Veuillez nous contacter`,
        error_21819:	`La demande a échoué (code d'erreur : 21819). Veuillez réessayer`,
        error_21820:	`Erreur : 21820. Veuillez nous contacter`,
        error_21821:	`Erreur : 21821. Veuillez nous contacter`,
        error_21822:	`Erreur : 21822. Veuillez nous contacter`,
        error_21823:	`La requête a échoué (code d'erreur : 21823). Veuillez réessayer`,
        error_21824:	`La requête a échoué (code d'erreur : 21824). Veuillez réessayer`,
        error_21825:	`La requête a échoué (code d'erreur : 21825). Veuillez réessayer`,
        error_21826:	`La demande a échoué (code d'erreur : 21826). Veuillez réessayer`,
        error_21827:	`La requête a échoué (code d'erreur : 21827). Veuillez réessayer`,
        error_21828:	`Compte supprimé. Veuillez attendre 3 jours ou utiliser un autre e-mail.`,
        error_21829:	`La connexion a échoué!`,
        error_26701:	`Code d'erreur : 26701, veuillez nous contacter`,
        error_26702:	`La demande a échoué (code d'erreur : 26702). Veuillez réessayer`,
        error_26703:	`Code d'erreur : 26703, veuillez nous contacter`,
        error_26704:	`Code d'erreur : 26704, veuillez nous contacter`,
        error_26705:	`Attendez la connexion (code d'erreur : 26705). Veuillez réessayer`,
        no_code_text:	`Nous avons envoyé un code de vérification. Veuillez entrer votre code. <span class='tips'>Vous n'avez pas reçu de code ?`,
        no_code_text_1:	`1. Veuillez vous assurer que l'adresse e-mail est valide et qu'elle peut recevoir des e-mails.`,
        no_code_text_2:	`2. Étant donné que l'e-mail est envoyé automatiquement par le système, il peut être signalé comme spam ou courrier indésirable. Veuillez vérifier si l'e-mail se trouve dans le dossier Corbeille.`,
        no_code_text_3:	`3. Vous ne parvenez pas à résoudre votre problème ?`,
        no_code_text_3_span:	`Cliquez ensuite <a href="https://discord.gg/CB5W97Z9eG" rel="nofollow">ici</a> pour nous contacter.`,
        no_code_text_4_span:	`<b>Attention :</b> Après la suppression de votre compte, vous ne pourrez plus utiliser la même adresse email pour vous inscrire et vous connecter pendant 3 jours.`,
        log_in:	`Se connecter`,
        public_Network_error:	`Erreur réseau. Veuillez réessayer plus tard.`,
        public_showToast_Success:	`Succès`,
        public_showToast_Warning:	`Avertissement`,
        public_showToast_Error:	`Erreur`,
        public_showToast_1:	`Paiement réussi, profitez du chat !`,
        public_showToast_2:	`Confirmant votre paiement, veuillez revenir plus tard.`,
        public_showToast_3:	`Le paiement a échoué, veuillez réessayer ou nous contacter.`,
        public_showToast_4:	`S'il vous plaît, attendez`,
        public_showToast_5:	`Le paiement a réussi, veuillez essayer d'actualiser la page plus tard pour mettre à jour le forfait.`,
        public_showToast_6:	`Abonnement réussi. Bonne discussion !`,
        public_showToast_7:	`Annulation du renouvellement de l'abonnement réussie !`,
        public_showToast_8:	`L'annulation a échoué. Veuillez réessayer plus tard ou contactez-nous.`,
        public_showToast_9:	`Veuillez vérifier l'avis.`,
        pricing_showToast_10:	`Échec de l'accès à la page de paiement, veuillez réessayer plus tard.`,
        pricing_showToast_11:	`Impossible de trouver le plan d'abonnement, veuillez réessayer plus tard.`,
        pricing_showToast_12:	`Impossible d'obtenir les informations de votre pays, veuillez nous contacter pour résoudre le problème.`,
        pricing_showToast_13:	`Désolé, mais le basculement entre les abonnements annuels et mensuels n'est pas disponible pour le moment.`,
        pricing_showToast_14:	`Désolé, nous ne prenons pas en charge les rétrogradations d'abonnement pour le moment.`,
        pricing_Credit:	`Payer par carte de crédit`,
        pricing_Wallet:	`Payer avec un portefeuille électronique`,
        public_Achievement:	`Réalisation(s) de`,
        public_Login_Required:	`Connexion requise`,
        public_In_order:	`Pour continuer, veuillez vous connecter à votre compte.`,
        public_Network_error:	`Erreur réseau, veuillez réessayer plus tard.`,
        public_New_Character:	`Nouveau personnage`,
        public_Explore_Now:	`Explorez maintenant`,
        public_Check_Now:	`Vérifiez maintenant`,
        public_Review:	`Revoir`,
        public_Follow:	`Suivre`,
        public_Following:	`Suivant`,
        public_Unfollow:	`Ne plus suivre`,
        public_notifications:	`Aucune notification.`,
        public_Successfully_Unfollow:	`Se désabonner avec succès`,
        public_Successfully_Follow:	`Suivre avec succès`,
        public_Failed_Unlike:	`Échec de la différence avec le personnage`,
        public_Failed_Followed:	`Échec du suivi`,
        public_Successfully_Like:	`Aimer avec succès le personnage`,
        public_Successfully_Unlike:	`Avec succès contrairement au personnage`,
        public_Failed_Like:	`Je n'ai pas réussi à aimer le personnage`,
        public_too_fast:	`Ça clique trop vite. Veuillez patienter.`,
        public_Log_in_to_get:	`Connectez-vous pour obtenir`,
        public_Login_for_Achievements:	`Connectez-vous pour les réalisations`,
        public_Subscribe:	`S'abonner`,
        pricing_subscription:	`Veuillez attendre l'expiration de votre abonnement et revenir au forfait gratuit.`,
        pricing_Confirm_Payment_Completion:	`Confirmer la fin du paiement`,
        pricing_complete_the_payment:	`Veuillez finaliser le paiement dans la nouvelle fenêtre. Et complétez la liaison du compte ici après le paiement réussi.`,
        pricing_Paid:	`Payé`,
        pricing_Payment_Info_not_detected:	`Informations de paiement non détectées, veuillez réessayer plus tard ou contactez-nous via Dsicord`,
        pricing_character_finish_loading:	`Veuillez attendre que le chargement des cartes de personnage soit terminé.`,
        public_Report:	`Rapport`,
        public_Paid:	`Modifier le personnage`,
        public_Failed_Show_Achievements:	`Impossible d'afficher les réalisations`,
        public_results_create:	`Les résultats souhaités sont introuvables. Cliquez sur "créer" maintenant pour créer celui que vous aimez.`,
        public_create:	`Créer`,
        public_Views:	`Vues`,
        public_Likes:	`Goûts`,
        public_Comment:	`Commentaire`,
        public_Private:	`Privé`,
        public_Restricted_Display:	`Affichage restreint`,
        public_Under_Review:	`En cours de révision`,
                public_Claim:`Réclamer`,
                public_Resubmit:`Soumettre à nouveau`,
        public_results_not_found:	`Les résultats souhaités sont introuvables.`,
        public_story_anonymous:	`L'auteur de cette histoire est anonyme.`,
        public_no_chat_stories:	`Pas d'histoires de discussion pour l'instant, allez en créer une !`,
        public_Earn:	`Gagner`,
        public_Submit:	`Soumettre`,
        public_Unlock_My_Achievement:`Unlock My Achievement`,
        public_no_characters:	`Il n'y a aucun personnage disponible pour le moment, nous vous recommandons les personnages suivants :`,
        public_enter_character:	`Veuillez entrer le nom du personnage.`,
        public_length_characters_2:	`La longueur du nom doit être supérieure à 2 caractères.`,
        public_length_characters_3:	`Le nom doit comporter de 3 à 40 caractères.`,
        public_length_characters_40:	`La longueur du nom ne peut pas dépasser 40 caractères.`,
        public_length_characters_205:	`La description doit comporter de 5 à 200 caractères.`,
        public_length_characters_500:	`Le contenu de l'introduction est limité à un maximum de 500 caractères.`,
        public_no_Introduction:	`Pas encore d'introduction.`,
        public_Image_uploading:	`Téléchargement d'images ! Veuillez patienter une seconde.`,
        public_select_gender:	`Veuillez sélectionner le sexe du personnage.`,
        public_length_Introduction_500:	`Le contenu de l'introduction est limité à un maximum de 500 caractères.`,
        public_length_characters_200:	`Le commentaire doit comporter entre 1 et 200 caractères.`,
        public_length_characters_201:	`La description doit comporter entre 5 et 200 caractères.`,
        public_length_characters_1000:	`Le nombre maximum de caractères est de 1 000.`,
        public_length_characters_1001:	`Le message d'accueil doit comporter de 3 à 1 000 caractères.`,
        public_length_characters_4000:	`Le contenu de la personnalité doit comporter de 0 à 4 000 caractères.`,
        public_length_characters_1002:	`Le contenu du scénario doit comporter entre 0 et 1 000 caractères.`,
        public_creation_failed:	`La création du personnage a échoué, veuillez réessayer.`,
        public_Description_characters:	`La description doit comporter entre 5 et 500 caractères.`,
        public_pornographic_illegal:	`S'il vous plaît, n'utilisez pas de mots pornographiques et illégaux, sinon la génération de l'image du personnage échouera !`,
        creator_edit_description:	`L'image générée contient du contenu sensible, veuillez modifier la description et réessayer.`,
        creator_Generate_failed:	`La génération d'images a échoué !`,
        creator_exceed_10M:	`La taille de l'image ne peut pas dépasser 10 M`,
        creator_Database_Error:	`8001, Échec du traitement de la base de données`,
        creator_Save_failed:	`Échec de l'enregistrement, veuillez réessayer.`,
        bonus_Reward_Title:	`Récompense : titre limité`,
        bonus_Go_Create:	`Allez dans Créer !`,
        bonus_Earn:	`Gagner`,
        bonus_Finished:	`Fini`,
        bonus_Completed:	`Complété!`,
        bonus_Complete:	`Complet!`,
                bonus_messages:`messages`,
                bonus_image_unlock_props:`l'image se déverrouille`,
        bonus_correct_link:	`Veuillez entrer le bon lien !`,
        bonus_Get_your_title:	`Obtenez votre titre!`,
        bonus_New_achievment:	`Nouvelle réalisation terminée !`,
        bonus_submission_failed:	`Désolé, la soumission a échoué. Veuillez soumettre à nouveau.`,
        bonus_Check_in_failed:	`L'enregistrement a échoué. Veuillez réessayer plus tard.`,
        bonus_Chat_with:`Chat with various AI characters without any filter on HeyReal.ai. Input the invite code`,
        bonus_Chat_with_1:`after you sign up to get tons of free messages.`,
        recommend_Characters:	`Personnages`,
        recommend_Interactions:	`Interactions`,
        recommend_Created_by:	`Créé par :`,
        chat_story_Successfully:	`Avec succès`,
        chat_story_Failed:	`Échoué`,
        chat_story_story:	`l'histoire`,
        chat_story_like:	`Comme`,
        chat_story_unlike:	`Contrairement à`,
        chat_story_characters:	`Le commentaire ne doit pas dépasser 200 caractères.`,
        chat_story_Author:	`Auteur:`,
        character_not_info:	`Le créateur n'a laissé aucune information ici.`,
        character_hidden_details:	`Le créateur a caché les détails pertinents du personnage`,
        character_info_public:	`Le créateur n'a pas rendu cette information publique.`,
        character_restore:	`Ce personnage est restreint en raison d'images inappropriées. Modifiez pour le restaurer.`,
        character_info_1:	`Ce personnage est restreint en raison de`,
        character_info_2:	`texte et images inappropriées. Modifiez pour le restaurer.`,
        character_info_3:	`texte. Modifiez pour le restaurer.`,
        character_info_4:	`Ce personnage est en cours de révision et n'est actuellement visible que par vous-même. Il sera rendu public une fois l’examen terminé.`,
        character_View_all:	`Tout afficher`,
        character_Chat_Now:	`Discutez maintenant`,
        character_restricted:	`Ce caractère ne peut pas être affiché en raison d'une violation de nos directives relatives au contenu. Veuillez essayer un autre personnage.`,
        character_Share_Story:	`Partagez la première histoire avant tout le monde !`,
        character_Start_Chat:	`Démarrer le chat`,
        character_Edit:	`Modifier`,
        character_View_Profile:	`Afficher le profil &gt;&gt;`,
        character_Photo_Album:	`Photo album`,
        character_Successfully_Remove:	`Supprimer avec succès des favoris`,
        character_Failed_Remove:	`Échec de la suppression des favoris`,
        character_Successfully_Add:	`Ajouter avec succès aux favoris`,
        character_Failed_Add:	`Échec de l'ajout aux favoris`,
        character_info_4:	`Erreur de serveur !`,
        creator_Sever_Error:	`Erreur de serveur !`,
        public_username_is_taken:	`Ce nom d'utilisateur est pris. Veuillez en essayer un autre.`,
        public_Sever_failed:	`Échec de l'enregistrement des modifications. Veuillez réessayer.`,
        public_image_exceed_5:	`La taille de l'image ne peut pas dépasser 5M`,
        public_Something_wrong:	`Quelque chose s'est mal passé. Veuillez réessayer.`,
        public_Some_errors:	`Quelques erreurs dont nous n'avons pas connaissance !`,
        public_select_reason:	`Veuillez sélectionner la raison du rapport avant de le soumettre.`,
        public_Successful_report:	`Reportage réussi, merci pour votre contribution au milieu communautaire !`,
        public_Successful_report1:	`Rapport réussi`,
        public_Reported_too_often:	`Signalé trop souvent, veuillez réessayer plus tard !`,
        public_Reported_too_often1:	`Signalé trop souvent`,
        public_Failed_report:	`Échec du rapport`,
        public_take:`Jetez un oeil !`,
        album_Unlock:	`Ouvrir`,
        album_Chat_unlock:	`Discutez pour débloquer`,
        album_error:	`Désolé, une erreur inconnue s'est produite. Veuillez réessayer.`,
        album_private:	`Ce caractère ne peut pas être affiché car il est privé. Veuillez essayer un autre personnage.`,
        album_loading:	`Veuillez attendre que le chargement des cartes d'album soit terminé.`,
        coins_not_enough:	`Vous n'avez pas assez de pièces, veuillez d'abord en obtenir plus.`,
        coins_eligible_receive:	`L'utilisateur à qui vous donnez un pourboire n'est pas éligible pour recevoir des pourboires pour le moment.`,
        coins_sent_successfully:	`Les conseils ont été envoyés avec succès !`,
        coins_reached_limit:	`Désolé, ce créateur a atteint sa limite de conseils aujourd'hui, veuillez réessayer demain !`,
        coins_Unlock:	`Ouvrir`,
        聽overtime_1:	`Code d'erreur :`,
        email_placeholder:	`E-mail`,
        email_empty:	`Veuillez saisir votre e-mail`,
        email_not_valid:	`L'e-mail n'est pas valide`,
        email_not_valid_1:	`Veuillez saisir votre email`,
        email_not_valid_2:	`L'e-mail n'est pas valide, veuillez utiliser une autre adresse.`,
        email_not_valid_3:	`Aucune saisie d'e-mail`,
        password_placeholder:	`Mot de passe`,
        password_empty:	`Veuillez saisir le mot de passe`,
        password_not_valid:	`Compte ou mot de passe incorrect`,
        password_not_valid_1:	`Un mot de passe de plus de 8 caractères est requis`,
        password_not_valid_2:	`Veuillez créer un mot de passe`,
        password_placeholder_1:	`Créez votre mot de passe`,
        password_placeholder_2:	`Confirmez votre mot de passe`,
        password_placeholder_3:	`Créer un nouveau mot de passe`,
        password_placeholder_4:	`Confirmer le nouveau mot de passe`,
        password_placeholder_5:	`Saisir l'ancien mot de passe`,
        copy_password_empty:	`Veuillez confirmer le mot de passe`,
        copy_password_not_valid:	`Veuillez confirmer votre mot de passe`,
        copy_passwords_inconsistent:	`La confirmation de votre mot de passe ne correspond pas`,
        code_empty:	`Veuillez saisir le code de vérification`,
        code_not_valid:	`Code de vérification invalide`,
        code_placeholder:	`Le code de vérification`,
        not_received_code:	`Si votre boîte aux lettres n'a pas reçu le code de vérification depuis longtemps, veuillez récupérer le code de vérification.`,
        get_first_code:	`Veuillez d'abord obtenir le code de vérification.`,
        connect_your_email_placeholder:	`Connectez votre email`,
        last_name_placeholder:	`Veuillez entrer votre nom de famille`,
        first_name_placeholder:	`Veuillez entrer votre prénom`,
        address_placeholder:	`Veuillez entrer votre adresse`,
        error_24901:	`Le compte actuel n'a pas de courrier électronique lié et ne trouve pas les commandes. Veuillez connecter un e-mail.`,
        user_guide:	`Guide de l'utilisateur>>`,
        download:	`Télécharger`,
        order_number:	`Numéro de commande :`,
        Refund:	`Remboursement`,
        Disabled:	`Désactivé`,
        Normal:	`Normale`,
        Modify:	`Modifier`,
        Modify_1:	`Modifier>>`,
        error_20101:	`Veuillez saisir votre email (code d'erreur : 20101)`,
        error_20102:	`L'e-mail n'est pas valide (code d'erreur : 20102)`,
        error_20103:	`La requête a échoué (code d'erreur : 20103). Veuillez réessayer`,
        error_20104:	`L'adresse e-mail est déjà utilisée, veuillez vous <a href="/fr/account/login/">connectez-vous</a> ou inscrivez-vous avec une nouvelle adresse e-mail.`,
        error_20105:	`La requête a échoué (code d'erreur : 20105). Veuillez réessayer`,
        error_20106:	`Échec de l'envoi de l'e-mail, veuillez réessayer`,
        error_20107:	`Compte supprimé. Veuillez attendre 3 jours ou utiliser un autre e-mail.`,
        error_20201:	`Veuillez saisir votre email (code d'erreur : 20201)`,
        error_20202:	`Veuillez saisir votre mot de passe (code d'erreur : 20202)`,
        error_20203:	`Veuillez saisir le code de vérification (code d'erreur : 20203)`,
        error_20204:	`L'e-mail n'est pas valide (code d'erreur : 20204)`,
        error_20205:	`Un mot de passe supérieur à 8 caractères est requis (code d'erreur : 20205)`,
        error_20206:	`La demande a échoué (code d'erreur : 20206). Veuillez réessayer`,
        error_20207:	`Code de vérification invalide`,
        error_20208:	`La demande a échoué (code d'erreur : 20208). Veuillez réessayer`,
        error_20209:	`La demande a échoué (code d'erreur : 20209). Veuillez réessayer`,
        error_20210:	`Compte supprimé. Veuillez attendre 3 jours ou utiliser un autre e-mail.`,
        error_20301:	`Veuillez saisir votre email (code d'erreur : 20301)`,
        error_20302:	`Erreur : 20302. Veuillez nous contacter`,
        error_20303:	`L'e-mail n'est pas valide (code d'erreur : 20303)`,
        error_20304:	`La requête a échoué (code d'erreur : 20304). Veuillez réessayer`,
        error_20305:	`Le compte n'existe pas. Veuillez saisir à nouveau ou <a href="/fr/account/register/">Créez-le</a> d'abord.`,
        error_20306:	`Vous n'avez pas encore défini de mot de passe, veuillez utiliser la <a href="/fr/account/passwordless-login/">Connexion sans mot de passe</a>.`,
        error_20308:	`La requête a échoué (code d'erreur : 20308). Veuillez réessayer`,
        error_20401:	`Échec de la déconnexion (code d'erreur : 20401). Veuillez réessayer`,
        error_20501:	`Veuillez saisir votre email (code d'erreur : 20501)`,
        error_20502:	`L'e-mail n'est pas valide (code d'erreur : 20502)`,
        error_20503:	`La requête a échoué (code d'erreur : 20503). Veuillez réessayer`,
        error_20504:	`Échec de l'envoi de l'e-mail. Veuillez réessayer.`,
        error_20601:	`Veuillez saisir votre email (code d'erreur : 20601)`,
        error_20602:	`Veuillez saisir le code de vérification (code d'erreur : 20602)`,
        error_20603:	`L'e-mail n'est pas valide (code d'erreur : 20603)`,
        error_20604:	`La requête a échoué (code d'erreur : 20604). Veuillez réessayer`,
        error_20606:	`La requête a échoué (code d'erreur : 20606). Veuillez réessayer`,
        error_20607:	`La requête a échoué (code d'erreur : 20607). Veuillez réessayer`,
        error_20608:	`La requête a échoué (code d'erreur : 20608). Veuillez réessayer`,
        error_20701:	`Veuillez saisir votre email (code d'erreur : 20701)`,
        error_20702:	`L'e-mail n'est pas valide (code d'erreur : 20702)`,
        error_20703:	`La requête a échoué (code d'erreur : 20703). Veuillez réessayer`,
        error_20704:	`Le compte n'existe pas. Veuillez saisir à nouveau ou <a href="/fr/account/register/">Créez-le</a> d'abord.`,
        error_20705:	`La demande a échoué (code d'erreur : 20705). Veuillez réessayer`,
        error_20706:	`Échec de l'envoi de l'e-mail. Veuillez réessayer`,
        error_20801:	`Veuillez saisir votre email (code d'erreur : 20801)`,
        error_20802:	`Erreur : 20802. Veuillez nous contacter`,
        error_20803:	`Veuillez saisir le code de vérification (code d'erreur : 20803)`,
        error_20804:	`L'e-mail n'est pas valide (code d'erreur : 20804)`,
        error_20805:	`Un mot de passe supérieur à 8 caractères est requis (code d'erreur : 20805)`,
        error_20806:	`La requête a échoué (code d'erreur : 20806). Veuillez réessayer`,
        error_20808:	`La demande a échoué (code d'erreur : 20808). Veuillez réessayer`,
        error_21000:	`Les modifications sont enregistrées`,
        error_21001:	`Aucune information n'est soumise (code d'erreur : 21001)`,
        error_21002:	`La requête a échoué (code d'erreur : 21002). Veuillez réessayer`,
        error_21101:	`Veuillez saisir votre email (code d'erreur : 21101)`,
        error_21102:	`L'e-mail n'est pas valide (code d'erreur : 21102)`,
        error_21103:	`La requête a échoué (code d'erreur : 21103), veuillez réessayer`,
        error_21104:	`L'e-mail est déjà connecté, veuillez en utiliser un nouveau`,
        error_21105:	`La requête a échoué (code d'erreur : 21105), veuillez réessayer`,
        error_21106:	`Échec de l'envoi de l'e-mail. Veuillez réessayer`,
        error_21201:	`Veuillez saisir votre email (code d'erreur : 21201)`,
        error_21202:	`Veuillez saisir le code de vérification (code d'erreur : 21202)`,
        error_21203:	`L'e-mail n'est pas valide (code d'erreur : 21203)`,
        error_21204:	`Erreur : 21204. Veuillez nous contacter`,
        error_21205:	`Erreur : 21205. Veuillez nous contacter`,
        error_21206:	`Un mot de passe supérieur à 8 caractères est requis (code d'erreur : 21206)`,
        error_21207:	`La demande a échoué (code d'erreur : 21207). Veuillez réessayer`,
        error_21209:	`La demande a échoué (code d'erreur : 21209). Veuillez réessayer`,
        error_21301:	`Veuillez saisir l'ancien mot de passe (code d'erreur : 21301)`,
        error_21302:	`Veuillez créer un nouveau mot de passe (code d'erreur : 21302)`,
        error_21303:	`Le nouveau mot de passe ne peut pas être le même que l'ancien. (Erreur : 21303)`,
        error_21304:	`Un mot de passe supérieur à 8 caractères est requis (code d'erreur : 21304)`,
        error_21306:	`La demande a échoué (code d'erreur : 21306). Veuillez réessayer`,
        error_21402:	`La requête a échoué (code d'erreur : 21402). Veuillez réessayer`,
        error_21403:	`Échec de l'envoi du code de vérification. Veuillez le renvoyer`,
        error_21500:	`Le compte a été supprimé`,
        error_21501:	`Veuillez saisir le code de vérification (code d'erreur : 21501)`,
        error_21502:	`La session de connexion a expiré (Erreur : 21502). Veuillez vous reconnecter.`,
        error_21503:	`La demande a échoué (code d'erreur : 21503). Veuillez réessayer`,
        error_21505:	`La requête a échoué (code d'erreur : 21505), veuillez réessayer`,
        error_21901:	`Erreur : 21901. Veuillez nous contacter`,
        error_21902:	`La requête a échoué (code d'erreur : 21902). Veuillez réessayer`,
        error_21903:	`Le statut du compte a changé (code d'erreur : 21903), veuillez actualiser la page et réessayer`,
        error_21904:	`Erreur : 21904. Veuillez réessayer`,
        error_21905:	`Erreur : 21905. Veuillez réessayer`,
        error_21906:	`La demande a échoué (code d'erreur : 21906). Veuillez réessayer`,
        error_21907:	`Le compte Google a été lié à un autre compte`,
        error_21908:	`La requête a échoué (code d'erreur : 21908). Veuillez réessayer`,
        error_22001:	`La requête a échoué (code d'erreur : 22001). Veuillez réessayer`,
        error_22002:	`La dissociation a échoué sans connexion supplémentaire`,
        error_22003:	`La requête a échoué (code d'erreur : 22003). Veuillez réessayer`,
        error_22101:	`Erreur : 22101. Veuillez nous contacter`,
        error_22102:	`Le statut du compte a changé (code d'erreur : 22102), veuillez actualiser la page et réessayer`,
        error_22103:	`La requête a échoué (code d'erreur : 22103). Veuillez réessayer`,
        error_22104:	`Le statut du compte a changé (code d'erreur : 22104), veuillez actualiser la page et réessayer`,
        error_22105:	`Erreur : 22105. Veuillez réessayer`,
        error_22106:	`Erreur : 22106. Veuillez réessayer`,
        error_22107:	`Erreur : 22107. Veuillez nous contacter`,
        error_22108:	`La demande a échoué (code d'erreur : 22108). Veuillez réessayer`,
        error_22201:	`Erreur : 22201. Veuillez nous contacter`,
        error_22202:	`Vérification invalide (Erreur : 22202). Veuillez réessayer.`,
        error_22203:	`Erreur : 22203. Veuillez réessayer »`,
        error_22204:	`La requête a échoué (code d'erreur : 22204). Veuillez réessayer`,
        error_22206:	`La requête a échoué (code d'erreur : 22206). Veuillez réessayer`,
        error_22401:	`Erreur : 22401. Veuillez nous contacter`,
        error_22402:	`Vérification invalide (Erreur : 22402). Veuillez réessayer.`,
        error_22403:	`Erreur : 22403. Veuillez réessayer`,
        error_22404:	`La requête a échoué (code d'erreur : 22404). Veuillez réessayer`,
        error_22405:	`Le compte Facebook a été lié à un autre e-mail`,
        error_22406:	`Erreur : 22406. Veuillez réessayer`,
        error_22407:	`Erreur : 22407. Veuillez nous contacter`,
        error_22408:	`Erreur : 22408. Veuillez nous contacter`,
        error_22409:	`Erreur : 22409. Veuillez nous contacter`,
        error_22410:	`Erreur : 224010. Veuillez nous contacter`,
        error_22411:	`Erreur : 224011. Veuillez nous contacter`,
        error_22412:	`Erreur : 224012. Veuillez nous contacter`,
        error_22413:	`Erreur : 22413. Veuillez nous contacter`,
        error_22414:	`La requête a échoué (code d'erreur : 22414). Veuillez réessayer`,
        error_22415:	`Erreur : 22415. Veuillez nous contacter`,
        error_22416:	`Erreur : 22416. Veuillez nous contacter`,
        error_22417:	`Erreur : 22417. Veuillez nous contacter`,
        error_22418:	`La requête a échoué (code d'erreur : 22418). Veuillez réessayer`,
        error_22419:	`Erreur : 22419. Veuillez nous contacter`,
        error_22420:	`Erreur : 22420. Veuillez nous contacter`,
        error_22421:	`Erreur : 22421. Veuillez nous contacter`,
        error_22422:	`La requête a échoué (code d'erreur : 22422). Veuillez réessayer`,
        error_22423:	`La requête a échoué (code d'erreur : 22423). Veuillez réessayer`,
        error_22424:	`La demande a échoué (code d'erreur : 22424). Veuillez réessayer`,
        error_22425:	`La requête a échoué (code d'erreur : 22425). Veuillez réessayer`,
        error_20098:	`Code d'erreur : 20098. Si vous naviguez en mode Privé, veuillez passer en mode Normal et réessayer.`,
        error_22498:	`La demande d'accès à Facebook a échoué (Erreur : 22498). Veuillez réessayer.`,
        error_24902:	`La requête a échoué (code d'erreur : 24902). Veuillez réessayer`,
        error_24903:	`La requête a échoué (code d'erreur : 24903). Veuillez réessayer`,
        error_24904:	`La requête a échoué (code d'erreur : 24904). Veuillez réessayer`,
        error_24905:	`La demande a échoué (code d'erreur : 24905). Veuillez réessayer`,
        login_title:	`Connectez-vous à HeyReal`,
        no_account:	`Pas de compte ?`,
        create_it:	`Créez-le`,
        or_log_in_with:	`Ou connectez-vous avec`,
        passwordless_login:	`Connexion sans mot de passe`,
        log_in_done:	`Connexion terminée`,
        three_rd_account_connect_info:	`Félicitations! Vous vous êtes connecté avec succès. Vous pouvez désormais connecter un compte de messagerie qui sera utilisé pour vous connecter ultérieurement.`,
        connect_now:	`Connectez-vous maintenant`,
        see_my_account:	`Voir mon compte`,
        three_rd_login_merge_account:	`L'adresse e-mail du compte tiers a été enregistrée, souhaitez-vous vous connecter et vous connecter directement avec cette adresse e-mail ?`,
        connect_log_in:	`Se connecter et se connecter`,
        create_an_account:	`Créer un compte`,
        connect_account:	`Connecter le compte`,
        connect_account_info:	`Après vous être connecté, vous pouvez vous connecter avec ce compte.`,
        back_to_log_in:	`Retour pour me connecter`,
        create_password:	`Créer un mot de passe`,
        create_now:	`Créer maintenant`,
        password_login_subtitle:	`Connexion sans mot de passe avec e-mail`,
        account_login:	`Connexion au compte`,
        rights:	`En créant ce compte, vous acceptez les <a href="https://heyreal.ai/fr/terms-and-conditions/">Conditions d'utilisation</a> et la <a href="https://heyreal.ai/fr/privacy-policy/">Politique de confidentialité</a>`,
        passwordless_login_done:	`Connexion sans mot de passe effectuée`,
        passwordless_login_info:	`Félicitations, vous avez réussi la connexion sans mot de passe. Vous pouvez créer un mot de passe pour ce compte et vous connecter avec le compte et le mot de passe à l'avenir. <a href="/fr/account/create-password/" style="display: initial;">Créer maintenant</a>`,
        sign_up:	`S'inscrire`,
        register_info:	`Créez votre compte`,
        reset_now:	`Réinitialiser maintenant`,
        forgot_password:	`Mot de passe oublié`,
        reset_password_subtitle:	`Utilisez l'e-mail de votre compte pour réinitialiser le mot de passe`,
        plan_products:	`Plans et produits`,
        nick_name:	`Surnom:`,
        email:	`E-mail:`,
        unlink:	`Dissocier`,
        link:	`Lien`,
        change_now:	`Changer maintenant`,
        connect_email:	`Connecter l'e-mail`,
        delete_account:	`Supprimer le compte`,
        delete_account_info:	`Lorsque votre compte est supprimé, toutes les données du forfait et des produits associés à votre compte seront définitivement supprimées et vous ne pourrez peut-être pas les récupérer. Nous vous recommandons d’y aller avec prudence.`,
        Delete:	`Supprimer`,
        Logout:	`Déconnexion`,
        to:	`à`,
        footer:	`Copyright © 2024 HeyReal Studio. Tous droits réservés.`,
        google_login:	`Connectez-vous avec Google`,
        State:	`État`,
        images:	`image(s)`,
        email_verification:	`Vérification par e-mail`,
        email_verification_info:	`Nous avons envoyé le message de vérification à votre adresse e-mail <span class="email"></span> et veuillez terminer la vérification. Après vérification, les avantages seront automatiquement synchronisés.`,
        error_26301:	`Code d'erreur : 26301, veuillez nous contacter`,
        error_26302:	`Code d'erreur : 26302, veuillez nous contacter`,
        error_26303:	`Erreur de format d'e-mail (code d'erreur : 26303). Veuillez le saisir à nouveau`,
        error_26304:	`Un mot de passe supérieur à 8 caractères est recommandé (code d'erreur : 26304)`,
        error_26305:	`La demande a échoué (code d'erreur : 26305). Veuillez réessayer`,
        error_26306:	`L'e-mail a été enregistré, veuillez <a href="/fr/account/login/">vous connecter</a>`,
        error_26307:	`La demande a échoué (code d'erreur : 26307). Veuillez réessayer`,
        error_26308:	`La demande a échoué (code d'erreur : 26308). Veuillez réessayer`,
        error_26401:	`Code d'erreur : 26401, veuillez réessayer`,
        error_26402:	`L'e-mail a été vérifié (code d'erreur : 26402), veuillez réessayer`,
        error_26403:	`La demande a échoué (code d'erreur : 26403). Veuillez réessayer`,
        error_26404:	`La requête a échoué (code d'erreur : 26404). Veuillez réessayer`,
        error_26501:	`Code d'erreur : 26501, veuillez nous contacter`,
        error_26502:	`Code d'erreur : 26502, veuillez nous contacter`,
        error_26503:	`Erreur de format d'e-mail (code d'erreur : 26503). Veuillez le saisir à nouveau`,
        error_26504:	`La demande a échoué (code d'erreur : 26504). Veuillez réessayer`,
        error_26505:	`L'e-mail n'a pas été enregistré, veuillez <a href="/fr/account/register/">enregistrer-le d'abord</a>`,
        error_26506:	`L'e-mail a été vérifié.`,
        error_26507:	`La demande a échoué (code d'erreur : 26507). Veuillez réessayer`,
        error_26508:	`Vérification validée (code d'erreur : 26508), veuillez réessayer`,
        error_26509:	`La demande a échoué (code d'erreur : 26509), veuillez réessayer`,
        error_26510:	`Code d'erreur : 26510, veuillez nous contacter`,
        error_26601:	`Code d'erreur : 26601, veuillez nous contacter`,
        error_26602:	`Code d'erreur : 26602, veuillez nous contacter`,
        error_26603:	`La demande a échoué (code d'erreur : 26603). Veuillez réessayer`,
        error_26604:	`Code d'erreur : 26604, veuillez nous contacter`,
        error_26605:	`Code d'erreur : 26605, veuillez nous contacter`,
        no_cookie:	`Vous avez activé la fonction Bloquer tous les cookies dans votre navigateur, vous ne pouvez donc pas vous connecter. Veuillez vous rendre dans Paramètres pour cocher la case Autoriser tous les cookies.`,
        error_26801:	`Code d'erreur : 26801, veuillez nous contacter`,
        error_26802:	`Code d'erreur : 26802, veuillez nous contacter`,
        error_26803:	`La requête a échoué (code d'erreur : 26803). Veuillez réessayer`,
        error_26804:	`La requête a échoué (code d'erreur : 26804). Veuillez réessayer`,
        error_order:	`La requête a échoué (code d'erreur : 27098), veuillez réessayer !`,
        error_order1:	`La requête de commande est incomplète (code d'erreur :`,
        error_order2:	`), veuillez actualiser et réessayer.`,
        modify_email_title:	`Modifier l'e-mail`,
        modify_email_info:	`Vous pouvez utiliser l'e-mail modifié pour vous connecter à votre compte.`,
        images_per:	`Images par`,
        error_26101:	`Erreur : 26101. Veuillez nous contacter`,
        error_26102:	`Erreur : 26102. Veuillez nous contacter`,
        error_26103:	`La demande a échoué (code d'erreur : 26103). Veuillez réessayer`,
        error_26104:	`Code d'erreur : 26104, veuillez réessayer`,
        error_26105:	`Code d'erreur : 26105, veuillez réessayer`,
        error_26106:	`Échec de la suppression (code d'erreur : 26106). Veuillez réessayer`,
        error_26201:	`Erreur : 26201. Veuillez nous contacter`,
        error_26202:	`La demande a échoué (code d'erreur : 26202). Veuillez réessayer`,
        error_26001:	`Erreur : 26001. Veuillez nous contacter`,
        error_26002:	`Erreur : 26002. Veuillez nous contacter`,
        error_26003:	`Erreur : 26003. Veuillez nous contacter`,
        error_26004:	`Erreur : 26004. Veuillez nous contacter`,
        error_26005:	`La demande a échoué (code d'erreur : 26005). Veuillez réessayer`,
        error_26006:	`Code d'erreur : 26006, veuillez réessayer`,
        error_26008:	`Erreur : 26008. Veuillez nous contacter`,
        go_to_the_home_page:	`Accédez à la page d'accueil`,
    },
    pt:{
        overtime_1:	`Código de erro:`,
        overtime_2:	`, por favor tente novamente`,
        isnetwork:	`Erro na Internet. Verifique e tente novamente`,
        edit_photo:	`Editar foto`,
        select_photo:	`Selecione a foto`,
        change_photo:	`Alterar foto`,
        cancel:	`Cancelar`,
        hide_password:	`Ocultar senha`,
        show_password:	`Mostrar senha`,
        zoom_in:	`Ampliar`,
        zoom_out:	`Diminuir zoom`,
        rotate:	`Girar`,
        horizontal_flip:	`Inversão horizontal`,
        vertical_flip:	`Inversão vertical`,
        Connect:	`Conectar`,
        unlink_success:	`Desvincular com sucesso`,
        connect_success:	`Conecte-se com sucesso`,
        feedback_title:	`Obrigado pelo seu feedback. Deixe seu problema e responderemos em até 24 horas.`,
        feedback_thank_you:	`Obrigado!<br />Seu feedback foi enviado com sucesso.`,
        feedback_email:	`Digite seu e-mail aqui!`,
        feedback_content:	`Deixe aqui qualquer problema ou sugestão que você encontrou.`,
        feedback_submit:	`Enviar`,
        form_contents:	`Você não inseriu nenhuma descrição. Por favor, insira-o e envie novamente.`,
        old_password:	`Por favor insira a senha antiga`,
        new_password:	`Por favor crie uma nova senha`,
        old_new_password:	`A nova senha não pode ser igual à antiga`,
        incorrect_password:	`Senha incorreta`,
        delete_no:	`Excluir agora`,
        Caps:	`O Caps Lock está ativado`,
        Get:	`Pegar`,
        Done:	`Feito`,
        error_20001:	`Erro: 20001. Faça login novamente.`,
        error_20002:	`Erro: 20002. Faça login novamente.`,
        error_20003:	`Erro: 20003. Faça login novamente.`,
        error_20004:	`Falha na solicitação (código de erro: 20004). Por favor, tente novamente.`,
        error_20005:	`A sessão de login expirou (Erro: 20005). Faça login novamente.`,
        error_20006:	`Falha na solicitação (código de erro: 20006). Por favor, tente novamente.`,
        error_20007:	`A sessão de login expirou (Erro: 20007). Faça login novamente.`,
        error_20008:	`A sessão de login expirou (Erro: 20008). Faça login novamente.`,
        error_20009:	`A sessão de login expirou (Erro: 20009). Faça login novamente.`,
        error_20901:	`Falha na solicitação (código de erro: 20901). Por favor, tente novamente`,
        error_20902:	`Falha na solicitação (código de erro: 20902). Por favor, tente novamente`,
        error_22298:	`Falha na solicitação do Google (Erro: 22298). Por favor, tente novamente.`,
        error_21601:	`Erro: 21601. Entre em contato conosco`,
        error_21602:	`Verificação inválida (Erro: 21602). Por favor, tente novamente.`,
        error_21603:	`Erro: 21603. Tente novamente`,
        error_21604:	`Falha na solicitação (código de erro: 21604). Por favor, tente novamente`,
        error_21606:	`Falha na solicitação (código de erro: 21606). Por favor, tente novamente`,
        error_21611:	`Falha na solicitação (código de erro: 21611). Por favor, tente novamente`,
        error_21613:	`Inscreva-se com muita frequência. Tente novamente mais tarde.`,
        error_21801:	`Erro: 21801. Entre em contato conosco`,
        error_21802:	`Falha na solicitação (Erro: 21802). Por favor, tente novamente`,
        error_21803:	`Erro: 21803. Tente novamente`,
        error_21804:	`Falha na solicitação (código de erro: 21804). Por favor, tente novamente`,
        error_21806:	`Erro: 21806. Tente novamente`,
        error_21807:	`Erro: 21807. Entre em contato conosco`,
        error_21808:	`Erro: 21808. Entre em contato conosco`,
        error_21809:	`Erro: 21809. Entre em contato conosco`,
        error_21810:	`Erro: 21810. Entre em contato conosco`,
        error_21811:	`Erro: 21811. Entre em contato conosco`,
        error_21812:	`Erro: 21812. Entre em contato conosco`,
        error_21813:	`Falha na solicitação (código de erro: 21813). Por favor, tente novamente`,
        error_21814:	`Erro: 21814. Entre em contato conosco`,
        error_21815:	`Falha na solicitação (código de erro: 21815). Por favor, tente novamente`,
        error_21816:	`Erro: 21816. Entre em contato conosco`,
        error_21817:	`Erro: 21817. Entre em contato conosco`,
        error_21818:	`Erro: 21818. Entre em contato conosco`,
        error_21819:	`Falha na solicitação (código de erro: 21819). Por favor, tente novamente`,
        error_21820:	`Erro: 21820. Entre em contato conosco`,
        error_21821:	`Erro: 21821. Entre em contato conosco`,
        error_21822:	`Erro: 21822. Entre em contato conosco`,
        error_21823:	`Falha na solicitação (código de erro: 21823). Por favor, tente novamente`,
        error_21824:	`Falha na solicitação (código de erro: 21824). Por favor, tente novamente`,
        error_21825:	`Falha na solicitação (código de erro: 21825). Por favor, tente novamente`,
        error_21826:	`Falha na solicitação (código de erro: 21826). Por favor, tente novamente`,
        error_21827:	`Falha na solicitação (código de erro: 21827). Por favor, tente novamente`,
        error_21828:	`Conta excluída. Aguarde 3 dias ou use outro e-mail.`,
        error_21829:	`Falha no login!`,
        error_26701:	`Código de erro: 26701, entre em contato conosco`,
        error_26702:	`Reuqest falhou (código de erro: 26702). Por favor, tente novamente`,
        error_26703:	`Código de erro: 26703, entre em contato conosco`,
        error_26704:	`Código de erro: 26704, entre em contato conosco`,
        error_26705:	`Aguarde o login (código de erro: 26705). Por favor, tente novamente`,
        no_code_text:	`Enviamos um código de verificação. Por favor, insira seu código. <span class='tips'>Não recebeu um código?`,
        no_code_text_1:	`1. Certifique-se de que o endereço de e-mail seja válido e possa receber e-mails.`,
        no_code_text_2:	`2. Como o e-mail é enviado automaticamente pelo sistema, ele pode ser sinalizado como spam ou lixo eletrônico. Verifique se o e-mail está na pasta Lixeira.`,
        no_code_text_3:	`3. Não consegue resolver seu problema?`,
        no_code_text_3_span:	`Em seguida, clique <a href="https://discord.gg/CB5W97Z9eG" rel="nofollow">aqui</a> para entrar em contato conosco.`,
        no_code_text_4_span:	`<b>Atenção:</b> Após excluir sua conta, você não poderá usar o mesmo e-mail para se registrar e fazer login por 3 dias.`,
        log_in:	`Conecte-se`,
        public_Network_error:	`Erro de rede. Por favor, tente novamente mais tarde.`,
        public_showToast_Success:	`Sucesso`,
        public_showToast_Warning:	`Aviso`,
        public_showToast_Error:	`Erro`,
        public_showToast_1:	`Pagamento realizado com sucesso, aproveite o chat!`,
        public_showToast_2:	`Confirmando seu pagamento, volte mais tarde.`,
        public_showToast_3:	`Falha no pagamento, tente novamente ou entre em contato conosco.`,
        public_showToast_4:	`Por favor, aguarde`,
        public_showToast_5:	`O pagamento foi realizado com sucesso. Tente atualizar a página mais tarde para atualizar o plano.`,
        public_showToast_6:	`Assinatura com sucesso. Aproveite o bate-papo!`,
        public_showToast_7:	`Cancelamento da renovação da assinatura com sucesso!`,
        public_showToast_8:	`Falha no cancelamento. Por favor, tente novamente mais tarde ou entre em contato conosco.`,
        public_showToast_9:	`Por favor, verifique o aviso.`,
        pricing_showToast_10:	`Falha ao acessar a página de pagamento. Tente novamente mais tarde.`,
        pricing_showToast_11:	`Não foi possível encontrar o plano de assinatura. Tente novamente mais tarde.`,
        pricing_showToast_12:	`Não foi possível obter as informações do seu país, entre em contato conosco para resolver o problema.`,
        pricing_showToast_13:	`Desculpe, mas a alternância entre assinaturas anuais e mensais não está disponível no momento.`,
        pricing_showToast_14:	`Desculpe, não oferecemos suporte para downgrades de assinatura no momento.`,
        pricing_Credit:	`Pague com cartão de crédito`,
        pricing_Wallet:	`Pague com carteira eletrônica`,
        public_Achievement:	`Conquista(s)`,
        public_Login_Required:	`Login obrigatório`,
        public_In_order:	`Para prosseguir, faça login em sua conta.`,
        public_Network_error:	`Erro de rede. Tente novamente mais tarde.`,
        public_New_Character:	`Novo personagem`,
        public_Explore_Now:	`Explorar agora`,
        public_Check_Now:	`Verifique agora`,
        public_Review:	`Análise`,
        public_Follow:	`Seguir`,
        public_Following:	`Seguindo`,
        public_Unfollow:	`Deixar de seguir`,
        public_notifications:	`Sem notificações.`,
        public_Successfully_Unfollow:	`Deixar de seguir com sucesso`,
        public_Successfully_Follow:	`Seguir com sucesso`,
        public_Failed_Unlike:	`Falha ao Diferente do Personagem`,
        public_Failed_Followed:	`Falha ao seguir`,
        public_Successfully_Like:	`Curtir o personagem com sucesso`,
        public_Successfully_Unlike:	`Diferentemente do personagem com sucesso`,
        public_Failed_Like:	`Não gostei do personagem`,
        public_too_fast:	`Está clicando muito rápido. Por favor, espere.`,
        public_Log_in_to_get:	`Faça login para obter`,
        public_Login_for_Achievements:	`Login para conquistas`,
        public_Subscribe:	`Inscrever-se`,
        pricing_subscription:	`Aguarde até que sua assinatura expire e retorne ao plano gratuito.`,
        pricing_Confirm_Payment_Completion:	`Confirmar conclusão do pagamento`,
        pricing_complete_the_payment:	`Por favor, conclua o pagamento na nova janela. E conclua a vinculação da conta aqui após o pagamento bem-sucedido.`,
        pricing_Paid:	`Pago`,
        pricing_Payment_Info_not_detected:	`Informações de pagamento não detectadas, tente novamente mais tarde ou entre em contato conosco através do Dsicord`,
        pricing_character_finish_loading:	`Aguarde até que os cartões de personagem terminem de carregar.`,
        public_Report:	`Relatório`,
        public_Paid:	`Editar personagem`,
        public_Failed_Show_Achievements:	`Falha ao mostrar as conquistas`,
        public_results_create:	`Os resultados que você deseja não foram encontrados. Clique em "criar" agora para criar o que você gosta.`,
        public_create:	`Criar`,
        public_Views:	`Visualizações`,
        public_Likes:	`Curtidas`,
        public_Comment:	`Comentário`,
        public_Private:	`Privado`,
        public_Restricted_Display:	`Exibição restrita`,
        public_Under_Review:	`Em revisão`,
                public_Claim:`Alegar`,
                public_Resubmit:`Reenviar`,
        public_results_not_found:	`Os resultados que você deseja não foram encontrados.`,
        public_story_anonymous:	`O autor desta história é anônimo.`,
        public_no_chat_stories:	`Não há histórias de bate-papo por enquanto, crie uma!`,
        public_Earn:	`Ganhar`,
        public_Submit:	`Enviar`,
        public_Unlock_My_Achievement:`Unlock My Achievement`,
        public_no_characters:	`Não há personagens disponíveis no momento, recomendamos os seguintes personagens para você:`,
        public_enter_character:	`Por favor insira o nome do personagem.`,
        public_length_characters_2:	`O comprimento do nome deve ser superior a 2 caracteres.`,
        public_length_characters_3:	`O nome deve ter de 3 a 40 caracteres.`,
        public_length_characters_40:	`O comprimento do nome não pode exceder 40 caracteres.`,
        public_length_characters_205:	`A descrição deve ter de 5 a 200 caracteres.`,
        public_length_characters_500:	`O conteúdo da introdução é limitado a um máximo de 500 caracteres.`,
        public_no_Introduction:	`Nenhuma introdução ainda.`,
        public_Image_uploading:	`Carregamento de imagem! Por favor, espere um segundo.`,
        public_select_gender:	`Selecione o gênero do personagem.`,
        public_length_Introduction_500:	`O conteúdo da introdução é limitado a um máximo de 500 caracteres.`,
        public_length_characters_200:	`O comentário deve ter de 1 a 200 caracteres.`,
        public_length_characters_201:	`A descrição deve ter de 5 a 200 caracteres.`,
        public_length_characters_1000:	`O número máximo de caracteres é 1000.`,
        public_length_characters_1001:	`A saudação deve ter de 3 a 1000 caracteres.`,
        public_length_characters_4000:	`O conteúdo da personalidade deve ter de 0 a 4.000 caracteres.`,
        public_length_characters_1002:	`O conteúdo do cenário deve ter de 0 a 1.000 caracteres.`,
        public_creation_failed:	`Falha na criação do personagem. Tente novamente.`,
        public_Description_characters:	`A descrição deve ter de 5 a 500 caracteres.`,
        public_pornographic_illegal:	`Por favor, não use palavras pornográficas e ilegais, caso contrário a geração da imagem do personagem falhará!`,
        creator_edit_description:	`A imagem gerada contém conteúdo confidencial. Edite a descrição e tente novamente.`,
        creator_Generate_failed:	`Falha ao gerar imagens!`,
        creator_exceed_10M:	`O tamanho da imagem não pode exceder 10M`,
        creator_Database_Error:	`8001, falha no processamento do banco de dados`,
        creator_Save_failed:	`Falha ao salvar, tente novamente.`,
        bonus_Reward_Title:	`Recompensa: Título Limitado`,
        bonus_Go_Create:	`Vá para Criar!`,
        bonus_Earn:	`Ganhar`,
        bonus_Finished:	`Finalizado`,
        bonus_Completed:	`Concluído!`,
        bonus_Complete:	`Completo!`,
                bonus_messages:`mensagens`,
                bonus_image_unlock_props:`desbloqueio de imagem`,
        bonus_correct_link:	`Por favor insira o link correto!`,
        bonus_Get_your_title:	`Obtenha seu título!`,
        bonus_New_achievment:	`Nova conquista concluída!`,
        bonus_submission_failed:	`Desculpe, o envio falhou. Por favor reenvie.`,
        bonus_Check_in_failed:	`Falha no check-in. Por favor, tente novamente mais tarde.`,
        bonus_Chat_with:`Chat with various AI characters without any filter on HeyReal.ai. Input the invite code`,
        bonus_Chat_with_1:`after you sign up to get tons of free messages.`,
        recommend_Characters:	`Personagens`,
        recommend_Interactions:	`Interações`,
        recommend_Created_by:	`Criado por:`,
        chat_story_Successfully:	`Com sucesso`,
        chat_story_Failed:	`Fracassado`,
        chat_story_story:	`a história`,
        chat_story_like:	`Como`,
        chat_story_unlike:	`Diferente`,
        chat_story_characters:	`O comentário não deve ter mais de 200 caracteres.`,
        chat_story_Author:	`Autor:`,
        character_not_info:	`O criador não deixou nenhuma informação aqui.`,
        character_hidden_details:	`O criador ocultou os detalhes relevantes do personagem`,
        character_info_public:	`O criador não tornou esta informação pública.`,
        character_restore:	`Este personagem é restrito devido a imagens inadequadas. Edite para restaurá-lo.`,
        character_info_1:	`Este personagem é restrito por causa de`,
        character_info_2:	`texto e imagens inadequadas. Edite para restaurá-lo.`,
        character_info_3:	`texto. Edite para restaurá-lo.`,
        character_info_4:	`Este personagem está em revisão e atualmente só está visível para você. Ele será tornado público assim que a revisão for concluída.`,
        character_View_all:	`Ver tudo`,
        character_Chat_Now:	`Converse agora`,
        character_restricted:	`A exibição deste caractere está restrita devido à violação de nossas diretrizes de conteúdo. Por favor, tente outro personagem.`,
        character_Share_Story:	`Compartilhe a primeira história antes de todos!`,
        character_Start_Chat:	`Iniciar bate-papo`,
        character_Edit:	`Editar`,
        character_View_Profile:	`Ver perfil &gt;&gt;`,
        character_Photo_Album:	`Álbum de fotos`,
        character_Successfully_Remove:	`Remover com sucesso dos favoritos`,
        character_Failed_Remove:	`Falha ao remover dos favoritos`,
        character_Successfully_Add:	`Adicionar com sucesso aos favoritos`,
        character_Failed_Add:	`Falha ao adicionar aos favoritos`,
        character_info_4:	`Erro de servidor!`,
        creator_Sever_Error:	`Erro de servidor!`,
        public_username_is_taken:	`Este nome de usuário já está em uso. Por favor, tente outro.`,
        public_Sever_failed:	`Falha ao salvar as alterações. Tente novamente.`,
        public_image_exceed_5:	`O tamanho da imagem não pode exceder 5M`,
        public_Something_wrong:	`Algo deu errado. Por favor, tente novamente.`,
        public_Some_errors:	`Alguns erros dos quais não temos conhecimento!`,
        public_select_reason:	`Selecione o motivo do relatório antes de enviar.`,
        public_Successful_report:	`Relatório bem-sucedido, obrigado por sua contribuição para o meio ambiente da comunidade!`,
        public_Successful_report1:	`Relatório bem-sucedido`,
        public_Reported_too_often:	`Relatado com muita frequência. Tente novamente mais tarde!`,
        public_Reported_too_often1:	`Relatado com muita frequência`,
        public_Failed_report:	`Relatório falhado`,
        public_take:`Dê uma olhada!`,
        album_Unlock:	`Desbloquear`,
        album_Chat_unlock:	`Bate-papo para desbloquear`,
        album_error:	`Desculpe, ocorreu um erro desconhecido. Por favor, tente novamente.`,
        album_private:	`Este caractere não pode ser exibido porque é privado. Por favor, tente outro personagem.`,
        album_loading:	`Aguarde até que os cartões do álbum terminem de carregar.`,
        coins_not_enough:	`Você não tem moedas suficientes, por favor, consiga mais moedas primeiro.`,
        coins_eligible_receive:	`O usuário que você está dando gorjeta não está qualificado para receber gorjetas no momento.`,
        coins_sent_successfully:	`As dicas foram enviadas com sucesso!`,
        coins_reached_limit:	`Desculpe, este criador atingiu seu limite de gorjetas hoje. Tente novamente amanhã!`,
        coins_Unlock:	`Desbloquear`,
        聽overtime_1:	`Código de erro:`,
        email_placeholder:	`E-mail`,
        email_empty:	`Por favor insira o e-mail`,
        email_not_valid:	`E-mail não é válido`,
        email_not_valid_1:	`Por favor insira seu e-mail`,
        email_not_valid_2:	`O e-mail não é válido, use um endereço diferente.`,
        email_not_valid_3:	`Nenhuma entrada de e-mail`,
        password_placeholder:	`Senha`,
        password_empty:	`Por favor insira a senha`,
        password_not_valid:	`Conta ou senha incorreta`,
        password_not_valid_1:	`É necessária senha acima de 8 caracteres`,
        password_not_valid_2:	`Por favor crie uma senha`,
        password_placeholder_1:	`Crie sua senha`,
        password_placeholder_2:	`Confirme sua senha`,
        password_placeholder_3:	`Criar nova senha`,
        password_placeholder_4:	`Confirme a nova senha`,
        password_placeholder_5:	`Insira a senha antiga`,
        copy_password_empty:	`Por favor confirme a senha`,
        copy_password_not_valid:	`Por favor confirme sua senha`,
        copy_passwords_inconsistent:	`A confirmação da sua senha não corresponde`,
        code_empty:	`Insira o código de verificação`,
        code_not_valid:	`Código de verificação inválido`,
        code_placeholder:	`Código de verificação`,
        not_received_code:	`Se sua caixa de correio não recebe o código de verificação há muito tempo, obtenha o código de verificação novamente.`,
        get_first_code:	`Obtenha o código de verificação primeiro.`,
        connect_your_email_placeholder:	`Conecte seu e-mail`,
        last_name_placeholder:	`Por favor insira seu sobrenome`,
        first_name_placeholder:	`Por favor insira seu primeiro nome`,
        address_placeholder:	`Por favor insira seu endereço`,
        error_24901:	`A conta corrente não possui e-mail vinculado e não consegue localizar os pedidos. Por favor conecte um e-mail.`,
        user_guide:	`Guia do usuário >>`,
        download:	`Download`,
        order_number:	`Número do pedido:`,
        Refund:	`Reembolso`,
        Disabled:	`Desabilitado`,
        Normal:	`Normal`,
        Modify:	`Modificar`,
        Modify_1:	`Modificar >>`,
        error_20101:	`Por favor insira seu e-mail (código de erro: 20101)`,
        error_20102:	`O e-mail não é válido (código de erro: 20102)`,
        error_20103:	`Falha na solicitação (código de erro: 20103). Por favor, tente novamente`,
        error_20104:	`O e-mail já está em uso. <a href="/pt/account/login/">faça login</a> ou registre-se com um novo`,
        error_20105:	`Falha na solicitação (código de erro: 20105). Por favor, tente novamente`,
        error_20106:	`Falha ao enviar e-mail, tente novamente`,
        error_20107:	`Conta excluída. Aguarde 3 dias ou use outro e-mail.`,
        error_20201:	`Por favor insira seu e-mail (código de erro: 20201)`,
        error_20202:	`Por favor insira sua senha (código de erro: 20202)`,
        error_20203:	`Insira o código de verificação (código de erro: 20203)`,
        error_20204:	`O e-mail não é válido (código de erro: 20204)`,
        error_20205:	`É necessária uma senha com mais de 8 caracteres (código de erro: 20205)`,
        error_20206:	`Falha na solicitação (código de erro: 20206). Por favor, tente novamente`,
        error_20207:	`Código de verificação inválido`,
        error_20208:	`Falha na solicitação (código de erro: 20208). Por favor, tente novamente`,
        error_20209:	`Falha na solicitação (código de erro: 20209). Por favor, tente novamente`,
        error_20210:	`Conta excluída. Aguarde 3 dias ou use outro e-mail.`,
        error_20301:	`Por favor insira seu e-mail (código de erro: 20301)`,
        error_20302:	`Erro: 20302. Entre em contato conosco`,
        error_20303:	`O e-mail não é válido (código de erro: 20303)`,
        error_20304:	`Falha na solicitação (código de erro: 20304). Por favor, tente novamente`,
        error_20305:	`A conta não existe. Digite novamente ou <a href="/pt/account/register/">Crie-o</a> primeiro.`,
        error_20306:	`Você ainda não definiu uma senha, use o <a href="/pt/account/passwordless-login/">login sem senha</a>.`,
        error_20308:	`Falha na solicitação (código de erro: 20308). Por favor, tente novamente`,
        error_20401:	`Falha ao sair (código de erro: 20401). Por favor, tente novamente`,
        error_20501:	`Por favor insira seu e-mail (código de erro: 20501)`,
        error_20502:	`O e-mail não é válido (código de erro: 20502)`,
        error_20503:	`Falha na solicitação (código de erro: 20503). Por favor, tente novamente`,
        error_20504:	`Falha ao enviar e-mail. Por favor, tente novamente.`,
        error_20601:	`Por favor insira seu e-mail (código de erro: 20601)`,
        error_20602:	`Insira o código de verificação (código de erro: 20602)`,
        error_20603:	`O e-mail não é válido (código de erro: 20603)`,
        error_20604:	`Falha na solicitação (código de erro: 20604). Por favor, tente novamente`,
        error_20606:	`Falha na solicitação (código de erro: 20606). Por favor, tente novamente`,
        error_20607:	`Falha na solicitação (código de erro: 20607). Por favor, tente novamente`,
        error_20608:	`Falha na solicitação (código de erro: 20608). Por favor, tente novamente`,
        error_20701:	`Por favor insira seu e-mail (código de erro: 20701)`,
        error_20702:	`O e-mail não é válido (código de erro: 20702)`,
        error_20703:	`Falha na solicitação (código de erro: 20703). Por favor, tente novamente`,
        error_20704:	`A conta não existe. Digite novamente ou <a href="/pt/account/register/">Crie-o</a> primeiro.`,
        error_20705:	`Falha na solicitação (código de erro: 20705). Por favor, tente novamente`,
        error_20706:	`Falha ao enviar e-mail. Por favor, tente novamente`,
        error_20801:	`Por favor insira seu e-mail (código de erro: 20801)`,
        error_20802:	`Erro: 20802. Entre em contato conosco`,
        error_20803:	`Insira o código de verificação (código de erro: 20803)`,
        error_20804:	`O e-mail não é válido (código de erro: 20804)`,
        error_20805:	`É necessária uma senha acima de 8 caracteres (código de erro: 20805)`,
        error_20806:	`Falha na solicitação (código de erro: 20806). Por favor, tente novamente`,
        error_20808:	`Falha na solicitação (código de erro: 20808). Por favor, tente novamente`,
        error_21000:	`As alterações são salvas`,
        error_21001:	`Nenhuma informação é enviada (código de erro: 21001)`,
        error_21002:	`Falha na solicitação (código de erro: 21002). Por favor, tente novamente`,
        error_21101:	`Por favor insira seu e-mail (código de erro: 21101)`,
        error_21102:	`O e-mail não é válido (código de erro: 21102)`,
        error_21103:	`Falha na solicitação (código de erro: 21103), tente novamente`,
        error_21104:	`O e-mail já está conectado, use um novo`,
        error_21105:	`Falha na solicitação (código de erro: 21105), tente novamente`,
        error_21106:	`Falha ao enviar e-mail. Por favor, tente novamente`,
        error_21201:	`Por favor insira seu e-mail (código de erro: 21201)`,
        error_21202:	`Insira o código de verificação (código de erro: 21202)`,
        error_21203:	`O e-mail não é válido (código de erro: 21203)`,
        error_21204:	`Erro: 21204. Entre em contato conosco`,
        error_21205:	`Erro: 21205. Entre em contato conosco`,
        error_21206:	`É necessária uma senha com mais de 8 caracteres (código de erro: 21206)`,
        error_21207:	`Falha na solicitação (código de erro: 21207). Por favor, tente novamente`,
        error_21209:	`Falha na solicitação (código de erro: 21209). Por favor, tente novamente`,
        error_21301:	`Por favor insira a senha antiga (código de erro: 21301)`,
        error_21302:	`Por favor, crie uma nova senha (código de erro: 21302)`,
        error_21303:	`A nova senha não pode ser igual à antiga. (Erro: 21303)`,
        error_21304:	`É necessária uma senha acima de 8 caracteres (código de erro: 21304)`,
        error_21306:	`Falha na solicitação (código de erro: 21306). Por favor, tente novamente`,
        error_21402:	`Falha na solicitação (código de erro: 21402). Por favor, tente novamente`,
        error_21403:	`Falha ao enviar o código de verificação. Por favor reenvie`,
        error_21500:	`A conta foi excluída`,
        error_21501:	`Insira o código de verificação (código de erro: 21501)`,
        error_21502:	`A sessão de login expirou (Erro: 21502). Faça login novamente.`,
        error_21503:	`Falha na solicitação (código de erro: 21503). Por favor, tente novamente`,
        error_21505:	`Falha na solicitação (código de erro: 21505), tente novamente`,
        error_21901:	`Erro: 21901. Entre em contato conosco`,
        error_21902:	`Falha na solicitação (código de erro: 21902). Por favor, tente novamente`,
        error_21903:	`O status da conta mudou (código de erro: 21903), atualize a página e tente novamente`,
        error_21904:	`Erro: 21904. Tente novamente`,
        error_21905:	`Erro: 21905. Tente novamente`,
        error_21906:	`Falha na solicitação (código de erro: 21906). Por favor, tente novamente`,
        error_21907:	`A conta do Google foi vinculada a outra conta`,
        error_21908:	`Falha na solicitação (código de erro: 21908). Por favor, tente novamente`,
        error_22001:	`Falha na solicitação (código de erro: 22001). Por favor, tente novamente`,
        error_22002:	`Falha na desvinculação sem login adicional`,
        error_22003:	`Falha na solicitação (código de erro: 22003). Por favor, tente novamente`,
        error_22101:	`Erro: 22101. Entre em contato conosco`,
        error_22102:	`O status da conta mudou (código de erro: 22102), atualize a página e tente novamente`,
        error_22103:	`Falha na solicitação (código de erro: 22103). Por favor, tente novamente`,
        error_22104:	`O status da conta mudou (código de erro: 22104), atualize a página e tente novamente`,
        error_22105:	`Erro: 22105. Tente novamente`,
        error_22106:	`Erro: 22106. Tente novamente`,
        error_22107:	`Erro: 22107. Entre em contato conosco`,
        error_22108:	`Falha na solicitação (código de erro: 22108). Por favor, tente novamente`,
        error_22201:	`Erro: 22201. Entre em contato conosco`,
        error_22202:	`Verificação inválida (Erro: 22202). Por favor, tente novamente.`,
        error_22203:	`Erro: 22203. Tente novamente"`,
        error_22204:	`Falha na solicitação (código de erro: 22204). Por favor, tente novamente`,
        error_22206:	`Falha na solicitação (código de erro: 22206). Por favor, tente novamente`,
        error_22401:	`Erro: 22401. Entre em contato conosco`,
        error_22402:	`Verificação inválida (Erro: 22402). Por favor, tente novamente.`,
        error_22403:	`Erro: 22403. Tente novamente`,
        error_22404:	`Falha na solicitação (código de erro: 22404). Por favor, tente novamente`,
        error_22405:	`A conta do Facebook foi vinculada a outro e-mail`,
        error_22406:	`Erro: 22406. Tente novamente`,
        error_22407:	`Erro: 22407. Entre em contato conosco`,
        error_22408:	`Erro: 22408. Entre em contato conosco`,
        error_22409:	`Erro: 22409. Entre em contato conosco`,
        error_22410:	`Erro: 224010. Entre em contato conosco`,
        error_22411:	`Erro: 224011. Entre em contato conosco`,
        error_22412:	`Erro: 224012. Entre em contato conosco`,
        error_22413:	`Erro: 22413. Entre em contato conosco`,
        error_22414:	`Falha na solicitação (código de erro: 22414). Por favor, tente novamente`,
        error_22415:	`Erro: 22415. Entre em contato conosco`,
        error_22416:	`Erro: 22416. Entre em contato conosco`,
        error_22417:	`Erro: 22417. Entre em contato conosco`,
        error_22418:	`Falha na solicitação (código de erro: 22418). Por favor, tente novamente`,
        error_22419:	`Erro: 22419. Entre em contato conosco`,
        error_22420:	`Erro: 22420. Entre em contato conosco`,
        error_22421:	`Erro: 22421. Entre em contato conosco`,
        error_22422:	`Falha na solicitação (código de erro: 22422). Por favor, tente novamente`,
        error_22423:	`Falha na solicitação (código de erro: 22423). Por favor, tente novamente`,
        error_22424:	`Falha na solicitação (código de erro: 22424). Por favor, tente novamente`,
        error_22425:	`Falha na solicitação (código de erro: 22425). Por favor, tente novamente`,
        error_20098:	`Código de erro: 20098. Se você estiver navegando no modo Privado, mude para o modo Normal e tente novamente.`,
        error_22498:	`Falha na solicitação do Facebook (Erro: 22498). Por favor, tente novamente.`,
        error_24902:	`Falha na solicitação (código de erro: 24902). Por favor, tente novamente`,
        error_24903:	`Falha na solicitação (código de erro: 24903). Por favor, tente novamente`,
        error_24904:	`Falha na solicitação (código de erro: 24904). Por favor, tente novamente`,
        error_24905:	`Falha na solicitação (código de erro: 24905). Por favor, tente novamente`,
        login_title:	`Faça login no HeyReal`,
        no_account:	`Sem conta?`,
        create_it:	`Crie`,
        or_log_in_with:	`Ou faça login com`,
        passwordless_login:	`Login sem senha`,
        log_in_done:	`Login concluído`,
        three_rd_account_connect_info:	`Parabéns! Você fez login com sucesso. Agora você pode conectar uma conta de e-mail que será usada para fazer login no futuro.`,
        connect_now:	`Conecte-se agora`,
        see_my_account:	`Ver minha conta`,
        three_rd_login_merge_account:	`O endereço de e-mail da conta de terceiros foi registrado. Deseja conectar-se e fazer login diretamente com este endereço de e-mail?`,
        connect_log_in:	`Conecte-se e faça login`,
        create_an_account:	`Crie uma conta`,
        connect_account:	`Conectar conta`,
        connect_account_info:	`Após conectar, você pode fazer login com esta conta.`,
        back_to_log_in:	`Voltar para fazer login`,
        create_password:	`Criar senha`,
        create_now:	`Crie agora`,
        password_login_subtitle:	`Login sem senha com e-mail`,
        account_login:	`Login da conta`,
        rights:	`Ao criar esta conta, você concorda com os <a href="https://heyreal.ai/pt/terms-and-conditions/">Termos de Serviço</a> e a <a href="https://heyreal.ai/pt/privacy-policy/">Política de Privacidade</a>`,
        passwordless_login_done:	`Login sem senha concluído`,
        passwordless_login_info:	`Parabéns, você concluiu o login sem senha com sucesso. Você pode criar uma senha para esta conta e fazer login com a conta e a senha no futuro. <a href="/pt/account/create-password/" style="display: initial;">Criar agora</a>`,
        sign_up:	`Inscrever-se`,
        register_info:	`Crie sua conta`,
        reset_now:	`Redefinir agora`,
        forgot_password:	`Esqueceu sua senha`,
        reset_password_subtitle:	`Use o e-mail da sua conta para redefinir a senha`,
        plan_products:	`Plano e Produtos`,
        nick_name:	`Apelido:`,
        email:	`E-mail:`,
        unlink:	`Desvincular`,
        link:	`Link`,
        change_now:	`Mude agora`,
        connect_email:	`Conectar e-mail`,
        delete_account:	`Excluir conta`,
        delete_account_info:	`Quando sua conta for excluída, todos os dados em Planos e Produtos associados à sua conta serão excluídos permanentemente e talvez você não consiga recuperá-los. Recomendamos que você aja com cautela.`,
        Delete:	`Excluir`,
        Logout:	`Sair`,
        to:	`para`,
        footer:	`Direitos autorais de 2024 HeyReal Studio. Todos os direitos reservados.`,
        google_login:	`Faça login com o Google`,
        State:	`Estado`,
        images:	`imagens`,
        email_verification:	`Verificação de e-mail`,
        email_verification_info:	`Enviamos a mensagem de verificação para seu e-mail <span class="email"></span> e conclua a verificação. Após a verificação, os benefícios serão sincronizados automaticamente.`,
        error_26301:	`Código de erro: 26301, entre em contato conosco`,
        error_26302:	`Código de erro: 26302, entre em contato conosco`,
        error_26303:	`Erro de formato de e-mail (código de erro: 26303). Por favor insira-o novamente`,
        error_26304:	`Recomenda-se senha acima de 8 caracteres (código de erro: 26304)`,
        error_26305:	`Reuqest falhou (código de erro: 26305). Por favor, tente novamente`,
        error_26306:	`O e-mail foi registrado, por favor <a href="/pt/account/login/">faça login</a>`,
        error_26307:	`Reuqest falhou (código de erro: 26307). Por favor, tente novamente`,
        error_26308:	`Reuqest falhou (código de erro: 26308). Por favor, tente novamente`,
        error_26401:	`Código de erro: 26401, tente novamente`,
        error_26402:	`O e-mail foi verificado (código de erro: 26402), tente novamente`,
        error_26403:	`Reuqest falhou (código de erro: 26403). Por favor, tente novamente`,
        error_26404:	`Falha na solicitação (código de erro: 26404). Por favor, tente novamente`,
        error_26501:	`Código de erro: 26501, entre em contato conosco`,
        error_26502:	`Código de erro: 26502, entre em contato conosco`,
        error_26503:	`Erro de formato de e-mail (código de erro: 26503). Por favor insira-o novamente`,
        error_26504:	`Reuqest falhou (código de erro: 26504). Por favor, tente novamente`,
        error_26505:	`O e-mail não foi registrado, <a href="/pt/account/register/">registre-o primeiro</a>`,
        error_26506:	`O e-mail foi verificado.`,
        error_26507:	`Reuqest falhou (código de erro: 26507). Por favor, tente novamente`,
        error_26508:	`Verificação registrada (código de erro: 26508), tente novamente`,
        error_26509:	`Falha na solicitação (código de erro: 26509), tente novamente`,
        error_26510:	`Código de erro: 26510, entre em contato conosco`,
        error_26601:	`Código de erro: 26601, entre em contato conosco`,
        error_26602:	`Código de erro: 26602, entre em contato conosco`,
        error_26603:	`Reuqest falhou (código de erro: 26603). Por favor, tente novamente`,
        error_26604:	`Código de erro: 26604, entre em contato conosco`,
        error_26605:	`Código de erro: 26605, entre em contato conosco`,
        no_cookie:	`Você ativou a função Bloquear todos os cookies em seu navegador e não consegue fazer login. Vá em Configurações para marcar a caixa Permitir todos os cookies.`,
        error_26801:	`Código de erro: 26801, entre em contato conosco`,
        error_26802:	`Código de erro: 26802, entre em contato conosco`,
        error_26803:	`Falha na solicitação (código de erro: 26803). Por favor, tente novamente`,
        error_26804:	`Falha na solicitação (código de erro: 26804). Por favor, tente novamente`,
        error_order:	`Falha na solicitação (código de erro: 27098), tente novamente!`,
        error_order1:	`A consulta do pedido está incompleta (código de erro:`,
        error_order2:	`), atualize e tente novamente.`,
        modify_email_title:	`Modificar e-mail`,
        modify_email_info:	`Você pode usar o e-mail modificado para fazer login em sua conta.`,
        images_per:	`Imagens por`,
        error_26101:	`Erro: 26101. Entre em contato conosco`,
        error_26102:	`Erro: 26102. Entre em contato conosco`,
        error_26103:	`Falha na solicitação (código de erro: 26103). Por favor, tente novamente`,
        error_26104:	`Código de erro: 26104, tente novamente`,
        error_26105:	`Código de erro: 26105, tente novamente`,
        error_26106:	`Falha na exclusão (código de erro: 26106). Por favor, tente novamente`,
        error_26201:	`Erro: 26201. Entre em contato conosco`,
        error_26202:	`Falha na solicitação (código de erro: 26202). Por favor, tente novamente`,
        error_26001:	`Erro: 26001. Entre em contato conosco`,
        error_26002:	`Erro: 26002. Entre em contato conosco`,
        error_26003:	`Erro: 26003. Entre em contato conosco`,
        error_26004:	`Erro: 26004. Entre em contato conosco`,
        error_26005:	`Falha na solicitação (código de erro: 26005). Por favor, tente novamente`,
        error_26006:	`Código de erro: 26006, tente novamente`,
        error_26008:	`Erro: 26008. Entre em contato conosco`,
        go_to_the_home_page:	`Vá para a página inicial`,
    },
    es:{
        overtime_1:	`Código de error:`,
        overtime_2:	`, por favor vuelve a intentarlo`,
        isnetwork:	`Error de Internet. Por favor verifique y vuelva a intentar`,
        edit_photo:	`Editar foto`,
        select_photo:	`Seleccionar foto`,
        change_photo:	`Cambiar foto`,
        cancel:	`Cancelar`,
        hide_password:	`Ocultar contraseña`,
        show_password:	`Mostrar contraseña`,
        zoom_in:	`Dar un golpe de zoom`,
        zoom_out:	`alejar`,
        rotate:	`Girar`,
        horizontal_flip:	`volteo horizontal`,
        vertical_flip:	`volteo vertical`,
        Connect:	`Conectar`,
        unlink_success:	`Desvincular con éxito`,
        connect_success:	`Conéctese exitosamente`,
        feedback_title:	`Gracias por tus comentarios. Por favor deje su problema y le responderemos dentro de las 24 horas.`,
        feedback_thank_you:	`¡Gracias!<br />Sus comentarios se han enviado correctamente.`,
        feedback_email:	`¡Ingresa tu correo electrónico aquí!`,
        feedback_content:	`Deje aquí cualquier problema o sugerencia que haya encontrado.`,
        feedback_submit:	`Entregar`,
        form_contents:	`No has introducido ninguna descripción. Por favor ingréselo y envíelo nuevamente.`,
        old_password:	`Por favor ingrese la contraseña anterior`,
        new_password:	`Por favor crea una nueva contraseña`,
        old_new_password:	`La nueva contraseña no puede ser la misma que la anterior.`,
        incorrect_password:	`Contraseña incorrecta`,
        delete_no:	`Eliminar ahora`,
        Caps:	`El bloqueo de mayúsculas está activado`,
        Get:	`Conseguir`,
        Done:	`Hecho`,
        error_20001:	`Error: 20001. Inicie sesión nuevamente.`,
        error_20002:	`Error: 20002. Inicie sesión nuevamente.`,
        error_20003:	`Error: 20003. Inicie sesión nuevamente.`,
        error_20004:	`La solicitud falló (código de error: 20004). Por favor inténtelo de nuevo.`,
        error_20005:	`La sesión de inicio de sesión ha caducado (Error: 20005). Por favor inicie sesión nuevamente.`,
        error_20006:	`La solicitud falló (código de error: 20006). Por favor inténtelo de nuevo.`,
        error_20007:	`La sesión de inicio de sesión ha caducado (Error: 20007). Por favor inicie sesión nuevamente.`,
        error_20008:	`La sesión de inicio de sesión ha caducado (Error: 20008). Por favor inicie sesión nuevamente.`,
        error_20009:	`La sesión de inicio de sesión ha caducado (Error: 20009). Por favor inicie sesión nuevamente.`,
        error_20901:	`La solicitud falló (código de error: 20901). Por favor inténtalo de nuevo`,
        error_20902:	`La solicitud falló (código de error: 20902). Por favor inténtalo de nuevo`,
        error_22298:	`La solicitud de Google falló (Error: 22298). Por favor inténtelo de nuevo.`,
        error_21601:	`Error: 21601. Por favor contáctenos`,
        error_21602:	`Verificación no válida (Error: 21602). Por favor inténtelo de nuevo.`,
        error_21603:	`Error: 21603. Inténtalo de nuevo.`,
        error_21604:	`La solicitud falló (código de error: 21604). Por favor inténtalo de nuevo`,
        error_21606:	`La solicitud falló (código de error: 21606). Por favor inténtalo de nuevo`,
        error_21611:	`La solicitud falló (código de error: 21611). Por favor inténtalo de nuevo`,
        error_21613:	`Regístrese con demasiada frecuencia, inténtelo de nuevo más tarde.`,
        error_21801:	`Error: 21801. Por favor contáctenos`,
        error_21802:	`La solicitud falló (Error: 21802). Por favor inténtalo de nuevo`,
        error_21803:	`Error: 21803. Inténtalo de nuevo.`,
        error_21804:	`La solicitud falló (código de error: 21804). Por favor inténtalo de nuevo`,
        error_21806:	`Error: 21806. Inténtalo de nuevo.`,
        error_21807:	`Error: 21807. Por favor contáctenos`,
        error_21808:	`Error: 21808. Por favor contáctenos`,
        error_21809:	`Error: 21809. Por favor contáctenos`,
        error_21810:	`Error: 21810. Por favor contáctenos`,
        error_21811:	`Error: 21811. Por favor contáctenos`,
        error_21812:	`Error: 21812. Por favor contáctenos`,
        error_21813:	`La solicitud falló (código de error: 21813). Por favor inténtalo de nuevo`,
        error_21814:	`Error: 21814. Por favor contáctenos`,
        error_21815:	`La solicitud falló (código de error: 21815). Por favor inténtalo de nuevo`,
        error_21816:	`Error: 21816. Por favor contáctenos`,
        error_21817:	`Error: 21817. Por favor contáctenos`,
        error_21818:	`Error: 21818. Por favor contáctenos`,
        error_21819:	`La solicitud falló (código de error: 21819). Por favor inténtalo de nuevo`,
        error_21820:	`Error: 21820. Por favor contáctenos`,
        error_21821:	`Error: 21821. Por favor contáctenos`,
        error_21822:	`Error: 21822. Por favor contáctenos`,
        error_21823:	`La solicitud falló (código de error: 21823). Por favor inténtalo de nuevo`,
        error_21824:	`La solicitud falló (código de error: 21824). Por favor inténtalo de nuevo`,
        error_21825:	`La solicitud falló (código de error: 21825). Por favor inténtalo de nuevo`,
        error_21826:	`La solicitud falló (código de error: 21826). Por favor inténtalo de nuevo`,
        error_21827:	`La solicitud falló (código de error: 21827). Por favor inténtalo de nuevo`,
        error_21828:	`Cuenta eliminada. Espere 3 días o utilice otro correo electrónico.`,
        error_21829:	`¡Error de inicio de sesion!`,
        error_26701:	`Código de error: 26701, por favor contáctenos`,
        error_26702:	`La solicitud falló (código de error: 26702). Por favor vuelve a intentarlo`,
        error_26703:	`Código de error: 26703, por favor contáctenos`,
        error_26704:	`Código de error: 26704, por favor contáctenos`,
        error_26705:	`Espere a iniciar sesión (código de error: 26705). Por favor vuelve a intentarlo`,
        no_code_text:	`Hemos enviado un código de verificación. Por favor ingrese su código. <span class='tips'>¿No recibiste un código?`,
        no_code_text_1:	`1. Asegúrese de que la dirección de correo electrónico sea válida y pueda recibir correos electrónicos.`,
        no_code_text_2:	`2. Dado que el sistema envía el correo electrónico automáticamente, es posible que se marque como correo no deseado o correo no deseado. Verifique si el correo electrónico está en la carpeta Papelera.`,
        no_code_text_3:	`3. ¿No puedes resolver tu problema?`,
        no_code_text_3_span:	`Luego haga clic <a href="https://discord.gg/CB5W97Z9eG" rel="nofollow">aquí</a> para contactarnos.`,
        no_code_text_4_span:	`<b>Atención:</b> Después de eliminar su cuenta, no podrá utilizar el mismo correo electrónico para registrarse e iniciar sesión durante 3 días.`,
        log_in:	`Acceso`,
        public_Network_error:	`Error de red. Inténtelo de nuevo más tarde.`,
        public_showToast_Success:	`Éxito`,
        public_showToast_Warning:	`Advertencia`,
        public_showToast_Error:	`Error`,
        public_showToast_1:	`Pago exitoso, ¡disfruta del chat!`,
        public_showToast_2:	`Confirmando su pago, vuelva a consultar más tarde.`,
        public_showToast_3:	`El pago falló, inténtelo nuevamente o contáctenos.`,
        public_showToast_4:	`Espere por favor`,
        public_showToast_5:	`El pago se realizó correctamente. Intente actualizar la página más tarde para actualizar el plan.`,
        public_showToast_6:	`Suscripción exitosa. ¡Disfruta la charla!`,
        public_showToast_7:	`¡Cancelar la renovación de la suscripción con éxito!`,
        public_showToast_8:	`La cancelación falló. Inténtelo de nuevo más tarde o contáctenos.`,
        public_showToast_9:	`Por favor revisa el aviso.`,
        pricing_showToast_10:	`No se pudo ir a la página de pago, inténtelo nuevamente más tarde.`,
        pricing_showToast_11:	`No se pudo encontrar el plan de suscripción. Vuelva a intentarlo más tarde.`,
        pricing_showToast_12:	`No se pudo obtener la información de su país, contáctenos para resolver el problema.`,
        pricing_showToast_13:	`Lo sentimos, pero el cambio entre suscripciones anuales y mensuales no está disponible por ahora.`,
        pricing_showToast_14:	`Lo sentimos, no admitimos rebajas de suscripción por ahora.`,
        pricing_Credit:	`Pagar con tarjeta de crédito`,
        pricing_Wallet:	`Pagar con billetera electrónica`,
        public_Achievement:	`Logros de\'s`,
        public_Login_Required:	`Iniciar sesión requerido`,
        public_In_order:	`Para continuar, inicie sesión en su cuenta.`,
        public_Network_error:	`Error de red, inténtalo de nuevo más tarde.`,
        public_New_Character:	`Nuevo personaje`,
        public_Explore_Now:	`Explora ahora`,
        public_Check_Now:	`Comprobar ahora`,
        public_Review:	`Revisar`,
        public_Follow:	`Seguir`,
        public_Following:	`Siguiente`,
        public_Unfollow:	`Dejar de seguir`,
        public_notifications:	`Sin notificaciones.`,
        public_Successfully_Unfollow:	`Dejar de seguir exitosamente`,
        public_Successfully_Follow:	`Seguir con éxito`,
        public_Failed_Unlike:	`No se pudo diferenciar el personaje`,
        public_Failed_Followed:	`No se pudo seguir`,
        public_Successfully_Like:	`Me gusta el personaje con éxito`,
        public_Successfully_Unlike:	`Diferenciar exitosamente al personaje`,
        public_Failed_Like:	`No me gustó el personaje`,
        public_too_fast:	`Hace clic demasiado rápido. Por favor espera.`,
        public_Log_in_to_get:	`Inicia sesión para obtener`,
        public_Login_for_Achievements:	`Iniciar sesión para obtener logros`,
        public_Subscribe:	`Suscribir`,
        pricing_subscription:	`Espere a que caduque su suscripción y vuelva al plan gratuito.`,
        pricing_Confirm_Payment_Completion:	`Confirmar finalización del pago`,
        pricing_complete_the_payment:	`Por favor complete el pago en la nueva ventana. Y complete la vinculación de la cuenta aquí después del pago exitoso.`,
        pricing_Paid:	`Pagado`,
        pricing_Payment_Info_not_detected:	`Información de pago no detectada, inténtelo nuevamente más tarde o contáctenos a través de Dsicord`,
        pricing_character_finish_loading:	`Espere a que las tarjetas de personajes terminen de cargarse.`,
        public_Report:	`Informe`,
        public_Paid:	`Editar personaje`,
        public_Failed_Show_Achievements:	`No se pudieron mostrar los logros`,
        public_results_create:	`Los resultados que desea no se encuentran. Haga clic en "crear" ahora para crear el que desee.`,
        public_create:	`Crear`,
        public_Views:	`Vistas`,
        public_Likes:	`Gustos`,
        public_Comment:	`Comentario`,
        public_Private:	`Privado`,
        public_Restricted_Display:	`Visualización restringida`,
        public_Under_Review:	`En revisión`,
        public_Claim:`Afirmar`,
        public_Resubmit:`Reenviar`,
        public_results_not_found:	`Los resultados que desea no se encuentran.`,
        public_story_anonymous:	`El autor de esta historia es anónimo.`,
        public_no_chat_stories:	`No hay historias de chat por ahora, ¡crea una!`,
        public_Earn:	`Ganar`,
        public_Submit:	`Entregar`,
        public_Unlock_My_Achievement:`Unlock My Achievement`,
        public_no_characters:	`No hay personajes disponibles en este momento, te recomendamos los siguientes personajes:`,
        public_enter_character:	`Por favor introduce el nombre del personaje.`,
        public_length_characters_2:	`La longitud del nombre debe tener más de 2 caracteres.`,
        public_length_characters_3:	`El nombre debe tener entre 3 y 40 caracteres.`,
        public_length_characters_40:	`La longitud del nombre no puede exceder los 40 caracteres.`,
        public_length_characters_205:	`La descripción debe tener entre 5 y 200 caracteres.`,
        public_length_characters_500:	`El contenido de la introducción está limitado a un máximo de 500 caracteres.`,
        public_no_Introduction:	`Aún no hay introducción.`,
        public_Image_uploading:	`Subiendo imagen! Espere un segundo.`,
        public_select_gender:	`Por favor selecciona el género del personaje.`,
        public_length_Introduction_500:	`El contenido de la introducción está limitado a un máximo de 500 caracteres.`,
        public_length_characters_200:	`El comentario debe tener entre 1 y 200 caracteres.`,
        public_length_characters_201:	`La descripción debe tener entre 5 y 200 caracteres.`,
        public_length_characters_1000:	`El número máximo de caracteres es 1000.`,
        public_length_characters_1001:	`El saludo debe tener entre 3 y 1000 caracteres.`,
        public_length_characters_4000:	`El contenido de personalidad debe tener entre 0 y 4000 caracteres.`,
        public_length_characters_1002:	`El contenido del escenario debe tener entre 0 y 1000 caracteres.`,
        public_creation_failed:	`Error al crear el personaje, inténtalo de nuevo.`,
        public_Description_characters:	`La descripción debe tener entre 5 y 500 caracteres.`,
        public_pornographic_illegal:	`¡No utilices palabras pornográficas e ilegales, de lo contrario fallará la generación de la imagen del personaje!`,
        creator_edit_description:	`La imagen generada contiene contenido confidencial, edite la descripción e inténtelo nuevamente.`,
        creator_Generate_failed:	`¡Error al generar imágenes!`,
        creator_exceed_10M:	`El tamaño de la imagen no puede exceder los 10M.`,
        creator_Database_Error:	`8001, error en el procesamiento de la base de datos`,
        creator_Save_failed:	`Error al guardar, inténtelo de nuevo.`,
        bonus_Reward_Title:	`Recompensa: Título limitado`,
        bonus_Go_Create:	`¡Ve a Crear!`,
        bonus_Earn:	`Ganar`,
        bonus_Finished:	`Finalizado`,
        bonus_Completed:	`¡Terminado!`,
        bonus_Complete:	`¡Completo!`,
        bonus_messages:`mensajes`,
        bonus_image_unlock_props:`la imagen se desbloquea`,
        bonus_correct_link:	`¡Por favor ingrese el enlace correcto!`,
        bonus_Get_your_title:	`¡Consigue tu título!`,
        bonus_New_achievment:	`¡Nuevo logro completado!`,
        bonus_submission_failed:	`Lo sentimos, el envío falló. Por favor vuelva a enviar.`,
        bonus_Check_in_failed:	`El check-in falló. Inténtelo de nuevo más tarde.`,
        bonus_Chat_with:`Chat with various AI characters without any filter on HeyReal.ai. Input the invite code`,
        bonus_Chat_with_1:`after you sign up to get tons of free messages.`,
        recommend_Characters:	`Personajes`,
        recommend_Interactions:	`Interacciones`,
        recommend_Created_by:	`Creado por:`,
        chat_story_Successfully:	`Exitosamente`,
        chat_story_Failed:	`Fallido`,
        chat_story_story:	`la historia`,
        chat_story_like:	`Como`,
        chat_story_unlike:	`A diferencia de`,
        chat_story_characters:	`El comentario no debe tener más de 200 caracteres.`,
        chat_story_Author:	`Autor:`,
        character_not_info:	`El creador no dejó ninguna información aquí.`,
        character_hidden_details:	`El creador ha ocultado los detalles relevantes del personaje.`,
        character_info_public:	`El creador no hizo pública esta información.`,
        character_restore:	`Este personaje está restringido debido a imágenes inapropiadas. Edite para restaurarlo.`,
        character_info_1:	`Este personaje está restringido debido a`,
        character_info_2:	`texto e imágenes inapropiadas. Edite para restaurarlo.`,
        character_info_3:	`texto. Edite para restaurarlo.`,
        character_info_4:	`Este personaje está bajo revisión y actualmente solo es visible para ti. Se hará público una vez que se complete la revisión.`,
        character_View_all:	`Ver todo`,
        character_Chat_Now:	`Chatear ahora`,
        character_restricted:	`La visualización de este personaje está restringida debido a una violación de nuestras pautas de contenido. Por favor prueba con otro personaje.`,
        character_Share_Story:	`¡Comparte la primera historia antes que los demás!`,
        character_Start_Chat:	`Iniciar chat`,
        character_Edit:	`Editar`,
        character_View_Profile:	`Ver perfil &gt;&gt;`,
        character_Photo_Album:	`Álbum de fotos`,
        character_Successfully_Remove:	`Eliminar exitosamente de favoritos`,
        character_Failed_Remove:	`No se pudo eliminar de favoritos`,
        character_Successfully_Add:	`Agregar exitosamente a favoritos`,
        character_Failed_Add:	`No se pudo agregar a favoritos`,
        character_info_4:	`¡Error de corte!`,
        creator_Sever_Error:	`¡Error de corte!`,
        public_username_is_taken:	`Este nombre de usuario está en uso. Por favor prueba con otro.`,
        public_Sever_failed:	`Error al guardar los cambios, inténtelo de nuevo.`,
        public_image_exceed_5:	`El tamaño de la imagen no puede exceder los 5M.`,
        public_Something_wrong:	`Algo salió mal. Por favor inténtalo de nuevo.`,
        public_Some_errors:	`¡Algunos errores de los que no somos conscientes!`,
        public_select_reason:	`Seleccione el motivo del informe antes de enviarlo.`,
        public_Successful_report:	`Informe exitoso, ¡gracias por su contribución al entorno comunitario!`,
        public_Successful_report1:	`Informe exitoso`,
        public_Reported_too_often:	`Informado con demasiada frecuencia. ¡Inténtelo de nuevo más tarde!`,
        public_Reported_too_often1:	`Reportado con demasiada frecuencia`,
        public_Failed_report:	`Informe fallido`,
        public_take:`¡Echa un vistazo!`,
        album_Unlock:	`Descubrir`,
        album_Chat_unlock:	`Chatear para desbloquear`,
        album_error:	`Lo sentimos, se ha producido un error desconocido. Por favor inténtalo de nuevo.`,
        album_private:	`La visualización de este personaje está restringida porque es privado. Por favor prueba con otro personaje.`,
        album_loading:	`Espere a que terminen de cargarse las tarjetas del álbum.`,
        coins_not_enough:	`No tienes suficientes monedas, consigue más monedas primero.`,
        coins_eligible_receive:	`El usuario al que le estás dando propina no es elegible para recibir propinas por ahora.`,
        coins_sent_successfully:	`¡Los tips han sido enviados exitosamente!`,
        coins_reached_limit:	`Lo sentimos, este creador ha alcanzado su límite de sugerencias hoy. ¡Inténtalo de nuevo mañana!`,
        coins_Unlock:	`Descubrir`,
        聽overtime_1:	`Código de error:`,
        email_placeholder:	`Correo electrónico`,
        email_empty:	`Por favor ingrese el correo electrónico`,
        email_not_valid:	`El correo electrónico no es válido.`,
        email_not_valid_1:	`Por favor ingrese su correo electrónico`,
        email_not_valid_2:	`El correo electrónico no es válido, utilice una dirección diferente.`,
        email_not_valid_3:	`Sin entrada de correo electrónico`,
        password_placeholder:	`Contraseña`,
        password_empty:	`Por favor ingrese la contraseña`,
        password_not_valid:	`Cuenta o contraseña incorrecta`,
        password_not_valid_1:	`Se requiere contraseña de más de 8 caracteres`,
        password_not_valid_2:	`Por favor crea una contraseña`,
        password_placeholder_1:	`Crea tu contraseña`,
        password_placeholder_2:	`Confirma tu contraseña`,
        password_placeholder_3:	`Crear nueva contraseña`,
        password_placeholder_4:	`Confirmar nueva contraseña`,
        password_placeholder_5:	`Ingrese la contraseña anterior`,
        copy_password_empty:	`Por favor confirme la contraseña`,
        copy_password_not_valid:	`Por favor confirma tu contraseña`,
        copy_passwords_inconsistent:	`La confirmación de tu contraseña no coincide`,
        code_empty:	`Por favor ingrese el código de verificación`,
        code_not_valid:	`Código de verificación no válido`,
        code_placeholder:	`Código de verificación`,
        not_received_code:	`Si su buzón no ha recibido el código de verificación durante mucho tiempo, obtenga el código de verificación nuevamente.`,
        get_first_code:	`Primero obtenga el código de verificación.`,
        connect_your_email_placeholder:	`Conecta tu correo electrónico`,
        last_name_placeholder:	`Por favor ingresa tu apellido`,
        first_name_placeholder:	`Por favor ingresa tu nombre`,
        address_placeholder:	`Por favor ingrese su dirección`,
        error_24901:	`La cuenta actual no tiene ningún correo electrónico vinculado y no puede encontrar los pedidos. Por favor conecte un correo electrónico.`,
        user_guide:	`Guía del usuario>>`,
        download:	`Descargar`,
        order_number:	`Número de orden:`,
        Refund:	`Reembolso`,
        Disabled:	`Desactivado`,
        Normal:	`Normal`,
        Modify:	`Modificar`,
        Modify_1:	`Modificar>>`,
        error_20101:	`Por favor ingrese su correo electrónico (código de error: 20101)`,
        error_20102:	`El correo electrónico no es válido (código de error: 20102)`,
        error_20103:	`La solicitud falló (código de error: 20103). Por favor inténtalo de nuevo`,
        error_20104:	`El correo electrónico ya está en uso, <a href="/es/account/login/">inicie sesión</a> o regístrese con uno nuevo.`,
        error_20105:	`La solicitud falló (código de error: 20105). Por favor inténtalo de nuevo`,
        error_20106:	`No se pudo enviar el correo electrónico. Vuelva a intentarlo.`,
        error_20107:	`Cuenta eliminada. Espere 3 días o utilice otro correo electrónico.`,
        error_20201:	`Por favor ingrese su correo electrónico (código de error: 20201)`,
        error_20202:	`Por favor ingrese su contraseña (código de error: 20202)`,
        error_20203:	`Ingrese el código de verificación (código de error: 20203)`,
        error_20204:	`El correo electrónico no es válido (código de error: 20204)`,
        error_20205:	`Se requiere una contraseña de más de 8 caracteres (código de error: 20205)`,
        error_20206:	`La solicitud falló (código de error: 20206). Por favor inténtalo de nuevo`,
        error_20207:	`Código de verificación no válido`,
        error_20208:	`La solicitud falló (código de error: 20208). Por favor inténtalo de nuevo`,
        error_20209:	`La solicitud falló (código de error: 20209). Por favor inténtalo de nuevo`,
        error_20210:	`Cuenta eliminada. Espere 3 días o utilice otro correo electrónico.`,
        error_20301:	`Por favor ingrese su correo electrónico (código de error: 20301)`,
        error_20302:	`Error: 20302. Por favor contáctenos`,
        error_20303:	`El correo electrónico no es válido (código de error: 20303)`,
        error_20304:	`La solicitud falló (código de error: 20304). Por favor inténtalo de nuevo`,
        error_20305:	`La cuenta no existe. Vuelva a ingresarlo o <a href="/es/account/register/">créelo</a> primero.`,
        error_20306:	`Aún no ha establecido una contraseña, utilice el <a href="/es/account/passwordless-login/">inicio de sesión sin contraseña</a>.`,
        error_20308:	`La solicitud falló (código de error: 20308). Por favor inténtalo de nuevo`,
        error_20401:	`No se pudo cerrar sesión (código de error: 20401). Por favor inténtalo de nuevo`,
        error_20501:	`Por favor ingrese su correo electrónico (código de error: 20501)`,
        error_20502:	`El correo electrónico no es válido (código de error: 20502)`,
        error_20503:	`La solicitud falló (código de error: 20503). Por favor inténtalo de nuevo`,
        error_20504:	`No se pudo enviar el correo electrónico. Por favor inténtelo de nuevo.`,
        error_20601:	`Por favor ingrese su correo electrónico (código de error: 20601)`,
        error_20602:	`Ingrese el código de verificación (código de error: 20602)`,
        error_20603:	`El correo electrónico no es válido (código de error: 20603)`,
        error_20604:	`La solicitud falló (código de error: 20604). Por favor inténtalo de nuevo`,
        error_20606:	`La solicitud falló (código de error: 20606). Por favor inténtalo de nuevo`,
        error_20607:	`La solicitud falló (código de error: 20607). Por favor inténtalo de nuevo`,
        error_20608:	`La solicitud falló (código de error: 20608). Por favor inténtalo de nuevo`,
        error_20701:	`Por favor ingrese su correo electrónico (código de error: 20701)`,
        error_20702:	`El correo electrónico no es válido (código de error: 20702)`,
        error_20703:	`La solicitud falló (código de error: 20703). Por favor inténtalo de nuevo`,
        error_20704:	`La cuenta no existe. Vuelva a ingresarlo o <a href="/es/account/register/">créelo</a> primero.`,
        error_20705:	`La solicitud falló (código de error: 20705). Por favor inténtalo de nuevo`,
        error_20706:	`No se pudo enviar el correo electrónico. Por favor inténtalo de nuevo`,
        error_20801:	`Por favor ingrese su correo electrónico (código de error: 20801)`,
        error_20802:	`Error: 20802. Por favor contáctenos`,
        error_20803:	`Ingrese el código de verificación (código de error: 20803)`,
        error_20804:	`El correo electrónico no es válido (código de error: 20804)`,
        error_20805:	`Se requiere una contraseña de más de 8 caracteres (código de error: 20805)`,
        error_20806:	`La solicitud falló (código de error: 20806). Por favor inténtalo de nuevo`,
        error_20808:	`La solicitud falló (código de error: 20808). Por favor inténtalo de nuevo`,
        error_21000:	`Los cambios se guardan`,
        error_21001:	`No se envía información (código de error: 21001)`,
        error_21002:	`La solicitud falló (código de error: 21002). Por favor inténtalo de nuevo`,
        error_21101:	`Por favor ingrese su correo electrónico (código de error: 21101)`,
        error_21102:	`El correo electrónico no es válido (código de error: 21102)`,
        error_21103:	`La solicitud falló (código de error: 21103), vuelva a intentarlo`,
        error_21104:	`El correo electrónico ya está conectado, utilice uno nuevo.`,
        error_21105:	`La solicitud falló (código de error: 21105), vuelva a intentarlo`,
        error_21106:	`No se pudo enviar el correo electrónico. Por favor inténtalo de nuevo`,
        error_21201:	`Por favor ingrese su correo electrónico (código de error: 21201)`,
        error_21202:	`Ingrese el código de verificación (código de error: 21202)`,
        error_21203:	`El correo electrónico no es válido (código de error: 21203)`,
        error_21204:	`Error: 21204. Por favor contáctenos`,
        error_21205:	`Error: 21205. Por favor contáctenos`,
        error_21206:	`Se requiere una contraseña de más de 8 caracteres (código de error: 21206)`,
        error_21207:	`La solicitud falló (código de error: 21207). Por favor inténtalo de nuevo`,
        error_21209:	`La solicitud falló (código de error: 21209). Por favor inténtalo de nuevo`,
        error_21301:	`Ingrese la contraseña anterior (código de error: 21301)`,
        error_21302:	`Cree una nueva contraseña (código de error: 21302)`,
        error_21303:	`La nueva contraseña no puede ser la misma que la anterior. (Error: 21303)`,
        error_21304:	`Se requiere una contraseña de más de 8 caracteres (código de error: 21304)`,
        error_21306:	`La solicitud falló (código de error: 21306). Por favor inténtalo de nuevo`,
        error_21402:	`La solicitud falló (código de error: 21402). Por favor inténtalo de nuevo`,
        error_21403:	`No se pudo enviar el código de verificación. Por favor reenvialo`,
        error_21500:	`La cuenta ha sido eliminada.`,
        error_21501:	`Ingrese el código de verificación (código de error: 21501)`,
        error_21502:	`La sesión de inicio de sesión ha caducado (Error: 21502). Por favor inicie sesión nuevamente.`,
        error_21503:	`La solicitud falló (código de error: 21503). Por favor inténtalo de nuevo`,
        error_21505:	`La solicitud falló (código de error: 21505), vuelva a intentarlo`,
        error_21901:	`Error: 21901. Por favor contáctenos`,
        error_21902:	`La solicitud falló (código de error: 21902). Por favor inténtalo de nuevo`,
        error_21903:	`El estado de la cuenta ha cambiado (código de error: 21903), actualice la página e inténtelo de nuevo`,
        error_21904:	`Error: 21904. Inténtalo de nuevo.`,
        error_21905:	`Error: 21905. Inténtalo de nuevo.`,
        error_21906:	`La solicitud falló (código de error: 21906). Por favor inténtalo de nuevo`,
        error_21907:	`La cuenta de Google ha sido vinculada a otra cuenta.`,
        error_21908:	`La solicitud falló (código de error: 21908). Por favor inténtalo de nuevo`,
        error_22001:	`La solicitud falló (código de error: 22001). Por favor inténtalo de nuevo`,
        error_22002:	`Error al desvincular sin iniciar sesión adicionalmente`,
        error_22003:	`La solicitud falló (código de error: 22003). Por favor inténtalo de nuevo`,
        error_22101:	`Error: 22101. Por favor contáctenos`,
        error_22102:	`El estado de la cuenta ha cambiado (código de error: 22102), actualice la página e inténtelo de nuevo`,
        error_22103:	`La solicitud falló (código de error: 22103). Por favor inténtalo de nuevo`,
        error_22104:	`El estado de la cuenta ha cambiado (código de error: 22104), actualice la página e inténtelo de nuevo`,
        error_22105:	`Error: 22105. Inténtelo de nuevo.`,
        error_22106:	`Error: 22106. Inténtalo de nuevo.`,
        error_22107:	`Error: 22107. Por favor contáctenos`,
        error_22108:	`La solicitud falló (código de error: 22108). Por favor inténtalo de nuevo`,
        error_22201:	`Error: 22201. Por favor contáctenos`,
        error_22202:	`Verificación no válida (Error: 22202). Por favor inténtelo de nuevo.`,
        error_22203:	`Error: 22203. Inténtelo de nuevo"`,
        error_22204:	`La solicitud falló (código de error: 22204). Por favor inténtalo de nuevo`,
        error_22206:	`La solicitud falló (código de error: 22206). Por favor inténtalo de nuevo`,
        error_22401:	`Error: 22401. Por favor contáctenos`,
        error_22402:	`Verificación no válida (Error: 22402). Por favor inténtelo de nuevo.`,
        error_22403:	`Error: 22403. Inténtalo de nuevo.`,
        error_22404:	`La solicitud falló (código de error: 22404). Por favor inténtalo de nuevo`,
        error_22405:	`La cuenta de Facebook ha sido vinculada a otro correo electrónico.`,
        error_22406:	`Error: 22406. Inténtalo de nuevo.`,
        error_22407:	`Error: 22407. Por favor contáctenos`,
        error_22408:	`Error: 22408. Por favor contáctenos`,
        error_22409:	`Error: 22409. Por favor contáctenos`,
        error_22410:	`Error: 224010. Por favor contáctenos`,
        error_22411:	`Error: 224011. Por favor contáctenos`,
        error_22412:	`Error: 224012. Por favor contáctenos`,
        error_22413:	`Error: 22413. Por favor contáctenos`,
        error_22414:	`La solicitud falló (código de error: 22414). Por favor inténtalo de nuevo`,
        error_22415:	`Error: 22415. Por favor contáctenos`,
        error_22416:	`Error: 22416. Por favor contáctenos`,
        error_22417:	`Error: 22417. Por favor contáctenos`,
        error_22418:	`La solicitud falló (código de error: 22418). Por favor inténtalo de nuevo`,
        error_22419:	`Error: 22419. Por favor contáctenos`,
        error_22420:	`Error: 22420. Por favor contáctenos`,
        error_22421:	`Error: 22421. Por favor contáctenos`,
        error_22422:	`La solicitud falló (código de error: 22422). Por favor inténtalo de nuevo`,
        error_22423:	`La solicitud falló (código de error: 22423). Por favor inténtalo de nuevo`,
        error_22424:	`La solicitud falló (código de error: 22424). Por favor inténtalo de nuevo`,
        error_22425:	`La solicitud falló (código de error: 22425). Por favor inténtalo de nuevo`,
        error_20098:	`Código de error: 20098. Si estás navegando en modo Privado, cambia al modo Normal e inténtalo nuevamente.`,
        error_22498:	`La solicitud de Facebook falló (Error: 22498). Por favor inténtelo de nuevo.`,
        error_24902:	`La solicitud falló (código de error: 24902). Por favor inténtalo de nuevo`,
        error_24903:	`La solicitud falló (código de error: 24903). Por favor inténtalo de nuevo`,
        error_24904:	`La solicitud falló (código de error: 24904). Por favor inténtalo de nuevo`,
        error_24905:	`La solicitud falló (código de error: 24905). Por favor inténtalo de nuevo`,
        login_title:	`Inicia sesión en HeyReal`,
        no_account:	`¿Sin cuenta?`,
        create_it:	`crearlo`,
        or_log_in_with:	`O inicia sesión con`,
        passwordless_login:	`Inicio de sesión sin contraseña`,
        log_in_done:	`Iniciar sesión hecho`,
        three_rd_account_connect_info:	`¡Felicidades! Has iniciado sesión correctamente. Ahora puede conectar una cuenta de correo electrónico que utilizará para iniciar sesión en el futuro.`,
        connect_now:	`Conéctate ahora`,
        see_my_account:	`ver mi cuenta`,
        three_rd_login_merge_account:	`La dirección de correo electrónico de la cuenta de terceros se ha registrado. ¿Desea conectarse e iniciar sesión con esta dirección de correo electrónico directamente?`,
        connect_log_in:	`Conéctese e inicie sesión`,
        create_an_account:	`Crea una cuenta`,
        connect_account:	`Conectar cuenta`,
        connect_account_info:	`Después de conectarse, puede iniciar sesión con esta cuenta.`,
        back_to_log_in:	`Volver a iniciar sesión`,
        create_password:	`Crear contraseña`,
        create_now:	`Crear ahora`,
        password_login_subtitle:	`Inicio de sesión sin contraseña con correo electrónico`,
        account_login:	`Iniciar sesión en la cuenta`,
        rights:	`Al crear esta cuenta, aceptas los <a href="https://heyreal.ai/es/terms-and-conditions/">Términos de servicio</a> y la <a href="https://heyreal.ai/es/privacy-policy/">Política de privacidad</a>`,
        passwordless_login_done:	`Inicio de sesión sin contraseña realizado`,
        passwordless_login_info:	`Felicitaciones, ha completado exitosamente el inicio de sesión sin contraseña. Puede crear una contraseña para esta cuenta e iniciar sesión con la cuenta y la contraseña en el futuro. <a href="/es/account/create-password/" style="display: initial;">Crear ahora</a>`,
        sign_up:	`Inscribirse`,
        register_info:	`Crea tu cuenta`,
        reset_now:	`Reiniciar ahora`,
        forgot_password:	`Has olvidado tu contraseña`,
        reset_password_subtitle:	`Utilice el correo electrónico de su cuenta para restablecer la contraseña`,
        plan_products:	`Plan y productos`,
        nick_name:	`Apodo:`,
        email:	`Correo electrónico:`,
        unlink:	`Desconectar`,
        link:	`Enlace`,
        change_now:	`Cambiar ahora`,
        connect_email:	`Conectar correo electrónico`,
        delete_account:	`Eliminar cuenta`,
        delete_account_info:	`Cuando se elimina su cuenta, todos los datos del Plan y Productos asociados con su cuenta se eliminarán permanentemente y es posible que no pueda recuperarlos. Le recomendamos andar con cautela.`,
        Delete:	`Borrar`,
        Logout:	`Cerrar sesión`,
        to:	`a`,
        footer:	`Copyright 漏 2024 HeyReal Studio. Reservados todos los derechos.`,
        google_login:	`Iniciar sesión con Google`,
        State:	`Estado`,
        images:	`imagen(es)`,
        email_verification:	`Verificación de correo electrónico`,
        email_verification_info:	`Hemos enviado el mensaje de verificación a su correo electrónico <span class="email"></span> y finalice la verificación. Después de la verificación, los beneficios se sincronizarán automáticamente.`,
        error_26301:	`Código de error: 26301, por favor contáctenos`,
        error_26302:	`Código de error: 26302, por favor contáctenos`,
        error_26303:	`Error de formato de correo electrónico (código de error: 26303). Por favor ingresalo nuevamente`,
        error_26304:	`Se recomienda una contraseña de más de 8 caracteres (código de error: 26304)`,
        error_26305:	`La solicitud falló (código de error: 26305). Por favor vuelve a intentarlo`,
        error_26306:	`El correo electrónico ha sido registrado, por favor <a href="/es/account/login/">vaya a iniciar sesión</a>`,
        error_26307:	`La solicitud falló (código de error: 26307). Por favor vuelve a intentarlo`,
        error_26308:	`La solicitud falló (código de error: 26308). Por favor vuelve a intentarlo`,
        error_26401:	`Código de error: 26401, vuelva a intentarlo`,
        error_26402:	`El correo electrónico ha sido verificado (código de error: 26402), vuelva a intentarlo`,
        error_26403:	`La solicitud falló (código de error: 26403). Por favor vuelve a intentarlo`,
        error_26404:	`La solicitud falló (código de error: 26404). Por favor vuelve a intentarlo`,
        error_26501:	`Código de error: 26501, por favor contáctenos`,
        error_26502:	`Código de error: 26502, por favor contáctenos`,
        error_26503:	`Error de formato de correo electrónico (código de error: 26503). Por favor ingresalo nuevamente`,
        error_26504:	`La solicitud falló (código de error: 26504). Por favor vuelve a intentarlo`,
        error_26505:	`El correo electrónico no se ha registrado, <a href="/es/account/register/">regístrelo primero</a>`,
        error_26506:	`El correo electrónico ha sido verificado.`,
        error_26507:	`La solicitud falló (código de error: 26507). Por favor vuelve a intentarlo`,
        error_26508:	`Verificación fallida (código de error: 26508), vuelva a intentarlo`,
        error_26509:	`La solicitud falló (código de error: 26509), vuelva a intentarlo`,
        error_26510:	`Código de error: 26510, por favor contáctenos`,
        error_26601:	`Código de error: 26601, por favor contáctenos`,
        error_26602:	`Código de error: 26602, por favor contáctenos`,
        error_26603:	`La solicitud falló (código de error: 26603). Por favor vuelve a intentarlo`,
        error_26604:	`Código de error: 26604, por favor contáctenos`,
        error_26605:	`Código de error: 26605, por favor contáctenos`,
        no_cookie:	`Ha activado la función Bloquear todas las cookies en su navegador, por lo que no puede iniciar sesión. Vaya a Configuración para marcar la casilla Permitir todas las cookies.`,
        error_26801:	`Código de error: 26801, por favor contáctenos`,
        error_26802:	`Código de error: 26802, por favor contáctenos`,
        error_26803:	`La solicitud falló (código de error: 26803). Por favor vuelve a intentarlo`,
        error_26804:	`La solicitud falló (código de error: 26804). Por favor vuelve a intentarlo`,
        error_order:	`La solicitud falló (código de error: 27098), ¡inténtelo de nuevo!`,
        error_order1:	`La consulta del pedido está incompleta (código de error:`,
        error_order2:	`), actualice e inténtelo de nuevo.`,
        modify_email_title:	`Modificar correo electrónico`,
        modify_email_info:	`Puede utilizar el correo electrónico modificado para iniciar sesión en su cuenta.`,
        images_per:	`Imágenes por`,
        error_26101:	`Error: 26101. Por favor contáctenos`,
        error_26102:	`Error: 26102. Por favor contáctenos`,
        error_26103:	`La solicitud falló (código de error: 26103). Por favor inténtalo de nuevo`,
        error_26104:	`Código de error: 26104, vuelva a intentarlo`,
        error_26105:	`Código de error: 26105, vuelva a intentarlo`,
        error_26106:	`Error al eliminar (código de error: 26106). Por favor inténtalo de nuevo`,
        error_26201:	`Error: 26201. Por favor contáctenos`,
        error_26202:	`La solicitud falló (código de error: 26202). Por favor inténtalo de nuevo`,
        error_26001:	`Error: 26001. Por favor contáctenos`,
        error_26002:	`Error: 26002. Por favor contáctenos`,
        error_26003:	`Error: 26003. Por favor contáctenos`,
        error_26004:	`Error: 26004. Por favor contáctenos`,
        error_26005:	`La solicitud falló (código de error: 26005). Por favor inténtalo de nuevo`,
        error_26006:	`Código de error: 26006, vuelva a intentarlo`,
        error_26008:	`Error: 26008. Por favor contáctenos`,
        go_to_the_home_page:	`Ir a la página de inicio`,
    }
};